<template>
  <div class="orcamentos">
    <nav-menu/>

    <div class="w3-main w3-animate-left" style="margin-top:43px;">
      <header class="w3-container" style="padding-top:22px">
        <h5 class="w3-left  w3-col s12 m7 w3-margin-left"><b><i class="fa fa-shopping-cart"></i>  Orçamentos</b></h5>
        <div class=" w3-right w3-col s12 m12 l4" style="text-align: right" v-show="!proc_carregando_orcamento && !carregando_dados_iniciais">
          <button class="w3-button w3-theme w3-col s12"  @click="mostrarModalPesquisaOrcamentos()" :disabled="processando"><i class="fa fa-search"></i> Pesquisar orçamentos</button>
        </div>
      </header>

      <exibir-processando v-if="proc_carregando_orcamento || processando || reprocessando_prod"/>
      
      <div id="principal">
        
        <div v-show="!proc_carregando_orcamento && !carregando_dados_iniciais" v-cloak>
          <div v-show="parseFloat(orcamento_id) > 0" class="w3-col s12 m12 l12 w3-padding" v-cloak>
            <div class="w3-hide-small w3-hide-medium">
              <strong>Código</strong>
              <input type="text" style="width:25%" class="w3-input w3-border label-clicavel" v-model="orcamento_id" readOnly>
            </div>
            <div class="w3-hide-large">
              <strong>Código</strong>
              <input type="text" class="w3-input w3-border label-clicavel" v-model="orcamento_id" readOnly>
            </div>
          </div>

          <div class="w3-col s12 m12 l6 w3-padding w3-block">
            <frame-vendedor
              ref="frVendedor"
              :somenteLeitura="bloquear_trocar_vendedor"
              @blur.native="adicionarVendedor"
              @confirmar="adicionarVendedor"
              @limparDados="limparVendedor"
            />
          </div>

          <div class="w3-col s12 m12 l6 w3-padding" :class="{ 'bloco-consumidor-final' : cliente_consumidor_final }">
            <frame-cliente 
              ref="frCliente"
              :class="{ 'w3-col s10 m10 l10' : cliente_consumidor_final }" 
              :permitido_trocar_cliente="permitido_trocar_cliente" 
              :carregando_pedido="carregando_pedido"
              :buscar_financeiros_aberto="true"
              @cliente_selecionado="adicionarCliente" 
              @limpar_cliente="limparCliente"
              :verificarDados="verificarDadosCliente"
              @blur.native="adicionarCliente"
            />
            
            <button 
              class="w3-button w3-col s2 m2 l1 botao-consumidor-final w3-theme" 
              v-if="cliente_consumidor_final" 
              v-on:click="mostrarModalClienteConsumidorFinal()">
              <i class="fas fa-pen"></i>
	          </button>
          </div>        
          <div class="w3-col s12 m12 l6 w3-padding w3-block">
            <frame-condicao-pagamento 
              ref="frCondicaoPagamento"
              somenteEmpresasLiberadas="S"
              liberadaClienteSimplificado="N"
              somenteLeitura="N"
              :verificarDados="verificarDadosCondicaoPagamento"
              @limparDados="limparCondicaoPagamento"
              @confirmar="adicionarCondicaoPagamento" 
              @blur.native="adicionarCondicaoPagamento"
            />
          </div>  

          <pesquisa-produtos-venda 
            ref="frProdutosVenda"
            :somentePesquisar="'N'"
            :tipoFrete="tipo_frete"
            :valorFrete="valor_frete"
            :tipoEntrega="tipo_entrega"
            :totalFrete="valorTotalFretes"
            :outrasDespesas="outras_despesas"
            :adicionarProduto="adicionarProduto"
            :clienteSelecionado="cliente_selecionado"
            :produtosSelecionados="produtos_selecionados"
            :totalProdutos="valor(valor_total_produtos)"
            :condicaoSelecionada="condicao_pagamento_selecionada"
            :enderecoClienteSelecionado="endereco_cliente_selecionado"
            :parEmpQuestionarUsoPromocao="par_emp_questionar_uso_promocao"
            :percentualDescontoMaximoF5="valor(desconto_autorizado_vendedor)"
            :parEmpGerarBloqDescF5AcimaAut="par_emp_gerar_bloq_desc_f5_acima_aut"
            :parGerQtdMinCaractPesqProdutos="par_ger_qtd_min_caract_pesq_produtos"
            :parEmpQuestionarUsoPrecoAtacadoVda="par_emp_questionar_uso_preco_atacado_vda"
          />

          <div class="w3-col s12 m12 l6 w3-padding">
            <div class="w3-col s12 l12 m12">
              <strong class="w3-col w3-padding-small">Tipo de entrega</strong>
            </div> 
            <div class="w3-col s6 m3 w3-margin-bottom">
              <button class="botao-tipo-entrega" 
                :class="classe_botao_tipo_entrega_ato" 
                @click="tipo_entrega = 'ATO'">
                <i v-if="tipo_entrega === 'ATO'" class="fa fa-user-clock"></i> No ato
              </button>
            </div>
            <div class="w3-col s6 m3 w3-margin-bottom">
              <button 
                class="botao-tipo-entrega" 
                :class="classe_botao_tipo_entrega_ent" 
                @click="tipo_entrega = 'EPG'">
                <i v-if="tipo_entrega === 'EPG'" class="fa fa-shipping-fast"></i> Entregar
              </button>
            </div>
            <div class="w3-col s6 m3 w3-margin-bottom">
              <button 
                class="botao-tipo-entrega" 
                :class="classe_botao_tipo_entrega_sem" 
                @click="tipo_entrega = 'ESA'">
                <i v-if="tipo_entrega === 'ESA'" class="fa fa-hourglass-half"></i>
                <span class="w3-hide-large w3-hide-medium">Sem agend.</span>
                <span class="w3-hide-small">Sem agendamento</span>
              </button>
            </div>
            <div class="w3-col s6 m3 w3-margin-bottom">
              <button 
                class="botao-tipo-entrega" 
                :class="classe_botao_tipo_entrega_rlr" 
                @click="tipo_entrega = 'RLR'">
                <i v-if="tipo_entrega === 'RLR'" class="fa fa-store"></i> Retirar lojas rede
              </button>
            </div>
          </div>

          <div class="w3-animate-left w3-col s12 m6 w3-padding" v-if="tipo_entrega === 'EPG'" v-cloak>
            <div class="w3-col s12">
              <strong>Tipo de agendamento</strong>
              <select class="w3-select w3-border" v-model="tipo_agendamento_entrega" @change="buscarDataMinimaEntrega()">
                <option v-for="tipo in tiposAgendamentoArray" :key="tipo.descricao" :value="tipo.valor">{{tipo.descricao}}</option>
              </select>
            </div>
          </div>
          <div class="w3-animate-left w3-col s12 m3 w3-padding" v-if="tipo_entrega === 'EPG' && tipo_agendamento_entrega != 'E'" v-cloak>
            <div class="w3-col s12">
              <strong>Data mínima de entrega</strong>
              <input type="date" class="w3-input w3-border" v-model="data_minima_entrega" :disabled="tipo_agendamento_entrega != 'P'" @change="buscarDataMinimaEntrega()">
            </div>
          </div>
          <div class="w3-animate-left w3-col s12 m3 w3-padding" v-if="tipo_entrega === 'EPG'" v-cloak>
            <div class="w3-col s12">
              <strong>Data de entrega</strong>
              <input type="date" class="w3-input w3-border" v-model="data_entrega" :disabled="tipo_agendamento_entrega != 'E'" @change="gravarDataHoraEntrega()">
            </div>
          </div>
          <div class="w3-animate-left w3-col s12 m3 w3-padding" v-if="tipo_entrega === 'EPG' && tipo_agendamento_entrega != 'R'" v-cloak>
            <div class="w3-col s6" v-if="par_emp_tipo_agendamento_horario_ent === 'H'">
              <strong>Hora de entrega</strong>
              <input type="time" class="w3-input w3-border" v-model="hora_entrega" :disabled="tipo_agendamento_entrega != 'E'" @change="gravarDataHoraEntrega()">
            </div>
            <div class="w3-col s6" v-else>
              <strong>Período de entrega</strong>
              <select class="w3-select w3-border" v-model="hora_entrega" :disabled="tipo_agendamento_entrega != 'E'" @change="gravarDataHoraEntrega()">
                <option value="08:00">AM</option>
                <option value="14:00">PM</option>
                <option value="">--</option>
              </select>
            </div>
          </div>  
        </div>
        <div v-show="!proc_carregando_orcamento && !carregando_dados_iniciais">
          <div class="w3-padding">
            <div class="w3-bar w3-white w3-border">
              <div class="w3-col s4">
                <button 
                  id="tab_principais"
                  style="width: 100%; cursor:pointer"
                  class="w3-bar-item w3-transparent tablink botao-quadrado tab-active active" 
                  v-on:click="trocarAba('tab_principais', 'principais')">Produtos
                </button>
              </div>
              <div class="w3-col s4">
                <button 
                  id="tab_enderecos"
                  style="width: 100%; cursor:pointer"
                  class="w3-bar-item w3-transparent tablink botao-quadrado tab-active" 
                  v-on:click="trocarAba('tab_enderecos', 'enderecos')">Endereços
                </button>
              </div>
              <div class="w3-col s4">
                <button 
                  id="tab_fretes"
                  style="width: 100%; cursor:pointer"
                  class="w3-bar-item w3-transparent tablink botao-quadrado tab-active" 
                  v-on:click="trocarAba('tab_fretes', 'fretes')">Fretes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!proc_carregando_orcamento && !carregando_dados_iniciais">
          <div id="tabPrincipais" v-if="abaSelecionada == 'principais'">
            <div class="w3-col s12 w3-center" style="display: flex; flex-wrap: wrap; align-items: center; justify-content: center;">
              <span>
                <input 
                  type="number"
                  ref="produto"
                  placeholder="Código"
                  v-model="ref_produto"
                  onClick="this.select()"
                  id="pesquisa_produto_codigo"
                  @keyup.enter="handleRef('adicionar_produto')"
                  class="w3-round-large input-rapido-produtos w3-input w3-border label-clicavel" 
                />
              </span>
              <span class="w3-margin">
                <button 
                  class="w3-button w3-theme " 
                  @click="mostrarModalProdutos()">
                  <i class="fa fa-shopping-basket"></i> Pesquisar produto
                </button>
                <button 
                  class="w3-button w3-theme" 
                  @click="mostrarModalCodigoBarras()">
                  <i class="fa fa-camera"></i>
                </button>
              </span>
            </div>
            <div class="w3-panel w3-animate-left w3-col s12" v-show="produtos_selecionados.length == 0 && !reprocessando_prod">
              <div class="w3-text-theme w3-bottombar w3-border-theme w3-border  w3-padding-small w3-white">
                <p>Não há produto(s) selecionado(s).</p>
              </div>
            </div>
            <div class="w3-col s12 w3-container" v-show="produtos_selecionados.length > 0 && !reprocessando_prod" v-cloak>
              <div class="w3-hide-small w3-hide-medium w3-responsive w3-margin-top" v-cloak>
                <table class="w3-table-all">
                  <thead>
                    <tr>
                      <th></th>
                      <th style="min-width: 200px">Produto</th>
                      <th>Marca</th>
                      <th class="alinhamento-numero" style="width:10%;">Quantidade</th>
                      <th>Und</th>
                      <th class="alinhamento-numero">Preço unit. com impostos</th>
                      <th class="alinhamento-numero">Total com impostos</th>
                      <th class="alinhamento-numero">Estoque ato</th>
                      <th class="alinhamento-numero">Estoque agendamento</th>
                      <th class="alinhamento-numero">Total do ST</th>
                      <th class="alinhamento-numero">Total FCP ST</th>
                      <th class="alinhamento-numero">Total do IPI</th>
                      <th class="alinhamento-numero">Total do item</th>
                      <th class="alinhamento-numero">Preço unit.</th>
                      <th class="alinhamento-numero">Peso unit.</th>
                      <th class="alinhamento-texto">Cód. original</th>                      
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="produto in produtos_selecionados" 
                      :key=produto.produto_id
                      :style="getCorGrupoPromocao(produto)"
                      :class="getClasseLegendaProduto(produto.estoque_ato, produto.quantidade)"                       
                      style="cursor: pointer;">
                      <td>
                        <i style="color: #8d3cb3" class="fa fa-circle" v-if="produto.usou_promocao_especial == 'S'"></i>
                        <i style="color: #3cb371" class="fa fa-circle" v-if="produto.usou_promocao == 'S' && produto.usou_promocao_especial == 'N'"></i>
                        <i style="color: #ffa500" class="fa fa-circle" v-if="produto.kit == 'S'"></i>
                        <i style="color: #0300FE" class="fa fa-circle" v-if="produto.ponta_estoque"></i>
                      </td>
                      <td>{{formatarValor(produto.produto_id, 0)}} - {{produto.nome}}</td>
                      <td>{{produto.marca}}</td>
                      <td class="alinhamento-numero link" @click="alterarQuantidadeProduto(produto)"><strong>{{formatarValor(produto.quantidade)}}</strong></td>
                      <td>{{produto.unidade}}</td>                    
                      <td class="alinhamento-numero" >{{formatarValor(produto.preco_unitario_com_imposto, 4) | npz}}</td>  
                      <td class="alinhamento-numero" >{{formatarValor(produto.preco_unitario_com_imposto * produto.quantidade, 2) | npz}}</td>
                      <td class="alinhamento-numero">{{produto.estoque_ato}}</td>
                      <td class="alinhamento-numero">{{produto.estoque_agendamento}}</td>
                      <td class="alinhamento-numero" >{{formatarValor(produto.valor_total_st, 2) | npz}}</td>
                      <td class="alinhamento-numero" >{{formatarValor(produto.valor_total_fcp_st, 2) | npz}}</td>
                      <td class="alinhamento-numero" >{{formatarValor(produto.valor_total_ipi, 2) | npz}}</td>
                      <td class="alinhamento-numero">{{formatarValor(produto.total_item, 2)}}</td>
                      <td class="alinhamento-numero">{{formatarValor(produto.preco, 2)}}</td>
                      <td class="alinhamento-numero">{{produto.peso}}</td>
                      <td class="alinhamento-texto">{{produto.codigo_original}}</td>                      
                      <td>
                        <button class="w3-button w3-text-theme w3-border w3-tiny" v-on:click="mostrarModalOpcoesProduto(produto)"><i class="fa fa-edit"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>              
              
              <div class="w3-hide-large" v-cloak v-show="produtos_selecionados.length">
                <h4 class="w3-center w3-wide label_total_pedido" style="color: #8d1007; font-weight: 600;">Itens</h4>
                <div 
                  class="w3-panel w3-card card-produto w3-container" 
                  style="padding-left: 3px; padding-bottom: 0px;" 
                  :style="getCorGrupoPromocao(produto)"
                  v-for="(produto, index) in produtos_selecionados" :key="produto.produto_id"
                  @click="mostrarDetalhesProduto(index)" :class="{'active' : produto.mostrar_detalhes}">

                  <div class="w3-col" style="font-size: 13px">                    
                    <i style="color: #8d3cb3" class="fa fa-circle" v-if="produto.usou_promocao_especial == 'S'"></i>
                    <i style="color: #3cb371" class="fa fa-circle" v-if="produto.usou_promocao == 'S' && produto.usou_promocao_especial == 'N'"></i>
                    <i style="color: #ffa500" class="fa fa-circle" v-if="produto.kit == 'S'"></i>
                    <i style="color: #0300FE" class="fa fa-circle" v-if="produto.ponta_estoque"></i>
                    <strong class="texto-vermelho">{{ formatarValor(produto.produto_id, 0) }} - <span style="letter-spacing: .5px">{{ produto.nome }}</span></strong>
                  </div>

                  <div class="w3-col s12" style="font-size: 13px">
                    <label>Unidade: </label>
                    <strong class="cor-fonte-car-itens">{{produto.unidade}}</strong>
                  </div>

                  <div class="w3-col s12 m4" style="font-size: 13px">
                    <label>Quantidade: </label>
                    <strong class="link" @click="alterarQuantidadeProduto(produto)">{{formatarValor(produto.quantidade)}}</strong>
                  </div>     

                  <div class="w3-col s12" style="font-size: 13px;">
                    <div class="w3-col s12" style="font-size: 13px">
                      <label>Preço unit. com impostos: </label>
                      <strong class="cor-fonte-car-itens">R$ {{formatarValor(produto.preco_unitario_com_imposto, 4) | npz}}</strong>                      
                    </div>  
                    
                    <div class="w3-col s12" style="font-size: 13px">
                      <label>Total com impostos: </label>
                      <strong style="color: #03bf00">R$ {{formatarValor(produto.preco_unitario_com_imposto * produto.quantidade, 2) | npz}}</strong>
                    </div>

                    <div class="w3-col s6" v-show="produto.mostrar_detalhes || (produto.preco != produto.preco_unitario_com_imposto)">
                      <label>Preço unit.: </label>
                      <strong class="cor-fonte-car-itens">R$ {{formatarValor(produto.preco, 2)}}</strong>
                    </div>

                    <div class="w3-col s6" v-show="produto.mostrar_detalhes || (produto.preco != produto.preco_unitario_com_imposto)">
                      <label>Total: </label>
                      <strong class="cor-fonte-car-itens">R$ {{formatarValor(produto.total_item, 2)}}</strong>
                    </div>

                    <div class="w3-col s12 w3-center" v-show="!produto.mostrar_detalhes">
                      <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"></i>  
                    </div>  
                  </div>

                  <div class="w3-col" v-show="produto.mostrar_detalhes" style="font-size: 13px; padding:0px;">

                    <div class="w3-col s12" style="font-size: 13px">
                      <label>Marca: </label>
                      <strong class="cor-fonte-car-itens">{{produto.marca}}</strong>
                    </div>       
                    <div class="w3-col s12">
                      <label>Total do ST: </label>
                      <strong class="cor-fonte-car-itens">R$ {{formatarValor(produto.valor_total_st, 2)}}</strong>
                    </div>    
                    <div class="w3-col s12">
                      <label>Total FCP ST: </label>
                      <strong class="cor-fonte-car-itens">R$ {{formatarValor(produto.valor_total_fcp_st, 2)}}</strong>
                    </div>
                    <div class="w3-col s12" style="font-size: 13px">
                      <label>Total do IPI: </label>
                      <strong class="cor-fonte-car-itens">R$ {{formatarValor(produto.valor_total_ipi, 2)}}</strong>
                    </div> 
                                                                                                
                    <div class="w3-col s12" style="font-size: 13px">
                      <label>Estoque ato: </label>
                      <strong class="cor-fonte-car-itens">{{produto.estoque_ato}}</strong>
                    </div> 
                    <div class="w3-col s12" style="font-size: 13px">
                      <label>Estoque agendamento: </label>
                      <strong class="cor-fonte-car-itens">{{produto.estoque_agendamento}}</strong>
                    </div>    
                    <div class="w3-col s12" v-if="produto.peso !== '0'" style="font-size: 13px">
                      <label>Peso unit.: </label>
                      <strong class="cor-fonte-car-itens">{{produto.peso}}</strong>
                    </div>     
                    <div class="w3-col s12" v-if="produto.codigo_original" style="font-size: 13px">
                      <label>Cód. original: </label>
                      <strong class="cor-fonte-car-itens">{{produto.codigo_original}}</strong>
                    </div>                     
                    <div class="w3-col s12 w3-center" style="font-size: 13px">
                      <button class="w3-button w3-theme w3-tiny" v-on:click="mostrarModalOpcoesProduto(produto)"><i class="fa fa-edit"></i></button>
                    </div>                  
                  </div>              
                </div>
              </div>
            </div>
        </div>      

        <div id="tabEnderecos" class="aba" v-if="abaSelecionada == 'enderecos'">
          <div class="w3-col s12 w3-center">
            <button class="w3-bar-item w3-button w3-theme w3-border " @click="mostrarModalSelecionarEnderecosCliente"><i class="fa fa-location-arrow"></i> Carregar</button>
            <button class="w3-bar-item w3-button w3-theme w3-border " id="btn_carregar_endereço" @click="limparEndereco()"><i class="fa fa-eraser"></i> Limpar</button>
          </div>
          <br>
          <div class="w3-row-padding">
            <div class="w3-col m6 s12 l4">
              <strong>CEP</strong>
              <input type="text" class="w3-input w3-border" v-model="endereco_cliente_selecionado.cep" readOnly>
            </div>
            <div class="w3-col m6 s12 l4">
              <strong>Logradouro</strong>
              <input type="text" class="w3-input w3-border" :value="endereco_cliente_selecionado.logradouro" readOnly>
            </div>
            <div class="w3-col m6 s12 l4">
              <strong>Complemento</strong>
              <input type="text" class="w3-input w3-border" :value="endereco_cliente_selecionado.complemento" readOnly>
            </div>
            <div class="w3-col m6 s12 l4">
              <strong>Ponto de referência</strong>
              <input type="text" class="w3-input w3-border" :value="endereco_cliente_selecionado.ponto_referencia" readOnly>
            </div>
            <div class="w3-col m6 s12 l4">
              <strong>Bairro</strong>
              <input type="text" class="w3-input w3-border" :value="endereco_cliente_selecionado.nome_bairro" readOnly>
            </div>
            <div class="w3-col m6 s12 l4">
              <strong>Tipo de imóvel</strong>
              <select class="w3-select w3-border" :value="endereco_cliente_selecionado.tipo_imovel" disabled>
                <option value="NIN">Não informado</option>
                <option value="APH">Apart Hotel</option>
                <option value="APA">Apartamento</option>
                <option value="CCO">Casa comercial</option>
                <option value="CAC">Casa em condomínio</option>
                <option value="CAS">Casa</option>
                <option value="FAZ">Fazenda/chácara/sítio</option>
                <option value="GAL">Galpão</option>
                <option value="GAR">Garagem</option>
                <option value="LOJ">Loja</option>
                <option value="LOT">Lote</option>
                <option value="PRE">Prédio</option>
                <option value="QUI">Quintinete</option>
                <option value="SAL">Sala comercial</option>
                <option value="SOB">Sobrado</option>
              </select>
            </div>
            <div class="w3-col m6 s12 l6">
              <strong>Tipo de acesso imóvel</strong>
              <select class="w3-select w3-border" :value="endereco_cliente_selecionado.tipo_acesso_imovel" disabled>
                <option value="T">Térreo</option>
                <option value="L">Elevador</option>
                <option value="E">Escada</option>
                <option value="N">Nenhum</option>
              </select>
            </div>
            <div class="w3-col m6 s12 l6">
              <strong>Andar</strong>
              <input type="text" class="w3-input w3-border" :value="endereco_cliente_selecionado.andar > 0 ? endereco_cliente_selecionado.andar : '' " readOnly>
            </div>
          </div>
          <div class="w3-row-padding">
            <div class="w3-col m12 s12">
              <strong>Observações</strong>
              <textarea class="w3-border texto-preto" v-model="observacoes_endereco" style="width:100%;" rows="5" @change="gravarObservacaoEndereco()"></textarea>
            </div>
          </div>
          <div class="w3-row-padding">
            <div v-if="((cliente_selecionado.tipo_cliente == 'U') || (cliente_selecionado.tipo_cliente == 'O')) && endereco_cliente_selecionado.inscricao_estadual" class="w3-col m12 s12 l4">
              <strong>Inscrição estadual</strong>
              <input type="text" class="w3-input w3-border" :value="endereco_cliente_selecionado.inscricao_estadual" readOnly>
            </div>  
          </div>            
        </div>
        <div id="tabFretes" class="aba" v-if="abaSelecionada == 'fretes'">
          <div class="w3-row-padding">
            <div class="w3-col s6 m6 l6">
              <strong class="w3-hide-large w3-hide-medium">Frete adic. por andar</strong>
              <strong class="w3-hide-small">Frete adicional por andar</strong>
              <input type="text" class="w3-input w3-border" :value="frete_adicional_andar" disabled>
            </div>
            <div class="w3-col s6 m6 l6">
              <strong>Tipo de frete por andar</strong>
              <select class="w3-select w3-border" v-model="tipo_frete_andar" :disabled="!permitir_edicao_tipo_frete_andar" @change="buscarFreteAdicionalPorAndar">
                <option value="EL">Elevador</option>
                <option value="ES">Escada</option>
              </select>
            </div>
          </div>
          <br>
          <div class="w3-row-padding" v-if="par_emp_tipo_entregas_venda != 'ZON' && par_emp_tipo_frete_manifesto == 'R'">
            <div class="w3-col m12">
              <strong>Rota</strong>
              <input type="text" class="w3-input w3-border" v-model="frete_rota.rota" disabled>
            </div>
            <div class="w3-col m6 s12">
              <strong>Valor do frete por Kg</strong>
              <input type="text" class="w3-input w3-border" :value="frete_rota.valor_frete_por_kg_venda" disabled>
            </div>
            <div class="w3-col m6 s12">
              <strong>Total do frete por Kg</strong>
              <input type="text" class="w3-input w3-border" :value="frete_rota.total_frete_rota_kg" disabled>
            </div>
            <div class="w3-col m6 s12">
              <strong>% do frete por valor dos produtos</strong>
              <input type="text" class="w3-input w3-border" :value="frete_rota.perc_frete_venda" disabled>
            </div>
            <div class="w3-col m6 s12">
              <strong>Total do frete por %</strong>
              <input type="text" class="w3-input w3-border" :value="frete_rota.valor_ref_perc_prod_frete_rota" disabled>
            </div>
            <div class="w3-col m12 s12">
              <strong>Valor mínimo do frete para esta rota</strong>
              <input type="text" class="w3-input w3-border" :value="frete_rota.valor_minimo_frete_venda" disabled>
            </div>

            <div class="w3-col m12 s12">
              <strong>Valor do frete de rota a ser cobrado</strong>
              <input type="text" class="w3-input w3-border" :value="frete_rota.valor_frete_rota_cobrado" disabled>
            </div>
            <div class="w3-col m12 s12">
              <strong>Total do frete terceirizado</strong>
              <input type="text" class="w3-input w3-border" :value="frete_rota.total_frete_terceirizado" disabled>
            </div>
          </div>
          <div class="w3-row-padding" v-if="par_emp_tipo_entregas_venda != 'ZON' && par_emp_tipo_frete_manifesto != 'R'">
            <div class="w3-hide-small w3-hide-medium">
              <table class="w3-table-all" v-if="frete_tipos_veiculos.length > 0">
                <thead>
                  <tr>
                    <th class="alinhamento-numero">Tipo de veículo</th>
                    <th>Nome</th>
                    <th class="alinhamento-numero">Peso máximo</th>
                    <th class="alinhamento-numero">Valor do frete</th>
                    <th class="alinhamento-numero">Quantidade de viagens</th>
                    <th class="alinhamento-numero">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="label-clicavel" v-for="tipo_veiculo in frete_tipos_veiculos" v-show="parseFloat(tipo_veiculo.valor_frete) > 0">
                    <td class="alinhamento-numero">{{tipo_veiculo.tipo_veiculo_id}}</td>
                    <td>{{tipo_veiculo.nome}}</td>
                    <td class="alinhamento-numero">{{tipo_veiculo.peso_maximo}} Kg</td>
                    <td class="alinhamento-numero">R$ {{tipo_veiculo.valor_frete}}</td>
                    <td style="min-width: 200px">
                      <input 
                        type="number" 
                        step="1" 
                        class="w3-input w3-border" 
                        v-model="tipo_veiculo.viagens" 
                        v-on:keyup="calcularFreteTiposVeiculos()"
                      />
                    </td>
                    <td class="alinhamento-numero" style="min-width: 200px">R$ {{formatarValor(tipo_veiculo.valor_total)}}</td>
                  </tr>
                </tbody>
              </table>   
            </div>

            <div class="w3-container w3-hide-large">
              <div class="w3-responsive w3-col">
                <div 
                  class="label-clicavel card-tipo-veiculo w3-border"
                  style="margin-bottom: 8px; margin-right: 5px;" 
                  v-for="tipo_veiculo in frete_tipos_veiculos" 
                  v-show="parseFloat(tipo_veiculo.valor_frete) > 0"
                  :key="tipo_veiculo.tipo_veiculo_id">

                  <div>Tipo de veículo: <strong>{{tipo_veiculo.tipo_veiculo_id}}</strong></div>
                  <div>Nome: <strong>{{tipo_veiculo.nome}}</strong></div>
                  <div>Peso máximo: <strong>{{tipo_veiculo.peso_maximo}} Kg</strong></div>
                  <div>Total: <strong>R${{formatarValor(tipo_veiculo.valor_frete, 2)}}</strong></div>
                  
                  <div 
                    style="min-width: 200px">
                    Quantidade de viagens: 
                    <input 
                      type="number" 
                      step="1" 
                      class="w3-input w3-border" 
                      v-model="tipo_veiculo.viagens" v-on:keyup="calcularFreteTiposVeiculos()"
                    />
                  </div>
                  
                  <div 
                    class="alinhamento-numero" 
                    style="min-width: 200px; color: #199436; margin-top: 3px;"> 
                    <strong> R$ {{formatarValor(tipo_veiculo.valor_total, 2)}} </strong>
                  </div>

                </div>
              </div>
            </div>
            
            <div class="w3-container w3-white" v-cloak>
              <div class="w3-col m2">
                <label class="w3-left"><strong>Total do frete terceirizado: </strong>{{formatarValor(valorTotalFretesTerceirizados)}}</label>
              </div>
              <div class="w3-col m2">
                <label class="w3-left"><strong>Total do peso máximo: </strong>{{formatarValor(totalPesoMaximo)}}</label>
              </div>
              <div class="w3-col m2">
                <label class="w3-left"><strong>Total de peso do pedido: </strong>{{formatarValor(peso_total_produtos)}}</label>
              </div>
            </div>
          </div>
        </div>
        
        <div v-show="!proc_carregando_orcamento && !carregando_dados_iniciais && !reprocessando_prod" class="w3-container w3-center valores_orcamento hidden" id="valores_orcamento" v-cloak>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Peso total: </strong>{{formatarValor(peso_total_produtos)}}</label>
          </div>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Total IPI: </strong>{{formatarValor(valor_total_ipi, 2)}}</label>
          </div>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Total ST: </strong>{{formatarValor(valor_total_st, 2)}}</label>
          </div>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Total FCP ST: </strong>{{formatarValor(valor_total_fcp_st, 2)}}</label>
          </div>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Valor TC: </strong>{{formatarValor(valor_tac, 2)}}</label>
          </div>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Total frete: </strong>{{formatarValor(valorTotalFretes, 2)}}</label>
          </div>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Outras despesas: </strong>{{formatarValor(outras_despesas, 2)}}</label>
          </div>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Total descontos: </strong>{{formatarValor(valor_desconto, 2)}}</label>
          </div>
          <div class="w3-col m2">
            <label class="w3-left"><strong>Total produtos: </strong>{{formatarValor(valor_total_produtos, 2)}}</label>
          </div>
        </div>

        <div class="w3-container w3-center w3-margin-top" v-show="!proc_carregando_orcamento && !carregando_dados_iniciais && !reprocessando_prod"> 
          <div class="w3-container we-center w3-col s12 m6 l4 w3-left">
            <div @click="mostrarValoresOrcamento()">
              <h4 style="cursor: pointer;color: #004F18" class="w3-center w3-wide label_total_pedido"><strong>
                <span v-if="mostrarValoresTotais"> - </span>
                <span v-if="!mostrarValoresTotais"> + </span>
                Total pedido: </strong>{{formatarValor(total_liquido, 2)}}</h4>
            </div>
          </div>

          <button 
            class="w3-button w3-theme w3-col s12 m6 l4 w3-right fechar-pedido" 
            v-on:click="mostrarModalFecharPedido()">
            <i class="fa fa-shopping-cart"></i> Fechar pedido
          </button>
        
          <div v-if="!visualizar_opcoes_orcamento" class="w3-center w3-col s12 m12 l4" v-cloak>
            <button 
              class="btn-mix button-link" 
              style="margin:10px;"
              @click="visualizar_opcoes_orcamento=true" 
              v-show="!visualizar_opcoes_orcamento"> 
              <i class="fa fa-search-plus"></i> Visualizar todas as opções
            </button>
          </div>
          <div v-else v-cloak>
            <br>
            <div class="w3-row-padding">
              <div class="w3-col l2 m6 s12">  
                <button 
                  id="btn_gravar_orcamento"
                  class="w3-bar-item w3-button w3-white w3-border w3-mobile" 
                  style="margin: 5px" @click="mostrarModalFechamentoOrcamento()">
                  <i class="fas fa-database icone-vermelho" ></i> Gravar orçamento
                </button>
              </div>
              <div class="w3-col l2 m6 s12">
                <button
                  style="margin: 5px;" 
                  @click="imprimirPropostaOrcamento('N', orcamento_id)"
                  class="w3-bar-item w3-button w3-white w3-border w3-mobile" 
                  v-show="this.par_emp_gerar_bloq_proposta_orcamento == 'S'">
                  <i class="fa fa-print icone-vermelho"></i> Imprimir proposta
                </button>
              </div>  
              <div class="w3-col l2 m6 s12">
                <button 
                  class="w3-bar-item w3-button w3-white w3-border w3-mobile" 
                  style="margin: 5px" @click="mostrarModalFrete()">
                  <i class="fa fa-truck icone-vermelho"></i> Frete e despesas
                </button>
              </div>            
              <div class="w3-col l2 m6 s12">
                <button 
                  class="w3-bar-item w3-button w3-white w3-border w3-mobile" 
                  style="margin: 5px" @click="mostrarModalDescontoPorProduto()">
                  <i class="fa fa-percent icone-vermelho"></i> Desconto por item
                </button>  
              </div>
              <div class="w3-col l2 m6 s12">
                <button 
                  class="w3-bar-item w3-button w3-white w3-border w3-mobile" 
                  style="margin: 5px" @click="mostrarModalCopiarPedido()">
                  <i class="fa fa-copy icone-vermelho"></i> Copiar pedido
                </button>  
              </div>
              <div class="w3-col l2 m6 s12">
                <button 
                  class="w3-bar-item w3-button w3-white w3-border w3-mobile" 
                  style="margin: 5px;" @click="buscarMix()">
                  <i class="fa fa-chart-pie icone-vermelho"></i> Mix
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Inicio modal de Endereços  -->  
        <div id="modalSelecionarEnderecosCliente" 
          class="w3-modal" 
          v-if="abrirModalSelecionarEnderecosCliente"
          style="display: block">
          <div class="w3-modal-content w3-animate-zoom">

            <header class="w3-container">
              <span @click="abrirModalSelecionarEnderecosCliente = false" class="w3-button w3-display-topright">&times;</span>
            </header>

            <div class="w3-col s12 w3-left w3-margin-bottom titulo texto-vermelho">
              <label style="font-size:20px;">
                Lista de endereços do cliente
              </label>
            </div>

            <div class="w3-col l6 m12 w3-padding-left">
              <legenda>
                <span>Nome Do cliente</span>
                  <i slot="referencia" class="fa fa-user-tag texto-vermelho"></i>
              </legenda>
              <strong data-label="resultado-venda" id="eResultado">{{cliente_selecionado.nome_razao_social}}</strong>
            </div>
                      
            <div class="w3-row-padding w3-margin-bottom">
              <div class="w3-margin-top">
                <div class="w3-show card-endereco w3-border w3-container" v-for="endereco in enderecos_cliente" @click="adicionarEndereco(endereco)">                
                  <div class="w3-col s12">
                    <label>Endereço: </label>
                    <div style="font-weight: bold!important;">
                    <label>{{endereco.logradouro}}</label>
                      <label>, {{endereco.complemento}}</label>
                      <label>, {{endereco.nome_bairro}}, {{endereco.nome_cidade}}, {{endereco.estado_id}}</label>
                      <label v-if="endereco.ponto_referencia">, {{endereco.ponto_referencia}}</label>    
                      <label v-if="endereco.tipo_imovel == 'APH'">, Apart Hotel</label>
                      <label v-if="endereco.tipo_imovel == 'APA'">, Apartamento</label>
                      <label v-if="endereco.tipo_imovel == 'CCO'">, Casa comercial</label>
                      <label v-if="endereco.tipo_imovel == 'CAC'">, Casa em condomínio</label>
                      <label v-if="endereco.tipo_imovel == 'CAS'">, Casa</label>
                      <label v-if="endereco.tipo_imovel == 'FAZ'">, Fazenda/chácara/sítio</label>
                      <label v-if="endereco.tipo_imovel == 'GAL'">, Galpão</label>
                      <label v-if="endereco.tipo_imovel == 'GAR'">, Garagem</label>
                      <label v-if="endereco.tipo_imovel == 'LOJ'">, Loja</label>
                      <label v-if="endereco.tipo_imovel == 'LOT'">, Lote</label>
                      <label v-if="endereco.tipo_imovel == 'PRE'">, Prédio</label>
                      <label v-if="endereco.tipo_imovel == 'QUI'">, Quintinete</label>
                      <label v-if="endereco.tipo_imovel == 'SAL'">, Sala comercial</label>
                      <label v-if="endereco.tipo_imovel == 'SOB'">, Sobrado</label>
                      <label v-if="endereco.tipo_acesso_imovel == 'T'">, Térreo</label>
                      <label v-if="endereco.tipo_acesso_imovel == 'L'">, Elevador</label>
                      <label v-if="endereco.tipo_acesso_imovel == 'E'">, Escada</label>
                      <label v-if="endereco.andar > 0">, Andar: {{endereco.andar}}</label>
                      </div>
                    <div class="w3-col">
                      <label v-if="endereco.inscricao_estadual != 'ISENTO' && endereco.inscricao_estadual">Inscrição estadual: <strong>{{endereco.inscricao_estadual}}</strong></label>
                    </div>
                    
                  </div>                                                                                                         
                </div> 
              </div>
            </div>
          </div>
        </div>
        <!-- Fim modal de Endereços  -->

        <!-- Inicio modal de Opões de produto  -->  
        <div id="modalOpcoesProduto" class="w3-modal" v-if="abrirModalOpcoesProduto" @click="abrirModalOpcoesProduto = false"  style="display: block">
          <div class="w3-modal-content w3-animate-zoom" style="max-width: 400px">
            <header class="w3-container">
              <span @click="abrirModalOpcoesProduto = false" class="w3-button w3-display-topright">&times;</span>
              <h5 class="titulo texto-vermelho">Opções do produto</h5>
              <h5 class="texto-cinza w3-center">{{formatarValor(produto_selecionado_editando.produto_id, 0)}} - {{produto_selecionado_editando.nome}}</h5>
            </header>
            <div class="w3-row-padding">              
              <button 
                v-if="
                (
                  (  
                    (produto_selecionado_editando.tipo_controle_estoque === 'P') || 
                    (produto_selecionado_editando.tipo_controle_estoque === 'L') || 
                    (produto_selecionado_editando.tipo_controle_estoque === 'G')
                  ) &&
                  (tipo_entrega == 'ATO' || tipo_entrega == 'EPG')
                )"  
                class="w3-button w3-block w3-white w3-theme" 
                @click="definirLoteProdutoSelecionado()">
                Definir lote
              </button>
              <button class="w3-button w3-border w3-block w3-white w3-text-theme" @click="removerProdutoOrcamento(produto_selecionado_editando.produto_id)">Remover produto</button>
              <button class="w3-button w3-border w3-block w3-white w3-text-theme" @click="exibirAssistenciasTecnicas(produto_selecionado_editando)">Assistência técnica</button>
              <button class="w3-button w3-border w3-block w3-white w3-text-theme" @click="exibirEstoqueRedeProduto(produto_selecionado_editando)">Verificar estoque da rede</button>
              <button class="w3-button w3-border w3-block w3-white w3-text-theme" @click="exibirCaracteristicasProduto(produto_selecionado_editando)">Características do produto</button>
              <button class="w3-button w3-border w3-block w3-white w3-text-theme" @click="exibirDadosProdutosVendidos(produto_selecionado_editando)">Dados de produtos vendidos</button>
            </div>
            <br>
          </div>
        </div>
        <!-- Fim modal de Opões de produto -->

        <pesquisa-orcamentos 
          ref="frPesquisaOrcamentos"
          :carregarOrcamentoEdicao="carregarOrcamentoEdicao"
        />
        
        <modal-caracteristicas-produto 
          ref="mdCaracteristicasProduto"
        />
        
        <modal-estoque-rede-produto 
          ref="mdEstoqueRedeProduto"
        /> 
        
        <modal-assistencia-tecnica 
          ref="mdAssistenciaTecnica"
        />

        <dados-produtos-vendidos 
          ref="dadosProdutosVendidos"
        />
        
        <coletar-dados-consumidor-final 
          ref="coletarDadosConsumidorFinal"
          :utilizaControleCep="par_ger_utiliza_controle_cep"
          @carregarDadosClienteExistente="carregarDadosClienteExistente" 
          @carregarDadosConsumidorFinal="carregarDadosConsumidorFinal"
        />

        <!-- Inicio modal de alterar quantidade do produto -->
        <div id="modalAtualizarQuantidade" class="w3-modal" v-if="abrirModalAtualizarQuantidade" @click="abrirModalAtualizarQuantidade = false" style="display: block">
          <div class="w3-modal-content w3-animate-zoom" style="max-width: 340px" @click.stop>
            <header class="w3-container">
              <span @click="abrirModalAtualizarQuantidade = false" class="w3-button w3-display-topright">&times;</span>              
              <h4 class="titulo texto-vermelho">Alteração de quantidade</h4>
              <h5 class="texto-cinza w3-left" >{{formatarValor(produto_selecionado.produto_id, 0)}} - {{produto_selecionado.nome}}</h5>
            </header>
            <div class="w3-row-padding">
              <div class="w3-responsive">
                <div class="w3-col s12 w3-margem-top">
                  <label>Quantidade</label>
                  <input 
                    class="w3-input w3-border" 
                    id="quantidade_produto" 
                    ref="quantidade_produto" 
                    type="number" 
                    onClick="this.select();"
                    onFocus="this.select();"
                    v-on:keyup.enter="inserirAtualizarQuantidadeProduto(true)"
                    v-model="quantidade_produto_selecionado"><br>
                </div>
                <div class="w3-col s12 w3-center">
                  <button 
                    class="w3-button w3-theme" 
                    v-on:click="inserirAtualizarQuantidadeProduto(true)"> 
                    <i class="fas fa-check-circle"></i> Aplicar
                  </button>
                </div>
              </div>
            </div>
            <br>
          </div>
        </div>
        <!-- Fim do modal de alterar quantidade do produto -->

        <!-- Inicio modal oções de desconto -->
        <div id="modalOpcoesDesconto" class="w3-modal" v-if="abrirModalOpcoesDesconto" @click="abrirModalOpcoesDesconto = false" style="display: block">
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <h5 class="titulo texto-vermelho">Opções de negociação</h5>
            </header>
            <div class="w3-row-padding">
              <div class="w3-responsive">

                <div class="w3-padding-small" @click="opcao_tipo_negociacao_preco = 'MANTER_VALOR'">
                  <span>
                    <i class="far fa-circle" v-if="opcao_tipo_negociacao_preco != 'MANTER_VALOR'"></i>
                    <i class="far fas fa-check-circle" style="color: #199436;" v-if="opcao_tipo_negociacao_preco == 'MANTER_VALOR'"></i>
                    &nbsp;Manter os preços da negociação
                  </span>
                </div>

                <div class="w3-padding-small" @click="opcao_tipo_negociacao_preco = 'REFAZER_PRECO'">
                   <span>
                    <i class="far fa-circle" v-if="opcao_tipo_negociacao_preco != 'REFAZER_PRECO'"></i>
                    <i class="far fas fa-check-circle" style="color: #199436;" v-if="opcao_tipo_negociacao_preco == 'REFAZER_PRECO'"></i>
                    &nbsp;Refazer os preços de acordo com a condição
                  </span>
                </div>

                <div class="w3-padding-small" @click="opcao_tipo_negociacao_preco = 'MANTER_PERCENTUAL'">
                  <span>
                    <i class="far fa-circle" v-if="opcao_tipo_negociacao_preco != 'MANTER_PERCENTUAL'"></i>
                    <i class="far fas fa-check-circle" style="color: #199436;" v-if="opcao_tipo_negociacao_preco == 'MANTER_PERCENTUAL'"></i>
                    &nbsp;Manter os percentuais de desconto
                  </span>
                </div>

              </div>
              <div class="w3-center w3-col s12" style="margin-top: 5px; margin-bottom:5px">
                <button 
                  class="w3-button w3-theme" 
                  v-on:click="confirmarTipoNegociacaoPreco()"> 
                  <i class="fas fa-check-circle"></i> Ok
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Fim do modal oções de desconto -->

        <!-- Inicio modal de definir lote de produto  -->
        <div id="modalDefinirLoteProduto" class="w3-modal" v-if="abrirModalDefinirLoteProduto" @click="abrirModalDefinirLoteProduto = false"  style="display: block">
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span @click="abrirModalDefinirLoteProduto = false" class="w3-button w3-display-topright">&times;</span>
              <h2 class="texto-vermelho w3-center">{{formatarValor(produto_selecionado_editando.produto_id, 0)}} - {{produto_selecionado_editando.nome}}</h2>
            </header>

            <div class="w3-container">
              <div style="max-height: calc(75vh - 100px); min-height: 200px; overflow: auto">
                <div v-show="divisoes_lotes_produto_selecionado.length > 0" v-for="divisao in divisoes_lotes_produto_selecionado">
                  <div class="w3-panel w3-card card-produto w3-col s12 m12 l12" style="cursor: pointer">
                    <div class="w3-col s12 m12 l12">
                      <label class="w3-margin-right">Empresa: <strong>{{divisao.nome_empresa}}</strong></label>
                    </div>

                    <div class="w3-col s12 m12 l12">
                      <label class="w3-margin-right">Local: <strong>{{divisao.local_id}} - {{divisao.nome_local}}</strong></label>
                    </div>

                    <div class="w3-col s12 m12 l12">
                      <label class="w3-margin-right">Lote: <strong>{{divisao.lote}}</strong></label>
                    </div>

                    <div class="w3-col s12 m12 l12">
                      <label class="w3-margin-right">Estoque disponível: <strong>{{divisao.estoque_disponivel}}</strong></label>
                    </div>

                    <div class="w3-col s12 m12 l12">
                      <label class="w3-margin-right">Múlt. venda ponta estoque: <strong>{{divisao.multiplo_venda_ponta}}</strong></label>
                    </div>

                    <div class="w3-col s12 m12 l12" v-if="divisao.vencimento">
                      <label class="w3-margin-right">Vencimento: <strong>{{divisao.vencimento}}</strong></label>
                    </div>

                    <div class="w3-col s12 m12 l12" v-if="divisao.fabricacao">
                      <label class="w3-margin-right">Fabricação: <strong>{{divisao.fabricacao}}</strong></label>
                    </div>
                    
                    <div class="w3-col s12 m12 l12" v-if="tipo_entrega == 'ATO'">
                      <label class="w3-margin-right">Qtd. utilizar entrega ato:</label>
                      <vue-numeric 
                        style="min-width: 100px" 
                        class="w3-input w3-border" 
                        v-bind:precision="3" 
                        separator="." 
                        v-model="divisao.quantidade_utilizar_ato" 
                        @input="totalizarDivisoesProdutoSelecionado">
                      </vue-numeric>
                    </div>

                    <div class="w3-col s12 m12 l12" v-if="tipo_entrega != 'ATO'">
                      <label class="w3-margin-right">Qtd. utilizar entrega prog:</label>
                      <vue-numeric 
                        style="min-width: 100px" 
                        class="w3-input w3-border" 
                        v-bind:precision="3" 
                        separator="." 
                        v-model="divisao.quantidade_agendar" 
                        @input="totalizarDivisoesProdutoSelecionado">
                      </vue-numeric>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="container">
                <div class="w3-row-padding">
                  <div class="w3-half">
                    <label style="color: #0600b3;">Quantidade produto: <strong>{{formatarValor(produto_selecionado_editando.quantidade)}}</strong></label>
                  </div>
                  <div class="w3-half">
                    <label style="color: #199436;">Quantidade definida: <strong>{{formatarValor(totalizador_divisoes_produto_selecionado, 3)}}</strong></label>
                  </div>
                </div>
              </div>
              <footer class="w3-container w3-center">
                <button
                  class="w3-button w3-theme botao-100" 
                  style="margin-top: 10px; margin-bottom:10px" 
                  v-on:click="definirLotesProdutoSelecionado"> 
                  <i class="fas fa-check-circle"></i> Aplicar
                </button>
              </footer>
              <br>
            </div>
          </div>
        </div>

        <!-- Inicio modal opções proposta de orçamento -->
        <div id="modalOpcoesBloqueioProposta" class="w3-modal" v-if="abrirModalOpcoesBloqueioProposta" @click="abrirModalOpcoesBloqueioProposta = false" style="display: block">
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <h5 class="titulo texto-vermelho">Opções proposta de orçamento</h5>
            </header>

            <div class="w3-row-padding">
              <div class="w3-responsive">

                <div class="w3-padding-small" @click="opcao_gravacao_proposta = 'EDICAO_FUTURA'">
                  <span>
                    <i class="far fa-circle" v-if="opcao_gravacao_proposta != 'EDICAO_FUTURA'"></i>
                    <i class="far fas fa-check-circle" style="color: #199436;" v-if="opcao_gravacao_proposta == 'EDICAO_FUTURA'"></i>
                    &nbsp;Gravar para edição futura
                  </span>
                </div>

                <div class="w3-padding-small" @click="opcao_gravacao_proposta = 'VERIFICACAO'">
                  <span>
                    <i class="far fa-circle" v-if="opcao_gravacao_proposta != 'VERIFICACAO'"></i>
                    <i class="far fas fa-check-circle" style="color: #199436;" v-if="opcao_gravacao_proposta == 'VERIFICACAO'"></i>
                    &nbsp;Gerar proposta de orçamento para verificação
                  </span>
                </div>

              </div>

              <div class="w3-center w3-col s12" style="margin-top: 5px; margin-bottom:5px">
                <button 
                  class="w3-button w3-theme" 
                  v-on:click="gravarOrcamento()"> 
                  <i class="fas fa-check-circle"></i> Ok
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Fim do modal oções de desconto -->
        
        <!-- Inicio modal de fechar orçamento -->
        <div id="modalFechamentoOrcamento" class="w3-modal" v-if="abrirModalFechamentoOrcamento" @click="fecharModalGravarOrcamento()" style="display: block">
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container ">
              <span @click="fecharModalGravarOrcamento()" class="w3-button w3-display-topright">&times;</span>
              <h4 class="titulo texto-vermelho">Fechamento de orçamento</h4>
            </header>
            <div class="w3-container">
              <div class="w3-row">
                <div class="w3-col w3-row-padding">

                  <h4>Totais do pedido</h4>
                  <div class="w3-col s12 m6">
                    <strong>Total dos produtos</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_produtos, 2)" readOnly @change="calcularTotaisFechamentoPedido" >
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>Valor do desconto</strong>
                    <input
                      type="number"
                      class="w3-input w3-border"
                      :disabled="!permitido_aplicar_desconto"
                      v-model="valor_desconto"
                      onClick="this.select();"
                      v-on:keyup="calcularDescontoCapaOrcamento('VALOR')"
                      v-on:keyup.enter="calcularImpostosDescontoFechamentoPedido()"
                      v-on:blur="calcularImpostosDescontoFechamentoPedido()"
                    />
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>% do desconto</strong>
                    <input
                      type="number"
                      class="w3-input w3-border"
                      :disabled="!permitido_aplicar_desconto"
                      v-model="perc_desconto_venda"
                      onClick="this.select();"
                      v-on:keyup="calcularDescontoCapaOrcamento('PERC')"
                      v-on:keyup.enter="calcularImpostosDescontoFechamentoPedido()"
                      v-on:blur="calcularImpostosDescontoFechamentoPedido()"
                    />
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>Despesas</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(total_despesas, 2)" readOnly>
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>TC</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(valor_tac, 2)" readOnly>
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>Desconto PIS</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_desconto_pis, 2)" readOnly disabled>
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>Desconto COFINS</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_desconto_cofins, 2)" readOnly disabled>
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>Substituição tributária</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_st, 2)" readOnly>
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>Valor do FCP ST</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_fcp_st, 2)" readOnly>
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>Valor do IPI</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_ipi, 2)" readOnly>
                  </div>

                  <div class="w3-col s12 m6">
                    <strong>Total a ser pago</strong>
                    <input type="text" class="w3-input w3-border" :value="formatarValor(total_liquido, 2)" readOnly>
                  </div>
                </div>                
              
                <div class="w3-col">
                  <h4>Outras informações</h4>
                  <div class="w3-row-padding">
                    <div class="w3-col s12 m6">
                      <strong>Total preço normal</strong>
                      <input type="text" class="w3-input w3-border" :value="formatarValor(total_preco_normal, 2)" readOnly>
                    </div>
                    <div class="w3-col s12 m6">
                      <strong>Total preço promoção</strong>
                      <input type="text" class="w3-input w3-border" :value="formatarValor(total_preco_promocao, 2)" readOnly>
                    </div>
                  </div>
                </div>

                <div class="w3-col s12 w3-center w3-margin-top">
                  <button 
                    style="width:220px" 
                    :disabled="processando"
                    class="w3-button w3-theme" 
                    v-on:click="verificarPropostaOrcamento()">
                    <i class="fas fa-database"/> Gravar
                  </button>
                </div>
              </div>
            </div>
            <br>  
          </div>
        </div>
        <!-- Fim modal de fechar orçamento -->

        <!-- Inicio modal de frete produto -->
        <div id="modalFrete" class="w3-modal" v-if="abrirModalFrete" @click="abrirModalFrete = false" style="display: block">
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span @click="abrirModalFrete = false" class="w3-button w3-display-topright">&times;</span>
              <h4 class="titulo texto-vermelho" v-show="par_emp_permitir_ver_frete_na_venda == 'S'">Frete e Despesa do Pedido</h4>
              <h4 class="titulo texto-vermelho" v-show="par_emp_permitir_ver_frete_na_venda == 'N'">Despesas do Pedido</h4>
            </header>
            <div class="w3-container">
              <div class="w3-row-padding">
                <div class="w3-col m4" v-show="par_emp_permitir_ver_frete_na_venda == 'S'">
                  <strong>Tipo de frete</strong>
                  <select class="w3-select w3-border" v-model="tipo_frete" @change="valor_frete = 0">
                    <option value="C">CIF %</option>
                    <option value="F">FOB</option>
                    <option value="V">CIF R$</option>
                    <option value="S">Sem frete</option>
                  </select>
                </div>
                <div class="w3-col m4" v-show="par_emp_permitir_ver_frete_na_venda == 'S'">
                  <strong v-if="tipo_frete == 'C'">% de Frete</strong>
                  <strong v-else>Valor do frete</strong>
                  <vue-numeric 
                    onClick="this.select()"
                    class="w3-input w3-border" 
                    v-model="valor_frete" 
                    :value="0" 
                    v-bind:precision="2" 
                    separator="." 
                    :disabled="(tipo_frete == 'S' || tipo_frete == 'F' || tipo_frete == 'V') && (tipo_entrega == 'ATO' || tipo_entrega == 'RLR')"></vue-numeric>
                </div>
                <div class="w3-col m4">
                  <strong>Outras despesas</strong>
                  <vue-numeric 
                    onClick="this.select()"
                    class="w3-input w3-border" 
                    v-model="outras_despesas" 
                    :value="0" 
                    v-bind:precision="2" 
                    separator=".">
                  </vue-numeric>
                </div>
              </div>
            </div>
            <footer class="w3-container w3-center">
              <button 
                class="w3-button w3-theme botao-100" 
                style="margin-top: 10px; margin-bottom:10px" 
                @click="calcularFrete()">
                <i class="fas fa-check-circle"></i> Aplicar
              </button>
            </footer>
          </div>
        </div>
        <!-- Fim modal de frete produto -->

        <!-- Inicio modal de copiar pedido -->
        <div id="modalCopiarPedido" class="w3-modal" v-if="abrirModalCopiarPedido" @click="abrirModalCopiarPedido = false" style="display: block">
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span @click="abrirModalCopiarPedido = false" class="w3-button w3-display-topright">&times;</span>
              <h4 class="titulo texto-vermelho">Pedido a ser copiado</h4>
            </header>
            <div class="w3-container">
            
              <div class="w3-col s12">
                <strong>Pedido</strong>
                <input
                  type="number"
                  autocomplete='off' 
                  id="codigo_copiar_pedido"
                  ref="codigo_copiar_pedido"
                  v-model="copiar_orcamento_id"
                  v-on:keyup.enter="copiarPedido()"
                  class="w3-input w3-border w3-col s12 l12 m12"
                /> 
              </div>

              <center>
                <button 
                  class="w3-button w3-theme botao-100" 
                  style="margin-top: 10px; margin-bottom:10px" 
                  @click="copiarPedido()">
                  <i class="fas fa-check-circle"></i> Ok
                </button>
              </center>
            </div>
          </div>
        </div>
        <!-- Fim modal de copiar pedido -->


        <!-- Inicio modal de desconto produto -->
        <div id="modalDescontoProduto" class="w3-modal" v-if="abrirModalDescontoProduto" @click="abrirModalDescontoProduto = false" style="display: block">
          <div class="w3-modal-content w3-animate-zoom w3-padding" @click.stop>
            <header>
              <span @click="abrirModalDescontoProduto = false" class="w3-button w3-display-topright">&times;</span>
              <h4 class="titulo texto-vermelho">Desconto por Item</h4>
            </header>
            <div>
              <div class="w3-responsive w3-hide-small w3-hide-medium">
                <table class="w3-table-all">
                  <thead>
                    <tr>
                      <th style="white-space: nowrap;">Produto</th>
                      <th style="white-space: nowrap;">Preço base</th>
                      <th style="white-space: nowrap;">% Desconto</th>
                      <th style="white-space: nowrap;">Valor desconto</th>
                      <th style="white-space: nowrap;">Preço líquido</th>
                      <th style="white-space: nowrap;">Quantidade</th>
                      <th style="white-space: nowrap;">Total líquido</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- A regra de negócio aplicada aqui também deve ser aplicada no grid para versão mobile -->
                    <tr 
                      :key="index"
                      v-for="(produto, index) in produtos_selecionados"  
                      v-if="produtoAceitaDesconto(produto)">
                      <td style="min-width: 200px">{{formatarValor(produto.produto_id, 0)}} - {{produto.nome}}</td>
                      <td class="alinhamento-numero" style="color: blue; cursor: pointer;" @click="limparDescontoPorItem(index)">{{formatarValor(produto.preco_venda_sem_desconto, 2)}}</td>
                      <td class="alinhamento-numero">
                        <input 
                          type="number"
                          onClick="this.select()"
                          style="min-width: 100px" 
                          class="w3-input w3-border input-vermelho"
                          :readOnly="produto.ponta_estoque" 
                          v-model="produto.perc_desconto_temp"
                          v-on:keyup="calcularPreviaDescontoProduto(index)"
                          v-on:blur="calcularPreviaDescontoPrecoLiquido(index)"
                          v-on:keyup.enter="calcularPreviaDescontoPrecoLiquido(index)">
                      </td>
                      <td class="alinhamento-numero">{{formatarValor(produto.valor_desconto_temp, 2)}}</td>
                      <td class="alinhamento-numero">
                        <input 
                          type="number"
                          onClick="this.select()" 
                          style="min-width: 100px"
                          :readOnly="produto.ponta_estoque"  
                          v-model="produto.preco_temp" 
                          v-on:blur="calcularPreviaDescontoPrecoLiquido(index)"
                          v-on:keyup="calcularPreviaDescontoPrecoLiquido(index)"
                          class="w3-input w3-border input-verde"> 
                      </td>
                      <td class="alinhamento-numero">{{formatarValor(produto.quantidade)}}</td>
                      <td style="color: green;" class="alinhamento-numero">{{formatarValor(produto.total_item_temp, 2)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="w3-hide-large">
                <!-- A regra de negócio aplicada aqui também deve ser aplicada no grid para versão desktop -->
                <div 
                  :key="index"
                  v-for="(produto, index) in produtos_selecionados" 
                  v-if="produtoAceitaDesconto(produto)" 
                  class="w3-col w3-row-padding" style="margin-bottom: 15px; padding: 0;">
                  <div class="w3-col s12">
                    <strong><i class="fas fa-box"></i> {{formatarValor(produto.produto_id, 0)}} - {{produto.nome}} ({{formatarValor(produto.quantidade)}} {{produto.unidade}})</strong>
                  </div><br>                      
                  <div class="w3-col s12">
                    <label>Preço base: </label>
                    <label style="cursor: pointer; border-bottom: 1px solid;" @click="limparDescontoPorItem(index)">{{formatarValor(produto.preco_venda_sem_desconto, 2)}}</label>
                  </div>                   
                  <div class="w3-col s6">
                    <label>% Desconto </label>
                    <input 
                      type="number" 
                      onClick="this.select()"
                      style="min-width: 100px" 
                      class="w3-input w3-border input-vermelho"
                      :readOnly="produto.ponta_estoque" 
                      v-model="produto.perc_desconto_temp"
                      v-on:keyup="calcularPreviaDescontoProduto(index)"
                      v-on:onblur="calcularPreviaDescontoPrecoLiquido(index)"
                      v-on:keyup.enter="calcularPreviaDescontoPrecoLiquido(index)">
                  </div>
                  <div class="w3-col s6">
                    <label>Preço líquido </label>
                    <input 
                      type="number" 
                      onClick="this.select()"
                      style="min-width: 100px"
                      :readOnly="produto.ponta_estoque"
                      v-model="produto.preco_temp" 
                      v-on:blur="calcularPreviaDescontoPrecoLiquido(index)"
                      v-on:keyup="calcularPreviaDescontoPrecoLiquido(index)"
                      class="w3-input w3-border input-verde">                
                  </div>                  
                  <div class="w3-col s12">
                    <label>Valor desconto</label>
                    <strong>{{formatarValor(produto.valor_desconto_temp, 2)}}</strong>
                  </div>
                  <div class="w3-col s12" >
                    <label>Total líquido: </label>
                    <strong style="color: green; font-size: 16px">{{formatarValor(produto.total_item_temp, 2)}}</strong>
                    <div style="border-bottom: 2px dotted #666666; margin-top:5px;" class="w3-col"></div>
                  </div>                                                                                                                      
                </div>              
              </div><br>

              <div class="w3-container w3-center">
                <div class="w3-col s12 m12 l3">
                  <label class="w3-left">Total bruto: <strong style="color: blue;">{{formatarValor(valor_total_preco_venda_oculto, 2)}}</strong></label>
                </div>
                <div class="w3-col s12 m12 l3">
                  <label class="w3-left">Valor desconto: <strong style="color: red;">{{valorDescontoTotalF5Previa}}</strong></label>
                </div> 
                <div class="w3-col s12 m12 l3">
                  <label class="w3-left">% Desconto: <strong style="color: red;">{{percDescontoTotalF5Previa}}</strong></label>
                </div>      
                <div class="w3-col s12 m12 l3">
                  <label class="w3-left">Total dos itens: <strong style="color: green;">{{descontoTotalItensPrevia}}</strong></label>
                </div>                                              
              </div>
            </div>
            <footer class="w3-container" style="padding: 0;">
              <button 
                class="w3-button w3-theme botao-100 w3-right" 
                style="margin-top: 10px; margin-bottom:10px" 
                @click="gravarDescontosProdutos()">
                <i class="fas fa-check-circle"></i> Aplicar
              </button>
            </footer>
          </div>
        </div>
        <!-- Fim modal de desconto produto -->

        <!-- Inicio modal de fechar pedido -->
        <div id="modalFecharPedido" class="w3-modal" v-if="abrirModalFecharPedido" v-on:click="fecharModalFecharPedido()" style="display: block">
          <div class="w3-modal-content w3-animate-zoom" @click.stop style="padding-bottom: 0;">
            <header class="w3-container">
              <span v-on:click="fecharModalFecharPedido()" class="w3-button w3-display-topright">&times;</span>
              <h4 class="titulo texto-vermelho">Fechamento de pedido</h4>
            </header>

            <div class="w3-container w3-row-padding">
              <div class="w3-third">
                
                <div class="w3-col s12">
                  <h4>Totais do pedido</h4>
                  <strong>Total dos produtos</strong>
                  <input 
                    type="text"
                    class="w3-input w3-border" 
                    :value="formatarValor(valor_total_produtos, 2)"
                    readOnly
                    @change="calcularTotaisFechamentoPedido"
                    disabled>
                </div>
                
                <div class="w3-col s12">
                  <strong>Valor do desconto</strong><br>
                  <input
                    type="number"
                    class="w3-input w3-border w3-left"
                    :disabled="!permitido_aplicar_desconto"                       
                    v-model="valor_desconto"
                    v-on:keyup="calcularDescontoCapaOrcamento('VALOR')"
                    v-on:keyup.enter="calcularImpostosDescontoFechamentoPedido()"
                    v-on:blur="calcularImpostosDescontoFechamentoPedido()"
                  />
                </div>
                
                <div class="w3-col s12">
                  <strong>% do desconto</strong>
                  <input 
                    type="number"
                    class="w3-input w3-border w3-left"              
                    :disabled="!permitido_aplicar_desconto"
                    v-model="perc_desconto_venda"
                    v-on:keyup="calcularDescontoCapaOrcamento('PERC')"
                    v-on:keyup.enter="calcularImpostosDescontoFechamentoPedido()"
                    v-on:blur="calcularImpostosDescontoFechamentoPedido()"
                  />
                </div>
               
                <div class="w3-col s12">
                  <strong>Despesas\Frete</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(total_despesas, 2)" readOnly disabled>
                  <strong>TC</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(valor_tac, 2)" readOnly disabled>
                  <strong>Desconto PIS</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_desconto_pis, 2)" readOnly disabled>
                  <strong>Desconto COFINS</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_desconto_cofins, 2)" readOnly disabled>
                  <strong>Substituição tributária</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_st, 2)" readOnly disabled>
                  <strong>Valor do FCP ST</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_fcp_st, 2)" readOnly disabled>
                  <strong>Total IPI</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(valor_total_ipi, 2)" readOnly disabled>
                  <strong>Total pedido</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(total_liquido, 2)" readOnly disabled>
                </div>
              </div>

              <div class="w3-third">
                <div class="w3-col s12">
                  <h4>Formas de pagamento</h4>
                  <div @click="preecherCampoFechamentoPedido($event, 'VVD', 'campoDinheiro')">
                    <strong>Dinheiro</strong>
                    <money v-model="valor_dinheiro" v-bind="money" id="campoDinheiro" class="w3-input w3-border" :disabled="!habilitar_dinheiro"/>
                  </div>
                  
                  <div @click="preecherCampoFechamentoPedido($event, 'VCV', 'campoChequeVista')">
                    <strong>Cheque a vista</strong>
                    <money v-model="valor_cheque_vista" v-bind="money" id="campoChequeVista" class="w3-input w3-border" :disabled="!habilitar_cheque_vista"/>
                  </div>
                  
                  <div @click="preecherCampoFechamentoPedido($event, 'VCD', 'campoCartaoDB')">
                    <strong>Cartão de DB</strong>
                    <money v-model="valor_cartao_db" v-bind="money" id="campoCartaoDB" class="w3-input w3-border" :disabled="!habilitar_cartao_debito"/>
                  </div>
                  
                  <div @click="preecherCampoFechamentoPedido($event, 'VCP', 'campoChequePrazo')">
                    <strong>Cheque a prazo</strong>
                    <money v-model="valor_cheque_prazo" v-bind="money" id="campoChequePrazo" class="w3-input w3-border" :disabled="!habilitar_cheque_prazo"/>
                  </div>
                  
                  <div @click="preecherCampoFechamentoPedido($event, 'VCC', 'campoCartaoCR')"> 
                    <strong>Cartão de CR</strong>
                    <money v-model="valor_cartao_cr" v-bind="money" id="campoCartaoCR" class="w3-input w3-border" :disabled="!habilitar_cartao_credito" />
                  </div>
                 
                  <div @click="preecherCampoFechamentoPedido($event, 'VDB', 'campoDupBol')">
                    <strong>Duplicata ou boleto</strong>
                    <money v-model="valor_duplicata_boleta" v-bind="money" id="campoDupBol" class="w3-input w3-border" :disabled="!habilitar_duplicata_boleto"/>
                  </div> 

                  <div @click="preecherCampoFechamentoPedido($event, 'PIX', 'campoPix')">
                    <strong>Pix</strong>
                    <money v-model="valor_pix" v-bind="money" id="campoPix" class="w3-input w3-border" :disabled="!habilitar_pix"/>
                  </div> 
                  
                  <div @click="preecherCampoFechamentoPedido($event, 'VVA', 'campoAcumulativo')">
                    <strong>Acumulativo</strong>
                    <money v-model="valor_acumulativo" v-bind="money" id="campoAcumulativo" class="w3-input w3-border" :disabled="!habilitar_acumulativo"/>
                  </div>
                  
                  <div class="w3-col s12">
                    <div class="w3-col s12">
                      <strong>Crédito</strong>
                    </div>

                    <money 
                      v-bind="money"
                      :disabled="true"
                      id="campoCredito"
                      style="width: 75%"
                      v-model="valor_credito"
                      class="w3-input w3-border w3-left"
                    />

                    <button
                      @click="abrirModalCarregarCredito()"
                      style="font-size: 18px; color: white;"
                      class="w3-btn w3-light-green w3-right"
                      :disabled="!habilitar_credito || processando">
                      <i class="fas fa-search-dollar"/>
                    </button>
                  </div>

                </div>
              </div>
              <div class="w3-third">
                <div class="w3-col s12">
                  <h4>Outras informações</h4>

                  <strong class="w3-text-green">Total pagamentos</strong>
                  <vue-numeric class="w3-input w3-border" currency="R$" v-bind:precision="2" separator="." :value="totalFormasPagamento" disabled/>

                  <strong class="w3-text-indigo">Dif.pagamentos</strong>
                  <input type="text" :class="getClassDiferencaPagamento()" :value="formatarValor(valor_dif_pagamento, 2)" readOnly disabled>

                  <div v-if="valor_dif_pagamento > total_liquido" class="w3-col s12 w3-center fa-blink" style="margin-top: 15px; margin-bottom: 15px;">
                    <i class="fas fa-info-circle icone-vermelho" style="font-size: 15px;"/>
                    <strong class="texto-vermelho">Será gerado um crédito da diferença</strong>
                  </div>
                  
                  <strong>Total preço normal</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(total_preco_normal, 2)" readOnly disabled>
                  
                  <strong>Total preço promoção</strong>
                  <input type="text" class="w3-input w3-border" :value="formatarValor(total_preco_promocao, 2)" readOnly disabled>
                  
                  <strong class="texto-vermelho">% do desconto geral</strong>
                  <input type="text" class="w3-input w3-border texto-vermelho" :value="formatarValor(descontoPercDesconto, 2)" readOnly disabled>
                  
                  <strong class="texto-vermelho">Valor desconto geral</strong>
                  <input type="text" class="w3-input w3-border texto-vermelho" :value="formatarValor(descontoValorDesconto, 2)" readOnly disabled>
                </div>
              </div>
              <div class="w3-col s12 w3-center w3-margin-top">
                <button 
                  style="width:220px"
                  class="w3-button w3-theme" 
                  @click="fecharPedido()" 
                  :disabled="processando">
                  <i class="fas fa-check-circle"/> Ok
                </button>
              </div>
            </div>
            <br>
          </div>
        </div>
        <!-- Fim modal de fechar pedido -->

        <modal-mix 
          :mix="mix"
          v-if="abrirModalMix" 
          data-modal-mix="componente-mix"
          @close="abrirModalMix = false"
        />
        
        <mostrar-avisos-na-venda 
          ref="mostrarAvisosNaVenda" 
          :retornoAvisosNaVenda="retornoAvisosNaVenda"
        />

        <buscar-entregas-no-ato 
          ref="modal_ato"
          :tipo_entrega="tipo_entrega" 
          :vendedor="vendedor_selecionado" 
          :produtos_selecionados="produtos_selecionados"
          @confirmar_buscar_entregas_no_ato="confirmarBuscarEntregasAto" 
          :valor_frete="valorTotalFretes" 
          :frete_adicional_andar="frete_adicional_andar" 
          :frete_rota="frete_rota" 
          :frete_tipos_veiculos="frete_tipos_veiculos"
          :tipo_frete="tipo_frete" 
          :bairro_entrega_id="endereco_cliente_selecionado.bairro_id" 
          :definicoes_lotes="definicoes_lotes"
          :cliente="cliente_selecionado"
          :condicao_pagamento="condicao_pagamento_selecionada"
          :valor_frete_andar_elevador_escada="valor_frete_andar_elevador_escada"
          :valor_frete_manual="valor_frete"
          :data_agendamento="data_entrega"
        />

        <modal-carregar-credito 
          ref="modalCarregarCredito"
          :orcamentoId="valor(orcamento_id)"
          @confirmar="adicionarCreditos"
        />

        <modal-autorizacao
          modo="CER"
          ref="certificar"
          chave="poder_gerar_cr_pedido"
          descricaoAutorizacao="Gerar crédito para pedido"
          @confirmarAutorizacao="autorizarCredito"
        />

        <modal-impressao-proposta-orcamento
          ref="modalImpressaoPropostaOrcamento"
          :recarregarTela="recarregar_tela"
          :parEmpGerarBloqPropostaOrcamento="par_emp_gerar_bloq_proposta_orcamento"
          :telaOrigemImpressaoProposta="'ORCAMENTOS'"
          :recarregarComponente="recarregarComponente"
        />

      </div>
        <modal-codigo-barras 
          v-if="abrirModalLeitorCodigoBarras" 
          @codigo_barras="buscarPeloCodigoBarras" 
          @fechar_modal_codigo_barras="abrirModalLeitorCodigoBarras = false"
        />
      </div><!-- #principal -->
    </div><!-- w3-main -->
  </div><!-- .orcamentos -->
</template>

<script>
  // import dependências
  import moment from 'moment'
  import { Money } from 'v-money'
  import store from '@/ambiente/store' 
  import VueNumeric from 'vue-numeric'
  import legenda from '@/components/Legendas'
  import formatarValorMixin from '@/mixins/formatarValorMixin'

  // import componentes vue
  import NavMenu from '@/components/Menu'
  import ModalMix from '@/components/ModalMix'
  import ModalAutorizacao from '@/components/Autorizar'
  import FrameVendedor from '@/components/Frames/FrameVendedor'
  import ExibirProcessando from '@/components/ExibirProcessando'
  import FrameCliente from '@/components/Frames/FrameClienteOrcamento'
  import ModalCodigoBarras from '@/components/Orcamentos/ModalCodigoBarras'
  import PesquisaOrcamentos from "@/components/Pesquisas/PesquisaOrcamentos"
  import BuscarEntregasNoAto from "@/components/Orcamentos/BuscarEntregasNoAto"
  import ModalCarregarCredito from "@/components/Orcamentos/ModalCarregarCredito"
  import MostrarAvisosNaVenda from '@/components/Orcamentos/MostrarAvisosNaVenda'
  import FrameCondicaoPagamento from '@/components/Frames/FrameCondicaoPagamento'
  import PesquisaProdutosVenda from '@/components/Pesquisas/PesquisaProdutosVenda'
  import DadosProdutosVendidos from '@/components/Orcamentos/DadosProdutosVendidos'
  import ModalAssistenciaTecnica from '@/components/Orcamentos/ModalAssistenciaTecnica' 
  import ModalEstoqueRedeProduto from '@/components/Orcamentos/ModalEstoqueRedeProduto'
  import ModalCaracteristicasProduto from '@/components/Orcamentos/ModalCaracteristicasProduto'
  import ColetarDadosConsumidorFinal from '@/components/Orcamentos/ColetarDadosConsumidorFinal'
  import ModalImpressaoPropostaOrcamento from '@/components/Orcamentos/ModalImpressaoPropostaOrcamento'

  // import java script
  import RSessao from '@/components/Rest/RSessao'
  import REntrega from '@/components/Rest/REntrega.js'
  import RCliente from '@/components/Rest/RCliente/RCliente.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoFecharPedido from  '@/components/Rest/ROrcamento/ROrcamentoFecharPedido.js' 
  import ROrcamentoGravarOrcamento from '@/components/Rest/ROrcamento/ROrcamentoGravarOrcamento.js'
  import REstoqueBuscarDivisaoEstoque from '@/components/Rest/REstoque/REstoqueBuscarDivisaoEstoque.js'
  import ROrcamentoBuscarFretePorRota from '@/components/Rest/ROrcamento/ROrcamentoBuscarFretePorRota.js'
  import ROrcamentoBuscarEntregasNoAto from '@/components/Rest/ROrcamento/ROrcamentoBuscarEntregasNoAto.js'
  import ROrcamentoReprocessarProdutos from '@/components/Rest/ROrcamento/ROrcamentoReprocessarProdutos.js'
  import REnderecoBuscarEnderecosEntrega from '@/components/Rest/REndereco/REnderecoBuscarEnderecosEntrega.js'
  import ROrcamentoBuscarOrcamentoEdicao from '@/components/Rest/ROrcamento/ROrcamentoBuscarOrcamentoEdicao.js'
  import ROrcamentoBuscarMixNovoOrcamento from '@/components/Rest/ROrcamento/ROrcamentoBuscarMixNovoOrcamento.js'
  import ROrcamentoBuscarValorFretePadrao from '@/components/Rest/ROrcamento/ROrcamentoBuscarValorFretePadrao.js'
  import ROrcamentoBuscarTipoPrecoCliente from '@/components/Rest/ROrcamento/ROrcamentoBuscarTipoPrecoCliente.js'
  import ROrcamentoBuscarDadosIniciarPedido from '@/components/Rest/ROrcamento/ROrcamentoBuscarDadosIniciarPedido.js'
  import ROrcamentoBuscarTiposVeiculosOrcamento from '@/components/Rest/ROrcamento/ROrcamentoBuscarTiposVeiculosOrcamento.js'
  import ROrcamentoBuscarFreteAdicionalPorAndar from '@/components/Rest/ROrcamento/ROrcamentoBuscarFreteAdicionalPorAndar.js'
  import ROrcamentoVerificarPesoMaximoFreteOrcamento from '@/components/Rest/ROrcamento/ROrcamentoVerificarPesoMaximoFreteOrcamento.js'
  import ROrcamentoBuscarDadosIniciaisFechamentoPedido from '@/components/Rest/ROrcamento/ROrcamentoBuscarDadosIniciaisFechamentoPedido.js'

  export default {
    name: 'Orcamentos',  
      
    components: {
      Money,
      legenda,
      NavMenu,
      ModalMix,
      VueNumeric,
      FrameCliente,
      FrameVendedor,
      ModalAutorizacao,
      ModalCodigoBarras,
      ExibirProcessando,
      PesquisaOrcamentos,
      BuscarEntregasNoAto,
      ModalCarregarCredito,
      MostrarAvisosNaVenda,
      DadosProdutosVendidos,
      PesquisaProdutosVenda,
      FrameCondicaoPagamento,
      ModalAssistenciaTecnica,
      ModalEstoqueRedeProduto,
      ColetarDadosConsumidorFinal,
      ModalCaracteristicasProduto,
      ModalImpressaoPropostaOrcamento
    },

    mixins:[formatarValorMixin],

    data() {
      return {
        api: process.env.API,
        processando: false,
        reprocessando_prod: false,
        ultimos_parametros_reprocessar_produtos: {},

        /* Orçamento */
        orcamento_id: '',
        orcamentos_filtrados: [],
        
        /* Parâmetros gerais */    
        par_consumidor_final_id: 0,
        par_ger_utiliza_controle_cep: '',
        par_ger_qtd_min_caract_pesq_produtos: 0,
        par_ger_perm_selec_emp_ven_ret_loj_red: '',
        
        /* Parâmetros de empresas */
        par_emp_sugerir_cons_final_padrao_vda: '',
        par_emp_questionar_uso_preco_atacado_vda: '',
        par_emp_permitir_ver_frete_na_venda: '',
        par_emp_tipo_obrig_endereco_entrega: '',
        par_emp_tipo_agendamento_horario_ent: '',
        par_emp_tipo_agendamento_entrega: '',
        par_emp_tipo_frete_manifesto: '',
        par_emp_tipo_entregas_venda: '',
        par_emp_condicao_mobile_id: '',
        par_emp_condicao_padrao_venda_id: '',
        par_emp_questionar_uso_promocao: '',
        par_emp_tipo_selec_local_entrega_ato: '',
        par_emp_gerar_bloq_proposta_orcamento: '',
        par_emp_gerar_bloq_desc_f5_acima_aut: '',

        /* Cliente */
        cliente_consumidor_final: false,
        cliente_selecionado: {},
        tipo_cliente_bloqueado_venda: '',
        
        /* Consumidor final */
        dados_consumidor_final: {},
        processo_apos_coletar_consumidor_final: '',

        /* Produto */
        produtos_filtrados: [],
        produtos_selecionados: [],
        definicoes_lotes: [],
        divisoes_lotes_produto_selecionado: [],
        totalizador_divisoes_produto_selecionado: 0,
        produto_selecionado: {},
        quantidade_produto_selecionado: '',
        produto_selecionado_editando: {},
        adicionando_produto_direto: false,
        
        /* Endereço de entrega */
        enderecos_cliente: [],
        endereco_cliente_selecionado: {},
        observacoes_endereco: '',
        
        /* Vendedores */
        vendedor_selecionado: {},
        desconto_autorizado_vendedor: 0,

        /* Condição de pagamento */
        condicao_pagamento_selecionada: {},
        condicao_pagamento_id_frete_andar: '',
        indice_condicao_pagamento_selecionada: undefined,

        valor_total_preco_venda_oculto: 0,
        valor_total_produtos: 0,
        peso_total_produtos: 0,

        /* Fechamento de pedido */
        total_liquido: 0,

        valor_dif_pagamento: 0,
        creditos_utilizados: [],
        
        valor_desconto: 0,
        perc_desconto_venda: 0,
        valor_total_desconto_pis: 0,
        valor_total_desconto_cofins: 0,
        valor_produtos_com_desc_pis_cofins: 0,

        valor_dinheiro: 0,
        valor_cartao_db: 0,
        valor_cartao_cr: 0,
        valor_cheque_vista: 0,
        valor_cheque_prazo: 0,
        valor_duplicata_boleta: 0,
        valor_acumulativo: 0,
        valor_pix: 0,
        valor_credito: 0,
        total_formas_pagamento: 0,
        total_preco_normal: 0,
        total_preco_promocao: 0,        
        valor_tac: 0,
        valor_total_ipi: 0,
        valor_total_st: 0,
        valor_total_fcp_st: 0,
        valor_total_st_frete: 0,
        total_despesas: 0, 
        recebimento_na_entrega: false,
        tipo_contato_cliente: 'NEN',

        habilitar_dinheiro: false,
        habilitar_cartao_credito: false,
        habilitar_cartao_debito: false,
        habilitar_cheque_vista: false,
        habilitar_cheque_prazo: false,
        habilitar_duplicata_boleto: false,
        habilitar_acumulativo: false,
        habilitar_credito: false,
        habilitar_pix: false,
        bloquear_trocar_vendedor: 'N',
        permitido_trocar_cliente: true,
        permitido_aplicar_desconto: false,

        tipo_frete: 'F',
        valor_frete: 0,
        outras_despesas: 0,
        tipo_entrega: 'EPG',
        tipo_entrega_padrao: '',
        tipo_agendamento_entrega: '',
        data_minima_entrega: '',
        data_entrega: '',
        hora_entrega: '',

        /* Fretes */
        frete_rota: {},
        frete_tipos_veiculos: [],
        frete_adicional_andar: 0,
        valor_frete_andar_elevador_escada: 0,
        permitir_edicao_tipo_frete_andar: false,
        tipo_frete_andar: '',

        //Double Click
        contador_click: 0,
        delay: 700,
        timer: null,

        /* Preenchimento de orçamento */
        orcamento_dados_edicao: {},
        carregando_pedido: false,
        processando_restricoes: false,
        adicionando_direto: false,
        cliente_orc_pesquisado_cons_final: false,

        visualizar_opcoes_orcamento: false,
        mix: {},
        autorizado_visualizar_mix: false,
        autorizado_visualizar_lucratividade_mix: false,
        autorizado_visualizar_lucro_liquido_mix: false,
        autorizado_copiar_pedidos_venda: 'N',

        proc_carregando_orcamento: false,
        perc_descontos_produtos_temp: [],

        /* Leitura de código de barras */
        carregando_dados_iniciais: true,
        tipo_preco: null,
        mensagem_validacao_peso_frete: '',
        mostrarValoresTotais: false,
        usuario_redefiniu_lote: false,

        /* modais */
        abrirModalLeitorCodigoBarras: false,
        abrirModalImpressaoPropostaOrcamento: false,
        abrirModalDescontoProduto: false,
        abrirModalFrete: false,
        abrirModalCopiarPedido: false,
        abrirModalFechamentoOrcamento: false,
        abrirModalFecharPedido:false,        
        abrirModalAtualizarQuantidade: false,
        abrirModalOpcoesDesconto: false,
        abrirModalMix: false,
        abrirModalSelecionarEnderecosCliente: false,
        abrirModalOpcoesProduto: false,
        abrirModalDefinirLoteProduto: false,        
        abrirModalOpcoesBloqueioProposta: false,
        alterando_preco_produto: false,
        opcao_tipo_negociacao_preco: '',
        opcao_gravacao_proposta: '',
        recarregar_tela: '',
        hash_pedido: '',
        copiar_orcamento_id: '',

        // v-money
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: ' ',
          precision: 2,
          masked: false
        },
        armazenamentoLocalStorage: {},
        tiposAgendamentoArray: [],
        carregando_localStorage: false,

        adicionando_produtos: false,

        // Campos ref
        ref_produto: '',

        /* Transição */
        transicao_valores_pedido: false,

        /*Classe */
        classe_botao_tipo_entrega_ato: 'botao-tipo-entrega',
        classe_botao_tipo_entrega_ent: 'botao-tipo-entrega',
        classe_botao_tipo_entrega_sem: 'botao-tipo-entrega',
        classe_botao_tipo_entrega_rlr: 'botao-tipo-entrega',

        /*Aba*/
        abaSelecionada: 'principais'
      }
    },
    watch: {

      abrirModalEntregaNoAto() {
        this.verificarModalAberto();   
      },

      abrirModalLeitorCodigoBarras() {
        this.verificarModalAberto();   
      }, 

      abrirModalImpressaoPropostaOrcamento() {
        this.verificarModalAberto();   
      },

      abrirModalSelecionarEnderecosCliente() {
        this.verificarModalAberto();   
      },            

      abrirModalDescontoProduto() {
        this.verificarModalAberto();   
        this.calcularPreviaDescontoTodosProdutos();
      },    

      abrirModalFrete() {
        this.verificarModalAberto();
      },    

      abrirModalFechamentoOrcamento() {
        this.verificarModalAberto();

        if (this.abrirModalFechamentoOrcamento){
          this.calcularDescontoCapaOrcamento('VALOR');
          this.calcularImpostosDescontoFechamentoPedido();
        }
      },    

      abrirModalFecharPedido() {
        this.verificarModalAberto();
        if (this.abrirModalFecharPedido){
          this.calcularDescontoCapaOrcamento('VALOR');
          this.calcularImpostosDescontoFechamentoPedido();
        }
      },

      abrirModalAtualizarQuantidade(){
        this.verificarModalAberto();
      },

      abrirModalMix() {
        this.verificarModalAberto();   
      },    

      abrirModalOpcoesProduto() {
        this.verificarModalAberto();   
      },   

      abrirModalDefinirLoteProduto() {
        this.verificarModalAberto();   
      },        

      produtos_selecionados() {
        this.total_liquido = 
          (
            Biblioteca.valor(this.valor_total_produtos) - 
            Biblioteca.valor(this.valor_desconto) - 
            Biblioteca.valor(this.valor_total_desconto_pis) -
            Biblioteca.valor(this.valor_total_desconto_cofins) +
            Biblioteca.valor(this.valor_total_ipi) + 
            Biblioteca.valor(this.valor_total_st) + 
            Biblioteca.valor(this.valor_total_fcp_st) + 
            Biblioteca.valor(this.valor_tac) + 
            Biblioteca.valor(this.total_despesas)
          ).toFixed(2);

        this.total_formas_pagamento =
          Biblioteca.valor(this.valor_dinheiro) +
          Biblioteca.valor(this.valor_cartao_db) +
          Biblioteca.valor(this.valor_cartao_cr) +
          Biblioteca.valor(this.valor_cheque_vista) +
          Biblioteca.valor(this.valor_cheque_prazo) +
          Biblioteca.valor(this.valor_duplicata_boleta) +
          Biblioteca.valor(this.valor_acumulativo) + 
          Biblioteca.valor(this.valor_pix) +
          Biblioteca.valor(this.valor_credito);
      },

      tipo_entrega(){
        this.verificarTipoEntrega(this.tipo_entrega);
      },

    },
    computed: {
      verificarModal() {
        if (
          this.abrirModalDescontoProduto || 
          this.abrirModalFrete ||
          this.abrirModalFechamentoOrcamento ||
          this.abrirModalFecharPedido ||        
          this.abrirModalAtualizarQuantidade ||
          this.abrirModalMix ||
          this.abrirModalSelecionarEnderecosCliente ||
          this.abrirModalOpcoesProduto ||
          this.abrirModalDefinirLoteProduto
        ){
          return true;
        } 
        else {
          return false;     
        } 
      },

      totalFormasPagamento: function() {
        this.calcularTotaisFechamentoPedido();
        this.valor_dif_pagamento = Biblioteca.valor(this.total_formas_pagamento) - Biblioteca.valor(this.total_liquido);
        return this.formatarValor(this.total_formas_pagamento, 2);
      },

      valorTotalFretes(){
        let total = 0;

        /*
          Caso o frete seja CIF% não pode calcular o total de frete pois não pode ser mostrado no campo "Total de frete".
          Além disso o frete CIF% esta sendo calculado no servidor, retirando a necessidade de fazer o rateio no JS.
        */        
        if (this.tipo_entrega != 'ATO' && this.tipo_entrega != 'RLR' && this.tipo_frete != 'C'){
          total += this.valor_frete;
          total += this.valorTotalFretesTerceirizados;
          total += this.frete_adicional_andar;
        }

        if (total < 0) 
          total = 0;

        return total;
      },

      valorTotalFretesTerceirizados(){
        var total = 0;

        if (this.frete_rota.total_frete_terceirizado) {
          total += Biblioteca.valor(this.frete_rota.total_frete_terceirizado);
        }

        for (let i = 0; i < this.frete_tipos_veiculos.length; i++) {
          if (this.frete_tipos_veiculos[i].viagens > 0) {
            total += this.frete_tipos_veiculos[i].valor_total;
          }
        }

        return total;
      },

      totalPesoMaximo(){
        var total = 0;
        for (let i = 0; i < this.frete_tipos_veiculos.length; i++) {
          if (this.frete_tipos_veiculos[i].peso_maximo > 0 && this.frete_tipos_veiculos[i].viagens > 0) {
            total += this.frete_tipos_veiculos[i].peso_maximo * this.frete_tipos_veiculos[i].viagens;
          }
        }

        return total; 
      },

      freteTiposVeiculosSelecionados(){
        var fretes = [];
        for (let i = 0; i < this.frete_tipos_veiculos.length; i++) {
          if (this.frete_tipos_veiculos[i].peso_maximo > 0 && this.frete_tipos_veiculos[i].viagens > 0)
            fretes.push(this.frete_tipos_veiculos[i])
        }

        return fretes;
      },

      descontoTotalItens(){
        let total = 0;

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          total += this.produtos_selecionados[i].total_item;
        }
        
        return total;
      },

      descontoTotalItensPrevia(){
        let total = 0;

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          total += this.produtos_selecionados[i].total_item_temp;
        }
        
        return this.formatarValor(total, 2); 
      },

      descontoPercDesconto(){
        let total_desconto_preco_manual = 0;        

        let total = 0;
        if (this.descontoValorDesconto > 0 || parseFloat(this.valor_desconto) > 0){                    
          total = parseFloat(this.descontoValorDesconto) / (parseFloat(this.valor_total_preco_venda_oculto) - this.total_preco_promocao) * 100;
        } else{
          total = 0;
        }
        
        return total;
      },

      percDescontoTotalF5(){        
        return this.Arredondar((this.valorDescontoTotalF5 / this.valor_total_preco_venda_oculto) * 100, 4);
      },

      percDescontoTotalF5Previa(){   
        return this.formatarValor(Biblioteca.valor(this.valorDescontoTotalF5Previa) / this.valor_total_preco_venda_oculto * 100, 4);
      },

      valorDescontoTotalF5(){
        let total = 0;
        
        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          total += (this.produtos_selecionados[i].preco_venda_sem_desconto - this.produtos_selecionados[i].preco) * this.produtos_selecionados[i].quantidade;
        }

        return this.Arredondar(total, 2);
      },

      valorDescontoTotalF5Previa(){
        let total = 0;
        
        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          total += (this.produtos_selecionados[i].preco_venda_sem_desconto - this.produtos_selecionados[i].preco_temp) * this.produtos_selecionados[i].quantidade;
        }
        
        return this.formatarValor(total, 2);
      },

      descontoValorDesconto(){
        let total = 0;        

        total = (parseFloat(this.valor_total_preco_venda_oculto) - this.descontoTotalItens + parseFloat(this.valor_desconto));
        return total;
      }      
    },

    filters: {
      npz: function (value) {
        if (value === 0) return ''
        else if (value == '0,00') return ''
        return value
      }
    },

    methods: {
      async fecharModalFecharPedido(){
        try {
          this.abrirModalFecharPedido = false;

          await this.voltarDescontoCapaOriginal();

          for (let i = 0; i < this.produtos_selecionados.length; i++) {
            this.produtos_selecionados[i].quantidade_entrega_ato = 0;
            this.produtos_selecionados[i].quantidade_agendar = 0;
            this.produtos_selecionados[i].retirar_lojas_rede = 'N';
            this.produtos_selecionados[i].empresa_retirar_lojas_rede_id = 0;
            this.produtos_selecionados[i].quantidade_sem_previsao = 0;

            this.produtos_selecionados[i].tipo_selec_local_entrega_ato = 'N';
            this.produtos_selecionados[i].quantidade_entrega_ato_loj = 0;
            this.produtos_selecionados[i].quantidade_entrega_ato_dep = 0;
            this.produtos_selecionados[i].quantidade_entrega_ato_exp = 0;
            this.produtos_selecionados[i].tipo_local_padrao_entrega_ato = 'N';
            this.produtos_selecionados[i].qtd_sem_agendamento = 0;
            this.produtos_selecionados[i].previsao_entrega_sem_agen = 0;
          }

          await this.buscarFreteAdicionalPorAndar();
          await this.recalcularTotaisPedido(true);
        } catch (error) {
          this.verificarErro(error, 'fecharModalFecharPedido');
        }
      },

      async fecharModalGravarOrcamento(){
        try {
          this.abrirModalFechamentoOrcamento = false;

          await this.voltarDescontoCapaOriginal();
          await this.buscarFreteAdicionalPorAndar();
          await this.recalcularTotaisPedido(true);
        } catch (error) {
          this.verificarErro(error, 'fecharModalGravarOrcamento');
        }
      },

      adicionarCreditos(creditos){
        this.creditos_utilizados = [];
        this.valor_credito = creditos.valor_total_creditos_utilizados;

        if (creditos.creditos_utilizados){
          this.creditos_utilizados = JSON.parse(JSON.stringify(creditos.creditos_utilizados)); 
        }
      },

      autorizarCredito(usuario_lib_credito_id){
        this.fecharPedido(usuario_lib_credito_id);
      },

      abrirModalCarregarCredito(){
        this.$refs.modalCarregarCredito.abrir(this.cliente_selecionado.cadastro_id);
      },

      voltarDescontoCapaOriginal(){
        try {
          this.valor_desconto = 0;

          if (this.orcamento_dados_edicao){
            this.valor_desconto = Biblioteca.valor(this.orcamento_dados_edicao[0].valor_desconto);
          }
        } catch (error) {
          this.valor_desconto = 0;
        }
      },

      tiposAgendamentoEntrega: function(){
        let tipos = [];
        
        if (this.par_emp_tipo_agendamento_entrega === 'E'){
          tipos.push({
            valor: 'E',
            descricao: 'DATA ESPECÍFICA'
          })
          this.tipo_agendamento_entrega = 'E';
        } else if (this.par_emp_tipo_agendamento_entrega === 'R'){
          tipos.push(
            {
              valor: 'E',
              descricao: 'DATA ESPECÍFICA'
            },
            {
              valor: 'R',
              descricao: 'ROTATIVO'
            },
          );
          this.tipo_agendamento_entrega = 'R';
        }
        else if (this.par_emp_tipo_agendamento_entrega === 'P'){
          tipos.push(
            {
              valor: 'E',
              descricao: 'DATA ESPECÍFICA'
            },
            {
              valor: 'R',
              descricao: 'ROTATIVO'
            },
            {
              valor: 'P',
              descricao: 'ROTATIVO, A PARTIR DE UMA DATA'
            },
          );
          this.tipo_agendamento_entrega = 'R';
        }

        this.tiposAgendamentoArray = tipos;
      },

      verificarModalAberto(){
        const el = document.documentElement;

        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        } 
      },

      async recarregarComponente(){   
        Object.assign(this.$data, this.$options.data.call(this));

        await this.$refs.frVendedor.limparDados(); 
        await this.$refs.frCliente.limparDados();
        await this.$refs.frCondicaoPagamento.limparDados();
        await this.armazenarLocalStorage('REDEFINIR');
        await this.carregarDadosIniciaisTelaVendas();

        await this.gerarNovoHashPedido();
      },

      mostrarDetalhesProduto(index) {
        this.produtos_selecionados[index].mostrar_detalhes = !this.produtos_selecionados[index].mostrar_detalhes;
        this.$forceUpdate();
      },

      async carregarOrcamentoEdicao(orcamento_id, copiando_pedido){
        let carregou_orcamento = false;

        try {
          await this.gerarNovoHashPedido();
          this.proc_carregando_orcamento = true;

          let parametros = {
            orcamento_id: orcamento_id,
            tipo_operacao: copiando_pedido == 'S' ? 'COP' : 'EDI'
          }

          let retorno = await ROrcamentoBuscarOrcamentoEdicao.buscarOrcamentoEdicao(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.orcamento_dados_edicao = JSON.parse(JSON.stringify(retorno.dados.orcamento_dados_edicao));
        
          this.vendedor_selecionado = {};
          this.cliente_selecionado = {};
          this.endereco_cliente_selecionado = {};
          this.condicao_pagamento_selecionada = {};

          this.produtos_selecionados = [];
          await this.configurarCarregandoPedido();

          this.cliente_consumidor_final = false;
          //Colocado esse tratamente para não limpar os descontos carregados previamente caso o índice da condição de pagamento selecionada seja diferente da condição carregada
          this.indice_condicao_pagamento_selecionada = undefined;

          // Dados entrega
          this.tipo_frete = this.orcamento_dados_edicao[0].tipo_frete;
          this.valor_frete = this.orcamento_dados_edicao[0].valor_perc_frete;
          this.outras_despesas = this.orcamento_dados_edicao[0].valor_outras_despesas;
          this.valor_total_st_frete = Biblioteca.valor(retorno.dados.valor_st_frete);
          this.data_entrega = this.orcamento_dados_edicao[0].data_entrega;
          this.data_minima_entrega = this.tipo_agendamento_entrega == 'R' ? this.orcamento_dados_edicao[0].data_entrega : this.orcamento_dados_edicao[0].data_minima_entrega;
          this.hora_entrega = this.orcamento_dados_edicao[0].hora_entrega;
          this.valor_frete = Biblioteca.valor(this.valor_frete);
          this.outras_despesas = Biblioteca.valor(this.outras_despesas);

          await this.$refs.frCliente.inserirDadoPorChave(this.orcamento_dados_edicao[0].cadastro_id);
          await this.$refs.frCondicaoPagamento.inserirDadoPorChave(this.orcamento_dados_edicao[0].condicao_id);
          await this.$refs.frVendedor.inserirDadoPorChave(this.orcamento_dados_edicao[0].vendedor_id);

          // Dados gerais

          this.orcamento_id = '';
          if (copiando_pedido == 'N'){
            this.orcamento_id = this.orcamento_dados_edicao[0].orcamento_id; 
          }

          this.condicao_pagamento_id_frete_andar = this.orcamento_dados_edicao[0].condicao_id;
          this.tipo_entrega = this.orcamento_dados_edicao[0].tipo_entrega;
          this.tipo_agendamento_entrega = this.orcamento_dados_edicao[0].tipo_agendamento_entrega;
          this.valor_tac = this.orcamento_dados_edicao[0].valor_tac;
          this.peso_total_produtos = Biblioteca.valor(this.orcamento_dados_edicao[0].peso_total);
          
          // Desconto
          this.valor_desconto = Biblioteca.valor(this.orcamento_dados_edicao[0].valor_desconto);
          await this.calcularDescontoCapaOrcamento('VALOR');

          // Endereço 
          this.endereco_cliente_selecionado.cep = this.orcamento_dados_edicao[0].cep_entrega;
          this.endereco_cliente_selecionado.logradouro = this.orcamento_dados_edicao[0].logradouro_entrega;
          this.endereco_cliente_selecionado.complemento = this.orcamento_dados_edicao[0].complemento_entrega;
          this.endereco_cliente_selecionado.ponto_referencia = this.orcamento_dados_edicao[0].ponto_referencia_entrega;
          this.endereco_cliente_selecionado.tipo_imovel = this.orcamento_dados_edicao[0].tipo_imovel_entrega;
          this.endereco_cliente_selecionado.andar = this.orcamento_dados_edicao[0].andar_entrega;
          this.endereco_cliente_selecionado.tipo_acesso_imovel = this.orcamento_dados_edicao[0].tipo_acesso_imovel_entrega;
          this.endereco_cliente_selecionado.bairro_id = this.orcamento_dados_edicao[0].bairro_entrega_id;
          this.endereco_cliente_selecionado.inscricao_estadual = this.orcamento_dados_edicao[0].inscricao_estadual_entrega;
          this.tipo_frete_andar = this.orcamento_dados_edicao[0].tipo_frete_andar;

          this.observacoes_endereco = '';
          if (this.orcamento_dados_edicao[0].observacao){
            this.observacoes_endereco = this.orcamento_dados_edicao[0].observacao.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
          }

          // -----------------------> Dados consumidor final inicio <----------------------
          await this.limparConsumidorFinal();
          
          this.dados_consumidor_final.consumidor_final_tipo_pessoa = this.orcamento_dados_edicao[0].tipo_pessoa_consumidor_final;
          this.dados_consumidor_final.cpf_cnpj_consumidor_final = this.orcamento_dados_edicao[0].cpf_cnpj_consumidor_final;
          this.dados_consumidor_final.consumidor_final_nome = this.orcamento_dados_edicao[0].nome_consumidor_final ? this.orcamento_dados_edicao[0].nome_consumidor_final : '';
          this.dados_consumidor_final.consumidor_final_telefone = this.orcamento_dados_edicao[0].telefone_consumidor_final;
          this.dados_consumidor_final.consumidor_final_cep = this.orcamento_dados_edicao[0].cep_cons_final;
          this.dados_consumidor_final.consumidor_final_logradouro = this.orcamento_dados_edicao[0].logradouro_cons_final;
          this.dados_consumidor_final.consumidor_final_complemento = this.orcamento_dados_edicao[0].complemento_cons_final;
          this.dados_consumidor_final.consumidor_final_email = this.orcamento_dados_edicao[0].e_mail_cons_final;
          this.dados_consumidor_final.consumidor_final_data_nascimento = this.orcamento_dados_edicao[0].data_nascimento_cons_final;
          this.dados_consumidor_final.inscricao_estadual_consumidor_final = this.orcamento_dados_edicao[0].inscricao_est_cons_final;

          if (Biblioteca.valorInt(this.orcamento_dados_edicao[0].bairro_entrega_id) > 0){
            this.dados_consumidor_final.consumidor_final_bairro_selecionado = await this.$refs.coletarDadosConsumidorFinal.buscarBairro(this.orcamento_dados_edicao[0].bairro_entrega_id);
          } else if (Biblioteca.valorInt(this.orcamento_dados_edicao[0].bairro_cons_final_id) > 0){ 
            this.dados_consumidor_final.consumidor_final_bairro_selecionado = await this.$refs.coletarDadosConsumidorFinal.buscarBairro(this.orcamento_dados_edicao[0].bairro_cons_final_id);
          }
          // -----------------------> Dados consumidor final fim <----------------------

          //Mensagem de pedido que deverá ser recalculado
          if (this.orcamento_dados_edicao[0].mensagem) {
            Biblioteca.exclamar(this.orcamento_dados_edicao[0].mensagem);
          }

          var existe_produto_controla_lote = false;  
          
          // Produtos
          for (let i = 0; i < retorno.dados.orcamento_itens_edicao.length; i++) {
              
            if (!existe_produto_controla_lote){
              if (retorno.dados.orcamento_itens_edicao[i].tipo_controle_estoque == 'L' || retorno.dados.orcamento_itens_edicao[i].tipo_controle_estoque == 'P')
                existe_produto_controla_lote = true;
            }
            
            retorno.dados.orcamento_itens_edicao[i].adicionado = true;
            retorno.dados.orcamento_itens_edicao[i].quantidade = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].quantidade).toFixed(3);
            retorno.dados.orcamento_itens_edicao[i].preco = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].preco);

            retorno.dados.orcamento_itens_edicao[i].valor_total_ipi = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].valor_ipi);
            retorno.dados.orcamento_itens_edicao[i].valor_total_st = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].valor_st);
            retorno.dados.orcamento_itens_edicao[i].valor_total_fcp_st = 0;

            retorno.dados.orcamento_itens_edicao[i].valor_ipi = parseFloat((retorno.dados.orcamento_itens_edicao[i].valor_total_ipi / retorno.dados.orcamento_itens_edicao[i].quantidade).toFixed(2));
            retorno.dados.orcamento_itens_edicao[i].valor_st = parseFloat((retorno.dados.orcamento_itens_edicao[i].valor_total_st / retorno.dados.orcamento_itens_edicao[i].quantidade).toFixed(2));
            retorno.dados.orcamento_itens_edicao[i].valor_fcp_st = 0;
            
            retorno.dados.orcamento_itens_edicao[i].preco_promocao = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].preco_promocao);
            retorno.dados.orcamento_itens_edicao[i].preco_manual = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].preco_manual);
            retorno.dados.orcamento_itens_edicao[i].preco_venda_oculto = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].preco_venda_oculto);              
            
            if (retorno.dados.orcamento_itens_edicao[i].usou_promocao == 'S'){                
              retorno.dados.orcamento_itens_edicao[i].preco_promocao = retorno.dados.orcamento_itens_edicao[i].preco_venda_oculto;
            };
            
            retorno.dados.orcamento_itens_edicao[i].valor_desconto = (
              Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].valor_desconto_preco_manual) /
              retorno.dados.orcamento_itens_edicao[i].quantidade
            );            
            
            retorno.dados.orcamento_itens_edicao[i].preco_base = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].preco_base);
            retorno.dados.orcamento_itens_edicao[i].preco_base_desconto = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].preco_base_desconto);

            /* Somente considerar desconto se houver preço manual */
            if (retorno.dados.orcamento_itens_edicao[i].valor_desconto != 0 && retorno.dados.orcamento_itens_edicao[i].preco_manual != 0){
              retorno.dados.orcamento_itens_edicao[i].perc_desconto = (100 - (retorno.dados.orcamento_itens_edicao[i].preco_manual / retorno.dados.orcamento_itens_edicao[i].preco_base_desconto) * 100).toFixed(2);
              retorno.dados.orcamento_itens_edicao[i].preco_venda_oculto = retorno.dados.orcamento_itens_edicao[i].preco_base_desconto; 
              retorno.dados.orcamento_itens_edicao[i].perc_desconto_temp = retorno.dados.orcamento_itens_edicao[i].perc_desconto;
              retorno.dados.orcamento_itens_edicao[i].valor_desconto_temp = retorno.dados.orcamento_itens_edicao[i].valor_desconto;
              retorno.dados.orcamento_itens_edicao[i].desconto_alterado = true;
            }
            else {
              retorno.dados.orcamento_itens_edicao[i].perc_desconto = 0;
              retorno.dados.orcamento_itens_edicao[i].perc_desconto_temp = '';
              retorno.dados.orcamento_itens_edicao[i].valor_desconto_temp = 0;
              retorno.dados.orcamento_itens_edicao[i].desconto_alterado = false;
            }

            retorno.dados.orcamento_itens_edicao[i].total_item_temp = 0;
            retorno.dados.orcamento_itens_edicao[i].preco_temp = retorno.dados.orcamento_itens_edicao[i].preco;

            if (retorno.dados.orcamento_itens_edicao[i].usou_ponta_estoque == 'S')
              retorno.dados.orcamento_itens_edicao[i].ponta_estoque = true; 
            else 
              retorno.dados.orcamento_itens_edicao[i].ponta_estoque = false; 

            if (retorno.dados.orcamento_itens_edicao[i].ponta_estoque){              
              retorno.dados.orcamento_itens_edicao[i].preco_ponta = retorno.dados.orcamento_itens_edicao[i].preco;
            }  
            else{
              retorno.dados.orcamento_itens_edicao[i].preco_ponta = 0;
            }  

            retorno.dados.orcamento_itens_edicao[i].preco_atacado = retorno.dados.orcamento_itens_edicao[i].preco_atacado_oculto;
            retorno.dados.orcamento_itens_edicao[i].preco_atacado_oculto = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].preco_atacado_oculto);

            retorno.dados.orcamento_itens_edicao[i].preco_unitario_com_imposto = Biblioteca.valor(retorno.dados.orcamento_itens_edicao[i].preco_unitario_com_imposto);
            
            retorno.dados.orcamento_itens_edicao[i].retirar_lojas_rede = 'N';
            retorno.dados.orcamento_itens_edicao[i].empresa_retirar_lojas_rede_id = 0;
            retorno.dados.orcamento_itens_edicao[i].tipo_selec_local_entrega_ato = 'N';
            retorno.dados.orcamento_itens_edicao[i].quantidade_agendar =  0;
            retorno.dados.orcamento_itens_edicao[i].quantidade_entrega_ato_loj = 0;
            retorno.dados.orcamento_itens_edicao[i].quantidade_entrega_ato_dep = 0;
            retorno.dados.orcamento_itens_edicao[i].quantidade_entrega_ato_exp = 0;
            retorno.dados.orcamento_itens_edicao[i].tipo_local_padrao_entrega_ato = 'N';
            retorno.dados.orcamento_itens_edicao[i].qtd_sem_agendamento = 0;
            retorno.dados.orcamento_itens_edicao[i].previsao_entrega_sem_agen = 0;
            retorno.dados.orcamento_itens_edicao[i].quantidade_entrega_ato = 0;
                          
            if (retorno.dados.orcamento_itens_edicao[i].preco_unitario_com_imposto == 0){
              retorno.dados.orcamento_itens_edicao[i].preco_unitario_com_imposto = retorno.dados.orcamento_itens_edicao[i].preco;
            }

            this.produtos_selecionados.push(Object.assign({}, retorno.dados.orcamento_itens_edicao[i]));
          }      

          if (existe_produto_controla_lote){
            Biblioteca.exclamar('Os lotes informados previamente para os produtos que controlam lote não serão carregados!');
          }

          await this.reprocessamentoGeralPedido();
          await this.armazenarLocalStorage('ORCAMENTO_ID', this.orcamento_id);
          await this.armazenarLocalStorage('VALOR_DESCONTO', this.valor_desconto);  

          this.proc_carregando_orcamento = false;
          this.carregando_pedido = false;
          this.processando = false;
          
          carregou_orcamento = true;
        } catch (error) {
          this.verificarErro(error, 'carregarOrcamentoEdicao');
          carregou_orcamento = false;
        }

        return carregou_orcamento;
      },

      async reprocessamentoGeralPedido(){
        await this.recalcularTotaisPedido();
        await this.buscarFreteRota();
        await this.buscarFreteAdicionalPorAndar();
        await this.buscarFreteTiposVeiculos(this.orcamento_id);
        await this.calcularTotaisFechamentoPedido();
        await this.recalcularPrecosProdutos('NENHUM', 'S', true, true);
        await this.buscarDataMinimaEntrega();
      },

      async gravarDataHoraEntrega(){
        await this.armazenarLocalStorage('DATA_ENTREGA', this.data_entrega);
        await this.armazenarLocalStorage('HORA_ENTREGA', this.hora_entrega);
      },

      async gravarObservacaoEndereco(){
        await this.armazenarLocalStorage('OBSERVACAO_ENDERECO', this.observacoes_endereco);
      },

      async verificarUsuarioLogadoLocalStorage() {
        try {
          let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));

          if (!armazenamentoLocalStorage){
            return;
          }

          if (!armazenamentoLocalStorage.orcamentos_parametros_offline){
            return;
          }

          if (await !RSessao.carregouSessao()) {
            await RSessao.buscarDadosCarregarSessao(this.axios);
          }

          let retorno = await JSON.parse(JSON.stringify(store.state.usuario_logado));
          
          if (Biblioteca.valorInt(retorno.funcionario_id) != Biblioteca.valorInt(armazenamentoLocalStorage.orcamentos_parametros_offline.usuario_logado_id)){
            await this.armazenarLocalStorage('REDEFINIR');  
          } 
        } catch (error) {
          this.verificarErro(error, 'verificarUsuarioLogadoLocalStorage');   
        }
      },

      async armazenarLocalStorage(campo, valor){
        try {

          if (!valor && (campo != 'REDEFINIR')){
            return;
          }

          let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));

          if (!armazenamentoLocalStorage){
            armazenamentoLocalStorage = {};
          }

          if (!armazenamentoLocalStorage.orcamentos_pedido_offline){
            armazenamentoLocalStorage.orcamentos_pedido_offline = {};
          }

          if (campo == 'CLIENTE'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.cliente_selecionado = valor;
          } else if (campo == 'VENDEDOR'){ 
            armazenamentoLocalStorage.orcamentos_pedido_offline.vendedor_selecionado = valor;
          } else if (campo == 'CONDICAO'){ 
            armazenamentoLocalStorage.orcamentos_pedido_offline.condicao_pagamento_selecionada = valor;
          } else if (campo == 'PRODUTOS'){ 
            armazenamentoLocalStorage.orcamentos_pedido_offline.produtos_selecionados = valor;
          } else if (campo == 'ENDERECO'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.endereco_cliente_selecionado = valor;
          } else if (campo == 'LOTE'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.definicoes_lotes = valor;
          } else if (campo == 'TIPO_ENTREGA'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.tipo_entrega = valor;
          } else if (campo == 'DATA_MINIMA_ENTREGA'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.data_minima_entrega = valor;
          } else if (campo == 'TIPO_AGENDAMENTO_ENTREGA'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.tipo_agendamento_entrega = valor; 
          } else if (campo == 'DATA_ENTREGA'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.data_entrega = valor;  
          } else if (campo == 'DEFINICOES_LOTE'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.definicoes_lotes = valor;
          } else if (campo == 'HORA_ENTREGA'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.hora_entrega = valor;
          } else if (campo == 'OBSERVACAO_ENDERECO'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.observacoes_endereco = valor;
          } else if (campo == 'PERC_DESCONTO_VENDA'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.perc_desconto_venda = valor;
          } else if (campo == 'VALOR_FRETE'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.valor_frete = valor;
          } else if (campo == 'TIPO_FRETE'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.tipo_frete = valor;
          } else if (campo == 'OUTRAS_DESPESAS'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.outras_despesas = valor;  
          } else if (campo == 'VALOR_DESCONTO') {
            armazenamentoLocalStorage.orcamentos_pedido_offline.valor_desconto = valor;
          } else if (campo == 'FRETES_TIPOS_VEICULOS'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.frete_tipos_veiculos = valor;
          } else if (campo == 'ORCAMENTO_ID'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.orcamento_id = valor;
          } else if (campo == 'HASH_PEDIDO'){
            armazenamentoLocalStorage.orcamentos_pedido_offline.hash_pedido = valor;
          } else if (campo == 'REDEFINIR'){
            armazenamentoLocalStorage.orcamentos_pedido_offline = {};
            armazenamentoLocalStorage.orcamentos_parametros_offline = {};
          } else{
            // SEMPRE POR ÚLTIMO "SE NÃO ENCONTROU NENHUMA OPÇÃO ACIMA SAINDO FORA".
            return;
          }

          // Definindo a data da última alteracação feito no pedido.
          armazenamentoLocalStorage.orcamentos_pedido_offline.data_ultima_atualizacao = this.frontEndDateFormat(new Date());
          await localStorage.setItem('localStorage', JSON.stringify(armazenamentoLocalStorage));
        } catch (error) {
          this.verificarErro(error, 'armazenarLocalStorage');   
        }
      },

      async recarregarDadosLocalStorage(tipo_local_storage){
        let local = JSON.parse(localStorage.getItem('localStorage'));

        if (tipo_local_storage == 'TODOS'){
          await this.preencherOrcamentoLocalStorage(local);
        } else if (tipo_local_storage == 'PRODUTOS'){
          if (local.orcamentos_pedido_offline.produtos_selecionados){ 
            this.produtos_selecionados = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.produtos_selecionados));
            await this.recalcularTotaisPedido();
          }
        } else if (tipo_local_storage == 'CLIENTE'){
          if (local.orcamentos_pedido_offline.cliente_selecionado){
            await this.carregarDadosCliente(JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.cliente_selecionado)), true);
          }
        } else if (tipo_local_storage == 'CONDICAO'){
          if (local.orcamentos_pedido_offline.condicao_pagamento_selecionada){
            await this.carregarDadosCondicaoPagamento(JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.condicao_pagamento_selecionada)), true);
          }
        } else if (tipo_local_storage == 'TIPO_ENTREGA'){
          if (local.orcamentos_pedido_offline.tipo_entrega){
            this.tipo_entrega = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.tipo_entrega));
          }
        } else if (tipo_local_storage == 'VENDEDOR'){
          if (local.orcamentos_pedido_offline.vendedor_selecionado){
            this.vendedor_selecionado = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.vendedor_selecionado));
          }
        } else if (tipo_local_storage == 'LOTE'){
          if (local.orcamentos_pedido_offline.definicoes_lotes){
            this.definicoes_lotes = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.definicoes_lotes));
          }
        } else if (tipo_local_storage == 'ENDERECO'){
          if (local.orcamentos_pedido_offline.endereco_cliente_selecionado){
            this.endereco_cliente_selecionado = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.endereco_cliente_selecionado));
          }
        } else if (tipo_local_storage == 'TIPO_FRETE'){
          if (local.orcamentos_pedido_offline.tipo_frete){
            this.tipo_frete = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.tipo_frete));
          }
        } else if (tipo_local_storage == 'VALOR_FRETE'){
          if (local.orcamentos_pedido_offline.valor_frete){
            this.valor_frete = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.valor_frete));
          }
        } else if (tipo_local_storage == 'FRETES_TIPOS_VEICULOS'){
          if (local.orcamentos_pedido_offline.frete_tipos_veiculos){
            this.frete_tipos_veiculos = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.frete_tipos_veiculos));
          }
        } else if (tipo_local_storage == 'OUTRAS_DESPESAS'){
          if (local.orcamentos_pedido_offline.outras_despesas){
            this.outras_despesas = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.outras_despesas));
          }
        } else if (tipo_local_storage == 'HASH_PEDIDO'){
          if (local.orcamentos_pedido_offline.hash_pedido){
            this.hash_pedido = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.hash_pedido));
          }
        } 
      },

      async preencherOrcamentoLocalStorage(local){
        this.carregando_pedido = true;
        this.carregando_localStorage = true;
        this.par_emp_questionar_uso_promocao = 'S';

        // Vendedor
        if (local.orcamentos_pedido_offline.vendedor_selecionado && local.orcamentos_pedido_offline.vendedor_selecionado.funcionario_id){
          await this.$refs.frVendedor.inserirDadoPorChave(Biblioteca.valorInt(local.orcamentos_pedido_offline.vendedor_selecionado.funcionario_id));
        }
        
        // Cliente
        if (local.orcamentos_pedido_offline.cliente_selecionado && local.orcamentos_pedido_offline.cliente_selecionado.cadastro_id){ 
          await this.$refs.frCliente.inserirDadoPorChave(local.orcamentos_pedido_offline.cliente_selecionado.cadastro_id);       
        }

        // Condição de pagamento
        if (local.orcamentos_pedido_offline.condicao_pagamento_selecionada && local.orcamentos_pedido_offline.condicao_pagamento_selecionada.condicao_id){
          await this.$refs.frCondicaoPagamento.inserirDadoPorChave(Biblioteca.valorInt(local.orcamentos_pedido_offline.condicao_pagamento_selecionada.condicao_id));
        }

        if (local.orcamentos_pedido_offline.orcamento_id){
          this.orcamento_id = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.orcamento_id));
        }

        if (local.orcamentos_pedido_offline.data_entrega){
          this.data_entrega = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.data_entrega));
        }

        if (local.orcamentos_pedido_offline.hora_entrega){
          this.hora_entrega = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.hora_entrega));
        }

        if (local.orcamentos_pedido_offline.observacoes_endereco){
          this.observacoes_endereco = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.observacoes_endereco));
        }

        if (local.orcamentos_pedido_offline.tipo_frete){
          this.tipo_frete = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.tipo_frete));
        }

        if (local.orcamentos_pedido_offline.valor_frete){
          this.valor_frete = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.valor_frete));
        }

        if (local.orcamentos_pedido_offline.frete_tipos_veiculos){
          this.frete_tipos_veiculos = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.frete_tipos_veiculos));
        }
        
        if (local.orcamentos_pedido_offline.outras_despesas){
          this.outras_despesas = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.outras_despesas));
        }

        if (local.orcamentos_pedido_offline.valor_desconto){
          this.valor_desconto = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.valor_desconto));
        }
        
        if (local.orcamentos_pedido_offline.perc_desconto_venda){
          this.perc_desconto_venda = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.perc_desconto_venda));
          await this.calcularDescontoCapaOrcamento('PERC');
        }

        if (local.orcamentos_pedido_offline.tipo_entrega){
          this.tipo_entrega = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.tipo_entrega));
          await this.verificarTipoEntrega(this.tipo_entrega);
        }
        
        if (local.orcamentos_pedido_offline.data_minima_entrega){
          this.data_minima_entrega = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.data_minima_entrega));
        }

        if (local.orcamentos_pedido_offline.tipo_agendamento_entrega){
          this.tipo_agendamento_entrega = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.tipo_agendamento_entrega));        
        }
        
        if (local.orcamentos_pedido_offline.produtos_selecionados){ 
          this.produtos_selecionados = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.produtos_selecionados));
        }

        if (local.orcamentos_pedido_offline.endereco_cliente_selecionado){
          this.endereco_cliente_selecionado = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.endereco_cliente_selecionado));
        }

        if (local.orcamentos_pedido_offline.definicoes_lotes){
          this.definicoes_lotes = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.definicoes_lotes));
        }

        if (local.orcamentos_pedido_offline.hash_pedido){
          this.hash_pedido = JSON.parse(JSON.stringify(local.orcamentos_pedido_offline.hash_pedido)); 
        }

        /* Parâmetros gerais */
        if (local.orcamentos_parametros_offline.par_consumidor_final_id){
          this.par_consumidor_final_id = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_consumidor_final_id));
        }

        if (local.orcamentos_parametros_offline.par_ger_utiliza_controle_cep){
          this.par_ger_utiliza_controle_cep = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_ger_utiliza_controle_cep));
        }

        if (local.orcamentos_parametros_offline.par_emp_condicao_mobile_id){
          this.par_emp_condicao_padrao_venda_id = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_condicao_padrao_venda_id));  
        }
        
        if (local.orcamentos_parametros_offline.par_emp_sugerir_cons_final_padrao_vda){
          this.par_emp_sugerir_cons_final_padrao_vda = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_sugerir_cons_final_padrao_vda));
        }
        
        if (local.orcamentos_parametros_offline.desconto_autorizado_vendedor){
          this.desconto_autorizado_vendedor = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.desconto_autorizado_vendedor));
        }
        
        if (local.orcamentos_parametros_offline.par_emp_permitir_ver_frete_na_venda){
          this.par_emp_permitir_ver_frete_na_venda = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_permitir_ver_frete_na_venda));
        }

        if (local.orcamentos_parametros_offline.par_emp_sempre_obrigar_end_entrega){
          this.par_emp_sempre_obrigar_end_entrega = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_sempre_obrigar_end_entrega));
        }

        if (local.orcamentos_parametros_offline.par_emp_tipo_agendamento_horario_ent){
          this.par_emp_tipo_agendamento_horario_ent = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_tipo_agendamento_horario_ent));
        }

        if (local.orcamentos_parametros_offline.par_emp_tipo_frete_manifesto){
          this.par_emp_tipo_frete_manifesto = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_tipo_frete_manifesto));
        }

        if (local.orcamentos_parametros_offline.par_emp_tipo_entregas_venda){
          this.par_emp_tipo_entregas_venda = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_tipo_entregas_venda));
        }

        if (local.orcamentos_parametros_offline.par_emp_questionar_uso_promocao){
          this.par_emp_questionar_uso_promocao = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_questionar_uso_promocao));
        }
        
        if (local.orcamentos_parametros_offline.par_emp_tipo_agendamento_entrega) {
          this.par_emp_tipo_agendamento_entrega = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_tipo_agendamento_entrega));
        }

        if (local.orcamentos_parametros_offline.tipo_cliente_bloqueado_venda){
          this.tipo_cliente_bloqueado_venda = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.tipo_cliente_bloqueado_venda));
        }

        if (local.orcamentos_parametros_offline.par_emp_gerar_bloq_proposta_orcamento){
          this.par_emp_gerar_bloq_proposta_orcamento = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_gerar_bloq_proposta_orcamento));
        }

        if (local.orcamentos_parametros_offline.par_emp_gerar_bloq_desc_f5_acima_aut){
          this.par_emp_gerar_bloq_desc_f5_acima_aut = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.par_emp_gerar_bloq_desc_f5_acima_aut));
        }

        if (local.orcamentos_parametros_offline.autorizado_visualizar_mix){
          this.autorizado_visualizar_mix = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.autorizado_visualizar_mix)); 
        }
        
        if (local.orcamentos_parametros_offline.autorizado_visualizar_lucratividade_mix){
          this.autorizado_visualizar_lucratividade_mix = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.autorizado_visualizar_lucratividade_mix));
        }
        
        if (local.orcamentos_parametros_offline.autorizado_visualizar_lucro_liquido_mix){
          this.autorizado_visualizar_lucro_liquido_mix = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.autorizado_visualizar_lucro_liquido_mix)); 
        }

        if (local.orcamentos_parametros_offline.autorizado_copiar_pedidos_venda){
          this.autorizado_copiar_pedidos_venda = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.autorizado_copiar_pedidos_venda)); 
        }

        if (local.orcamentos_parametros_offline.tipo_entrega_padrao){
          this.tipo_entrega_padrao = JSON.parse(JSON.stringify(local.orcamentos_parametros_offline.tipo_entrega_padrao));  
        }

        await this.reprocessamentoGeralPedido();
        this.carregando_pedido = false;
      },   

      async carregarDadosIniciaisTelaVendas(){
        try {
          this.carregando_dados_iniciais = true;

          let retorno = await ROrcamentoBuscarDadosIniciarPedido.buscarDadosIniciarPedido(this.axios);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          /* Parâmetros gerais */
          this.par_consumidor_final_id = retorno.dados.par_consumidor_final_id;  
          this.par_ger_utiliza_controle_cep = retorno.dados.par_ger_utiliza_controle_cep;
          this.par_ger_qtd_min_caract_pesq_produtos = Biblioteca.valorInt(retorno.dados.par_ger_qtd_min_caract_pesq_produtos);

          /* Parâmetros de empresas */
          this.par_emp_condicao_mobile_id = retorno.dados.par_emp_condicao_mobile_id;
          this.par_emp_condicao_padrao_venda_id = retorno.dados.par_emp_condicao_padrao_venda_id;
          this.par_emp_sugerir_cons_final_padrao_vda = retorno.dados.par_emp_sugerir_cons_final_padrao_vda;
          this.par_emp_questionar_uso_preco_atacado_vda = retorno.dados.par_emp_questionar_uso_pco_atacado_vda;
          /* Desconto autorizado */
          this.desconto_autorizado_vendedor = retorno.dados.aut_desconto_autorizado;
          /* Permitir ver frete */
          this.par_emp_permitir_ver_frete_na_venda = retorno.dados.par_emp_permitir_ver_frete_na_venda;
          /* Sempre obrigar end. entrega */
          this.par_emp_tipo_obrig_endereco_entrega = retorno.dados.par_emp_tipo_obrig_endereco_entrega;

          /* Autorização*/
          this.autorizado_visualizar_mix = retorno.dados.aut_verificar_mix_venda =='S' ? true : false;
          this.autorizado_visualizar_lucratividade_mix = retorno.dados.aut_permitir_visualizar_lucratividade_mix == 'S' ? true : false;
          this.autorizado_visualizar_lucro_liquido_mix = retorno.dados.aut_permitir_visualizar_lucro_liquido_mix == 'S' ? true : false;
          this.autorizado_copiar_pedidos_venda = retorno.dados.aut_copiar_pedidos_venda;

          /* Mostrar período ou hora quando entrega programada */
          this.par_emp_tipo_agendamento_horario_ent = retorno.dados.par_emp_tipo_agendamento_horario_ent;
          this.par_emp_tipo_frete_manifesto = retorno.dados.par_emp_tipo_frete_manifesto;
          this.par_emp_tipo_entregas_venda = retorno.dados.par_emp_tipo_entregas_venda;
          this.par_emp_tipo_agendamento_entrega = retorno.dados.par_emp_tipo_agendamento_entrega;

          /* Bloqueios de proposta de orçamento */
          this.par_emp_gerar_bloq_proposta_orcamento = retorno.dados.par_emp_gerar_bloq_proposta_orcamento;
          this.par_emp_gerar_bloq_desc_f5_acima_aut = retorno.dados.par_emp_gerar_bloq_desc_f5_acima_aut;

          this.tipo_agendamento_entrega = this.par_emp_tipo_agendamento_entrega == 'R' ? 'R' : 'E';
          this.par_emp_questionar_uso_promocao = retorno.dados.par_emp_questionar_uso_promocao;
          this.tipo_cliente_bloqueado_venda = retorno.dados.par_emp_tipo_cliente_bloqueado_venda;

          this.tipo_entrega_padrao = retorno.dados.par_emp_tipo_entrega_padrao;

          if (this.tipo_entrega_padrao == 'S' || this.tipo_entrega_padrao == 'O') {
            this.tipo_entrega = "ATO";
          } else if (this.tipo_entrega_padrao == 'R') {
            this.tipo_entrega = "ESP";
          } else if  (this.tipo_entrega_padrao == 'P') {
            this.tipo_entrega = "EPG";
          } else {
            this.tipo_entrega = "ATO";
          }

          await this.tiposAgendamentoEntrega();
          
          // Parâmetros
          let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));

          if (!armazenamentoLocalStorage){
            armazenamentoLocalStorage = {};
          }
          
          armazenamentoLocalStorage.orcamentos_parametros_offline = {};
          armazenamentoLocalStorage.orcamentos_parametros_offline.usuario_logado_id = retorno.dados.usuario_id;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_consumidor_final_id = this.par_consumidor_final_id;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_ger_utiliza_controle_cep = this.par_ger_utiliza_controle_cep;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_condicao_mobile_id = this.par_emp_condicao_mobile_id;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_condicao_padrao_venda_id = this.par_emp_condicao_padrao_venda_id;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_sugerir_cons_final_padrao_vda = this.par_emp_sugerir_cons_final_padrao_vda;
          armazenamentoLocalStorage.orcamentos_parametros_offline.desconto_autorizado_vendedor = this.desconto_autorizado_vendedor;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_permitir_ver_frete_na_venda = this.par_emp_permitir_ver_frete_na_venda;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_sempre_obrigar_end_entrega = this.par_emp_sempre_obrigar_end_entrega;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_tipo_agendamento_horario_ent = this.par_emp_tipo_agendamento_horario_ent;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_tipo_frete_manifesto = this.par_emp_tipo_frete_manifesto;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_tipo_entregas_venda = this.par_emp_tipo_entregas_venda;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_questionar_uso_promocao = this.par_emp_questionar_uso_promocao;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_tipo_agendamento_entrega = this.par_emp_tipo_agendamento_entrega;
          armazenamentoLocalStorage.orcamentos_parametros_offline.tipo_cliente_bloqueado_venda = this.tipo_cliente_bloqueado_venda;
          armazenamentoLocalStorage.orcamentos_parametros_offline.tipo_entrega_padrao = this.tipo_entrega_padrao;
          armazenamentoLocalStorage.orcamentos_parametros_offline.tipo_agendamento_entrega = this.tipo_agendamento_entrega;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_gerar_bloq_proposta_orcamento = this.par_emp_gerar_bloq_proposta_orcamento;
          armazenamentoLocalStorage.orcamentos_parametros_offline.par_emp_gerar_bloq_desc_f5_acima_aut = this.par_emp_gerar_bloq_desc_f5_acima_aut;
          // Autorizações
          armazenamentoLocalStorage.orcamentos_parametros_offline.autorizado_visualizar_mix = this.autorizado_visualizar_mix;
          armazenamentoLocalStorage.orcamentos_parametros_offline.autorizado_visualizar_lucratividade_mix = this.autorizado_visualizar_lucratividade_mix;
          armazenamentoLocalStorage.orcamentos_parametros_offline.autorizado_visualizar_lucro_liquido_mix = this.autorizado_visualizar_lucro_liquido_mix;
          armazenamentoLocalStorage.orcamentos_parametros_offline.autorizado_copiar_pedidos_venda = this.autorizado_copiar_pedidos_venda;

          // Armazenando parâmetros no local storage
          await localStorage.setItem('localStorage', JSON.stringify(armazenamentoLocalStorage));

          // Armazenando definições de entrega do pedido no local storage
          await this.armazenarLocalStorage('VALOR_FRETE', this.valor_frete);
          await this.armazenarLocalStorage('OUTRAS_DESPESAS', this.outras_despesas);
          await this.armazenarLocalStorage('DATA_ENTREGA', this.data_entrega);
          await this.armazenarLocalStorage('HORA_ENTREGA', this.hora_entrega);
          await this.armazenarLocalStorage('OBSERVACAO_ENDERECO', this.observacoes_endereco);
          await this.armazenarLocalStorage('TIPO_ENTREGA', 'ATO');
          await this.armazenarLocalStorage('TIPO_FRETE', this.tipo_frete);
          await this.armazenarLocalStorage('DEFINICOES_LOTE', this.definicoes_lotes);
          await this.armazenarLocalStorage('PERC_DESCONTO_VENDA', this.perc_desconto_venda); 
                        
          // Somente permitir trocar o vendedor quando autorizado
          if (retorno.dados.cargo_usuario_logado_id == 2) {
            this.bloquear_trocar_vendedor = 'N';

            if (retorno.dados.aut_alterar_vendedor_quando_usu_vendedor == 'N'){
              this.bloquear_trocar_vendedor = 'S';
            }
            
            await this.$refs.frVendedor.inserirDadoPorChave(retorno.dados.usuario_id);
          }

          if (this.par_emp_sugerir_cons_final_padrao_vda == 'S') {              
            this.cliente_consumidor_final = true;
            await this.$refs.frCliente.inserirDadoPorChave(this.par_consumidor_final_id);
          }

          this.carregando_dados_iniciais = false;
          await this.buscarPercValorFretePadrao() ;
        } catch (error) {
          this.verificarErro(error, 'carregarDadosIniciaisTelaVendas');
        }
      },

      async permitirCondicaoPagamentoCliente(condicao_pagamento, cliente, utilizar_condicao_padrao_venda){
        if (!condicao_pagamento.condicao_id) {
          return;
        }

        let resultado = true; 
        let produtos = [];

        if (condicao_pagamento.acumulativo_forma_pagamento == 'S' && cliente.ignorar_par_prod_perm_vend_acu == 'N'){
          for (let i = 0; i < this.produtos_selecionados.length; i++){
            produtos.push(            
              {
                produto_id: this.produtos_selecionados[i].produto_id,
                permitir_vender_acumulativo: this.produtos_selecionados[i].permitir_vender_acumulativo
              }
            )
          }
        }

        await this.verificarBloqueiosCondicaoPagamento(
          produtos,
          condicao_pagamento.condicao_id, 
          cliente.cadastro_id, 
          utilizar_condicao_padrao_venda
        ).then((retorno) => {}).catch((retorno) => {
          if (retorno.houve_erro == 'S') {
            swal(retorno.mensagem)
            resultado = false;
          }
        });

        if (utilizar_condicao_padrao_venda == 'S') {
          if (Biblioteca.valor(this.par_emp_condicao_padrao_venda_id) > 0){
            this.$refs.frCondicaoPagamento.inserirDadoPorChave(this.par_emp_condicao_padrao_venda_id);
          }
          else if (Biblioteca.valor(this.par_emp_condicao_mobile_id) > 0) {
            this.$refs.frCondicaoPagamento.inserirDadoPorChave(this.par_emp_condicao_mobile_id);
          }
        }

        return resultado;
      },

      async verificarDadosCondicaoPagamento(condicao_pagamento) {
        return await this.permitirCondicaoPagamentoCliente(condicao_pagamento, this.cliente_selecionado, 'N');
      },

      verificarBloqueiosCondicaoPagamento(produtos, condicao_pagamento_id, cliente_id, utilizar_condicao_padrao_venda){
        return new Promise(async (sucesso, fracasso) => {
          let verificacao  = {
            houve_erro: 'S',
            mensagem: ''
          }

          if (!cliente_id) {
            sucesso(verificacao);
            return;
          }

          if (!condicao_pagamento_id) {
            verificacao.mensagem = 'A condição de pagamento deve ser selecionado!';
            fracasso(verificacao);
            return;
          }

          this.processando = true;

          let parametros = {
            produtos: produtos,
            condicao_pagamento_id: condicao_pagamento_id,
            cliente_id: cliente_id,
            utilizar_condicao_padrao_venda: utilizar_condicao_padrao_venda
          }

          let retorno = await RCliente.verificarCondicaoPagamentoCliente(this.axios, parametros);

          this.processando = false;

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          if (retorno.dados.status == 'BLOQUEADO'){
            verificacao.mensagem = retorno.dados.mensagem_aviso;
            fracasso(verificacao);
          } else{
            verificacao.houve_erro = 'S';
            sucesso(verificacao);
          }
        });
      },

      async buscarEnderecosEntrega() {
        try {
          this.enderecos_cliente = [];

          let parametros = {
            cadastro_id: this.cliente_selecionado.cadastro_id 
          }

          let retorno = await REnderecoBuscarEnderecosEntrega.buscarEnderecosEntrega(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.enderecos_cliente = retorno.dados;
          await this.recalcularPrecosProdutos('NENHUM', 'N', false, true);
        } catch (error) {
          this.verificarErro(error, 'buscarEnderecosEntrega');  
        }
      },

      limparEndereco(){
        this.endereco_cliente_selecionado = {};
        this.observacoes_endereco = '';
        this.tipo_frete_andar = '';
        this.atualizarDefinicaoTipoEntregaEnderecoEntrega(false, false);
        this.$refs.frProdutosVenda.limparPesquisa(true);
      },

      verificarPropostaOrcamento(){
        if (this.par_emp_gerar_bloq_proposta_orcamento == 'S'){
          this.abrirModalFechamentoOrcamento = false;
          this.abrirModalOpcoesBloqueioProposta = true;
        }else{
          this.gravarOrcamento();  
        }
      },

      async gravarOrcamento(){
        try {        
          await this.calcularImpostosDescontoFechamentoPedido();

          this.abrirModalOpcoesBloqueioProposta = false;

          if (!this.cliente_selecionado.cadastro_id){
            Biblioteca.exclamar('O cliente deve ser selecionado!');
            return;
          }

          if (!this.vendedor_selecionado.funcionario_id) {
            Biblioteca.exclamar('O vendedor deve ser selecionado!');
            return;
          }

          if (!this.condicao_pagamento_selecionada.condicao_id){
            Biblioteca.exclamar('A condição de pagamento deve ser selecionada!');
            return;
          }

          var produtos_orcamento = [];

          for (let item of this.produtos_selecionados) {
            produtos_orcamento.push(
              {
                produto_id: item.produto_id,
                kit: item.kit,
                ponta_estoque: item.ponta_estoque,
                usou_preco_atacado: item.usou_preco_atacado,
                usou_promocao: item.usou_promocao,
                usou_promocao_especial: item.usou_promocao_especial,
                multiplo_venda: this.formatarValor(item.multiplo_venda, 3),
                valor_custo_extra_venda: this.formatarValor(item.valor_custo_extra_venda),
                indice_preco_clientes: this.formatarValor(item.indice_preco_clientes),
                indice_preco_ncm: this.formatarValor(item.indice_preco_ncm),
                peso: this.formatarValor(item.peso),
                preco_base_promocao: this.formatarValor(item.preco_base_promocao),
                quantidade: this.formatarValor(item.quantidade, 3),
                preco_manual: this.formatarValor(item.preco_manual, 2),
                preco_venda: this.formatarValor(item.preco),
                total_item: this.formatarValor(item.total_item, 2),
                preco_venda_oculto: this.formatarValor(item.preco_venda_oculto, 2),
                perc_desconto: this.formatarValor(item.perc_desconto, 2),
                preco_base: this.formatarValor(item.preco_base), 
                valor_total_ipi: this.formatarValor(item.valor_total_ipi, 2),
                valor_total_st: this.formatarValor(item.valor_total_st, 2),
                valor_total_fcp_st: this.formatarValor(item.valor_total_fcp_st, 2),
                perc_ipi: this.formatarValor(item.perc_ipi, 2)
              }
            );
          }
          
          if (this.definicoes_lotes) {
          
            await swal('Ao gerar o orçamento as definições de lote são perdidas!', {
              buttons: {
                sim: "OK",
              },
            })
          }

          await this.verificarPesoMaximoFrete();

          let abortar = false;
          if (this.mensagem_validacao_peso_frete){
            await swal(this.mensagem_validacao_peso_frete, {
              buttons: {
                sim: "Sim",
                nao: "Não",
              },
            })
            .then((value) => {
              switch (value) {
                case "nao":
                abortar = true;
              }  
            });
          }

          if (abortar){
            return;
          }

          this.processando = true;

          let hash_pedido_envio = await this.gerarHashPedidoEnvio();

          let parametros = {
            orcamento_id: this.orcamento_id, 
            cliente_id: this.cliente_selecionado.cadastro_id,
            consumidor_final: this.dados_consumidor_final,
            condicao_pagamento_id: this.condicao_pagamento_selecionada.condicao_id,
            vendedor_id: this.vendedor_selecionado.funcionario_id,
            valor_desconto: this.formatarValor(this.valor_desconto),
            vlr_desconto_preco_manual: this.formatarValor(this.valorDescontoTotalF5),
            valor_desconto_pis: this.formatarValor(this.valor_total_desconto_pis), 
            valor_desconto_cofins: this.formatarValor(this.valor_total_desconto_cofins),
            valor_produtos_com_desc_pis_cofins: this.formatarValor(this.valor_produtos_com_desc_pis_cofins),
            valor_total_st: this.formatarValor(this.valor_total_st),
            valor_total_fcp_st: this.formatarValor(this.valor_total_fcp_st),
            valor_total_ipi: this.formatarValor(this.valor_total_ipi),
            itens_orcamento: produtos_orcamento,
            valor_total: this.formatarValor(this.valor_total_produtos),
            total_normal: this.formatarValor(this.total_preco_normal),
            peso_total: this.formatarValor(this.peso_total_produtos),
            logradouro: this.endereco_cliente_selecionado.logradouro,
            complemento: this.endereco_cliente_selecionado.complemento, 
            bairro_id: this.endereco_cliente_selecionado.bairro_id,
            cep: this.endereco_cliente_selecionado.cep,
            ponto_referencia: this.endereco_cliente_selecionado.ponto_referencia,
            tipo_imovel: this.endereco_cliente_selecionado.tipo_imovel,
            tipo_acesso_imovel: this.endereco_cliente_selecionado.tipo_acesso_imovel,
            andar: this.endereco_cliente_selecionado.andar,
            inscricao_estadual: this.endereco_cliente_selecionado.inscricao_estadual,
            tipo_frete: this.tipo_frete,
            valor_frete: this.formatarValor(this.valor_frete),
            frete_adicional_andar: this.formatarValor(this.frete_adicional_andar),
            valor_frete_terceirizado: this.formatarValor(this.valorTotalFretesTerceirizados),
            outras_despesas: this.formatarValor(this.outras_despesas),
            tipo_entrega: this.tipo_entrega,
            tipos_veiculos: this.freteTiposVeiculosSelecionados,
            tipo_agendamento_entrega: this.tipo_agendamento_entrega,
            observacoes_endereco: this.observacoes_endereco,
            data_entrega: moment(this.data_entrega, 'YYYY/MM/DD').format('DD/MM/YYYY'),
            hora_entrega: this.hora_entrega,
            data_minima_entrega: this.data_minima_entrega,
            hash_pedido_front: hash_pedido_envio,
            // Parâmetros para bloqueio proposta
            usuario_redefiniu_lote: this.usuario_redefiniu_lote,
            opcao_gravacao_proposta: this.opcao_gravacao_proposta
          }

          let retorno = await ROrcamentoGravarOrcamento.gravarOrcamento(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.processando = false;

          if (retorno.dados.status == 'Erro'){
            if (retorno.dados.produtos_multiplos){
              for (let i = 0; i < retorno.dados.produtos_multiplos.length; i++) {
                Biblioteca.exclamar('O produto ' + this.formatarValor(retorno.dados.produtos_multiplos[i].produto_id, 0) + ' está com a quantidade informada que não corresponde ao múltiplo de venda do produto. Quantidade sugerida: ' + retorno.dados.produtos_multiplos[i].quantidade_sugestao);
              }
            }
            else{
              if (retorno.dados.retorno_str && retorno.dados.retorno_str == 'MC'){
                Biblioteca.exclamar('O(s) produto(s) ' + retorno.dados.msg +  ' está(ão) bloqueado(s) para venda ');
                return;
              }

              Biblioteca.exclamar('Não foi possivel gravar o pedido. ' + retorno.dados.msg);
            }

            return;
          }
          else {
            if (retorno.dados.bloqueado == 'S'){
              let mensagem = retorno.dados.orcamento_id ? "Orçamento: " + retorno.dados.orcamento_id : '';
      
              swal({
                title: "Orçamento bloqueado!",
                text: mensagem,
                icon: "warning",
                button: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    closeModal: true,
                  },
                },
              })
              .then((value) => {
                this.recarregarComponente();
                this.abrirModalFechamentoOrcamento = false;
              });
            }
            else if (retorno.dados.liberar_impressao_proposta == 'N'){
              let mensagem = retorno.dados.orcamento_id ? "Orçamento: " + retorno.dados.orcamento_id : '';
      
              swal({
                title: "Orçamento gravado com sucesso.",
                text: mensagem,
                icon: "success",
                button: {
                  confirm: {
                    text: "OK",
                    value: true,
                    visible: true,
                    closeModal: true,
                  },
                },
              })
              .then((value) => {
                this.recarregarComponente();
                this.abrirModalFechamentoOrcamento = false;
              });
            }
            else if(retorno.dados.liberar_impressao_proposta == 'S') {
              swal({
                title: "Orçamento gravado com sucesso. Deseja visualizar as opções da proposta?",
                text: "Orçamento: " + retorno.dados.orcamento_id,
                icon: "success",
                buttons: {
                  sim: "Sim",
                  nao: "Não",
                },
              })
              .then((value) => {
                switch (value) {
                  case "sim":
                    this.abrirModalFechamentoOrcamento = false;
                    this.imprimirPropostaOrcamento('S', retorno.dados.orcamento_id);
                    break;
                  default:
                    this.recarregarComponente();
                    this.abrirModalFechamentoOrcamento = false;
                    break;
                }
              });
            }
          }
        } catch (error) {
          this.verificarErro(error, 'gravarOrcamento')   
        }
      },

      imprimirPropostaOrcamento(recarregar_tela, orcamento_id){
        this.recarregar_tela = recarregar_tela;
        this.$refs.modalImpressaoPropostaOrcamento.abrir(orcamento_id);
      },

      buscarPeloCodigoBarras(codigo){
        /* segundo parametro é referente ao indice de pesquisa para codigo de barras*/
        this.$refs.frProdutosVenda.inserirDadoPorChave(codigo, 2);
      },

      async removerProdutoOrcamento(produto_id){
        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          if (this.produtos_selecionados[i].produto_id == produto_id){
            this.produtos_selecionados.splice(i, 1);
            break;
          }
        }

        let i = 0;
        while (true) {
          if (i >= this.definicoes_lotes.length)
            break;

          if (this.definicoes_lotes[i].produto_id == this.produto_selecionado_editando.produto_id){
            this.definicoes_lotes.splice(i, 1); // Removendo do array as definições do produto selecionado
          }
          else{
            i++;
          }
        }      

        for (let i = 0; i < this.produtos_filtrados.length; i++) {
          if (this.produtos_filtrados[i].produto_id == produto_id){
            this.produtos_filtrados[i].adicionado = false;
            this.produtos_filtrados[i].perc_desconto = 0;

            this.produtos_filtrados[i].perc_desconto_temp = 0;
            break;
          }
        }

        await this.buscarFreteRota();
        await this.buscarFreteAdicionalPorAndar();
        await this.recalcularTotaisPedido(true);

        this.abrirModalOpcoesProduto = false;
      },

      verificarDadosCliente(cliente) {
        if (this.tipo_cliente_bloqueado_venda != 'N') {

          if ((this.tipo_cliente_bloqueado_venda == 'C') && (cliente.tipo_cliente == 'C')) {
            swal('Não é permitido realizar vendas para clientes contribuintes do ICMS!');
            return false;
          }

          else if ((this.tipo_cliente_bloqueado_venda == 'T') && (cliente.tipo_cliente == 'N')) {
            swal('Não é permitido realizar vendas para clientes não contribuintes do ICMS!');
            return false;
          }
          else if ((this.tipo_cliente_bloqueado_venda == 'A') && ((cliente.tipo_cliente == 'C') || (cliente.tipo_cliente == 'N'))) {
            swal('Não é permitido realizar vendas para clientes contribuintes do ICMS e não contribuintes do ICMS!');
            return false;
          }
          else if ((this.tipo_cliente_bloqueado_venda == 'F') && (cliente.tipo_cliente == 'F')) {
            swal('Não é permitido realizar vendas para clientes do tipo pessoa fí­sica!');
            return false;
          }
        }        

        if (cliente.utilizar_desc_imp_retido == 'S') {
          swal('Não é permitido realizar vendas para clientes que possui desconto de imposto retido!');
          return false;
        }

        if (cliente.perc_desc_cofins > 0 || cliente.perc_desc_pis > 0) {
          swal({
            title: "Cliente indisponível na web",
            text: 'Não é permitido realizar vendas para clientes que possuam o direito de desconto em pis ou cofins!',
            icon: "error",
            button: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                closeModal: true,
              },
            },
          })

          return false;
        }

        return true;
      },

      async carregarDadosCliente(cliente, carregar_frame){
        this.cliente_consumidor_final = (Biblioteca.valorInt(this.par_consumidor_final_id) == Biblioteca.valorInt(cliente.cadastro_id));
        this.cliente_selecionado = JSON.parse(JSON.stringify(cliente));

        if (carregar_frame){
          await this.$refs.frCliente.carregar(this.cliente_selecionado);
        }
      },

      async adicionarCliente(cliente){
        this.limparConsumidorFinal();
        this.$refs.frProdutosVenda.limparPesquisa(true);
        if (!this.verificarDadosCliente(cliente)) {
          return;
        }
        
        await this.carregarDadosCliente(cliente, false);
        await this.buscarAvisosRestricoesCliente('tpCampoCliente', true, this.carregando_pedido, false);
        
        if (this.carregando_pedido) {
          this.configurarCarregandoPedido();
        } else {
          this.endereco_cliente_selecionado = {};
          await this.recalcularPrecosProdutos('NENHUM', 'N', false, true);
        }

        await this.buscarTipoPreco();
      },

      carregarDadosVendedor(vendedor){
        this.vendedor_selecionado = JSON.parse(JSON.stringify(vendedor));
      },

      async adicionarVendedor(vendedor){
        await this.carregarDadosVendedor(vendedor);
      },
      carregarDadosCondicaoPagamento(condicao_pagamento, carregar_frame){
        this.condicao_pagamento_selecionada = JSON.parse(JSON.stringify(condicao_pagamento));
        
        if (carregar_frame){
          this.$refs.frCondicaoPagamento.carregar(this.condicao_pagamento_selecionada, true);
        }
      },

      async adicionarCondicaoPagamento(condicao_pagamento) {
        this.carregarDadosCondicaoPagamento(condicao_pagamento, false);

        if (!this.processando_restricoes){
          await this.buscarAvisosRestricoesCliente('tpCampoCondicaoPagamento', true, false, false);
        }

        let possui_produto_ponta_estoque = false;
        let possui_produto_com_desconto = false;

        if (this.condicao_pagamento_selecionada.aceitar_promocao_especial == 'N' || this.condicao_pagamento_selecionada.conceder_preco_promocional == 'N' || this.condicao_pagamento_selecionada.permitir_uso_ponta_estoque){
          let possui_produto_promocao = false;

          for (let i = 0; i < this.produtos_selecionados.length; i++) {
            if (this.produtos_selecionados[i].usou_promocao_especial == 'S' && this.condicao_pagamento_selecionada.aceitar_promocao_especial == 'N'){ 
              this.produtos_selecionados[i].usou_promocao_especial = 'N';
              this.produtos_selecionados[i].usou_promocao = 'N';
              possui_produto_promocao = true;
            } 

            if (this.produtos_selecionados[i].usou_promocao == 'S' && this.condicao_pagamento_selecionada.conceder_preco_promocional == 'N'){              
              this.produtos_selecionados[i].usou_promocao = 'N';
              possui_produto_promocao = true;
            }

            if (this.condicao_pagamento_selecionada.permitir_uso_ponta_estoque == 'N' && this.produtos_selecionados[i].ponta_estoque){
              this.produtos_selecionados[i].ponta_estoque  = false;
              possui_produto_ponta_estoque = true;
            }

            if (this.produtos_selecionados[i].valor_desconto != 0){
              possui_produto_com_desconto = true;
            }
          }
    
          if (possui_produto_promocao){
            swal('Os produtos ou alguns produtos que utilizavam preço promocional voltaram ao preço padrão pois a nova condição não permite promoção. Por favor, reveja os preços.');
          }  

          if (possui_produto_ponta_estoque){
            swal('Os produtos ou alguns produtos que utilizavam ponta de estoque voltaram ao preço padrão pois a nova condição não permite ponta de estoque. Por favor, reveja os preços.');
          }
        }

        if (this.indice_condicao_pagamento_selecionada && possui_produto_com_desconto){
          if (Biblioteca.valor(this.indice_condicao_pagamento_selecionada) > Biblioteca.valor(this.condicao_pagamento_selecionada.indice)){
            await this.reprocessarNovaCondicaoPagamento('MANTER_VALOR');
          } else if (this.par_emp_gerar_bloq_desc_f5_acima_aut == 'S'){
            this.abrirModalOpcoesDesconto = true;
          } else{
            swal('Os produtos que utilizavam preço manual voltaram ao preço padrão pois o índice da nova condição é maior que o da anterior. Por favor, reveja os preços.');
            await this.reprocessarNovaCondicaoPagamento('REFAZER_PRECO');
          }
        } else{
          await this.reprocessarNovaCondicaoPagamento('NENHUM');
        }

        this.indice_condicao_pagamento_selecionada = this.condicao_pagamento_selecionada.indice;
      },

      confirmarTipoNegociacaoPreco(){
        this.reprocessarNovaCondicaoPagamento(this.opcao_tipo_negociacao_preco);
        this.opcao_tipo_negociacao_preco = '';
        this.abrirModalOpcoesDesconto = false;
      },

      async reprocessarNovaCondicaoPagamento(tipo_negociacao_preco){
        await this.recalcularPrecosProdutos(tipo_negociacao_preco, 'N', false, true);
        await this.buscarTipoPreco();
        this.$refs.frProdutosVenda.limparPesquisa(true);
      },

      buscarProdutoPorCodigoArrayItens(produto_id){
        let produto_encontrado = undefined;

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          if (Biblioteca.valor(this.produtos_selecionados[i].produto_id) == Biblioteca.valor(produto_id)) {
            produto_encontrado = Object.assign({}, this.produtos_selecionados[i]);
            break;
          }  
        }

        return produto_encontrado; 
      },

      async adicionarProduto(produto){
        this.produto_selecionado = {};
        this.produto_selecionado = JSON.parse(JSON.stringify(produto));
        this.quantidade_produto_selecionado = produto.quantidade_edicao;        
        this.produto_selecionado.estoque_ato = this.formatarValor(parseFloat(this.produto_selecionado.estoque_ato));
        this.produto_selecionado.preco_atacado = this.formatarValor(parseFloat(this.produto_selecionado.preco_atacado));

        // Verificando se o produto já existe no pedido
        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          if(Biblioteca.valorInt(this.produtos_selecionados[i].produto_id) == Biblioteca.valorInt(this.produto_selecionado.produto_id)){
            swal('Este produto já foi lançado na linha ' + (i + 1) + ' do pedido!');
            produto.foi_adicionado = true;
            return;
          }  
        }

        if 
          (
            (this.condicao_pagamento_selecionada.acumulativo_forma_pagamento == 'S') && 
            (this.produto_selecionado.permitir_vender_acumulativo == 'N') &&
            (this.cliente_selecionado.ignorar_par_prod_perm_vend_acu == 'N')
          )
        {
          swal('Não é permitido inserir um item que não permite venda em acumulativo em pedidos com pagamento em Acumulativo!');  
          return;
        }

        if (this.produto_selecionado.valor_desconto != 0){
          this.produto_selecionado.desconto_alterado = true;  
        } else{
          this.produto_selecionado.perc_desconto = 0;
          this.produto_selecionado.valor_desconto = 0;
          this.produto_selecionado.desconto_alterado = false;
        }

        if (this.produto_selecionado.preco_alterado){
          this.produto_selecionado.usou_promocao = 'N'; 
          this.produto_selecionado.ponta_estoque = false;
        }

        let retorno = await this.inserirAtualizarQuantidadeProduto(produto.questionar_multiplo_aviso_venda);
        
        if (retorno){
          produto.foi_adicionado = true;
          produto.quantidade_edicao = '';
        }
      },

      async inserirAtualizarQuantidadeProduto(questionar_multiplo_aviso_venda){
        this.adicionando_produtos = true;
        
        if ((this.quantidade_produto_selecionado == '') || (Biblioteca.valor(this.quantidade_produto_selecionado) <= 0)) {
          Biblioteca.exclamar("É necessário inserir a quantidade de itens!");
          this.adicionando_produtos = false;
          return false;
        }
        
        if (this.temDecimais(this.quantidade_produto_selecionado) && this.produto_selecionado.permite_venda_fracionada == 'N') {
          Biblioteca.exclamar("Este produto não permite venda fracionada!");
          this.adicionando_produtos = false;
          return false;
        }

        await this.atualizaQuantidadeProduto();

        if (this.adicionando_produto_direto){
          this.$refs.frProdutosVenda.fechar(true);
          this.adicionando_produto_direto = false;
        }

        let retornoRecalcularPrecos = await this.recalcularPrecosProdutos('NENHUM', 'N', questionar_multiplo_aviso_venda, false);

        // Definindo lote da ponta de estoque
        let produto_adicionado = await this.buscarProdutoPorCodigoArrayItens(this.produto_selecionado.produto_id);
        if (produto_adicionado){
          if (produto_adicionado.ponta_estoque){
            await swal(
              'Definir o lote da ponte de estoque agora?', 
              {
                buttons: {
                  sim: "Sim",
                  nao: "Não"                
                },
              }
            ).then(async (value) => {
              switch (value) {
                case "sim": 
                  await this.definirProdutoSelecionado(produto_adicionado);
                  await this.definirLoteProdutoSelecionado();
              }
            });
          } else {
            await this.definirLoteEmGrade();
          }
        }

        return retornoRecalcularPrecos;
      },

      async definirLoteEmGrade(){
        // Removendo as definições de lote atual
        let i = 0;
        while (true) {
          if (i >= this.definicoes_lotes.length)
            break;

          if (this.definicoes_lotes[i].produto_id == this.produto_selecionado.produto_id){
            this.definicoes_lotes.splice(i, 1); // Removendo do array as definições do produto selecionado
          }
          else{
            i++;
          }
        }

        if (this.produto_selecionado.tipo_controle_estoque == 'G'){
          this.produto_selecionado_editando = Object.assign({}, this.produto_selecionado);
          await this.definirLoteProdutoSelecionado();
        }
      },

      async atualizaQuantidadeProduto(){
        this.produto_selecionado.total_item = Biblioteca.valor(this.produto_selecionado.total_item);

        if (!this.produto_selecionado.adicionado){
          this.produto_selecionado.adicionado = true;
          this.produto_selecionado.quantidade = this.quantidade_produto_selecionado;
          
          if (this.alterando_preco_produto){
            this.produtos_selecionados.splice(this.produto_selecionado.posicao, 0, Object.assign({}, this.produto_selecionado))
          } else{
            this.produtos_selecionados.push(Object.assign({}, this.produto_selecionado));
          }
        }
        else {
          for (let j = 0; j < this.produtos_selecionados.length; j++) {
            if (this.produtos_selecionados[j].produto_id == this.produto_selecionado.produto_id){
              this.produto_selecionado.quantidade = this.quantidade_produto_selecionado;
              this.produtos_selecionados[j].preco = this.produto_selecionado.preco;
              this.produtos_selecionados[j].preco_venda_oculto = this.produto_selecionado.preco_venda_oculto;
              this.produtos_selecionados[j].quantidade = this.quantidade_produto_selecionado;
              this.produtos_selecionados[j].valor_total_ipi = this.produto_selecionado.valor_total_ipi;
              this.produtos_selecionados[j].valor_total_st = this.produto_selecionado.valor_total_st;
              this.produtos_selecionados[j].valor_total_fcp_st = this.produto_selecionado.valor_total_fcp_st;
              this.produtos_selecionados[j].ponta_estoque = this.produto_selecionado.ponta_estoque;
              this.produtos_selecionados[j].usou_promocao = this.produto_selecionado.usou_promocao;
              this.produtos_selecionados[j].usou_promocao_especial = this.produto_selecionado.usou_promocao_especial;
              this.produtos_selecionados[j].preco_unitario_com_imposto = this.produto_selecionado.preco_unitario_com_imposto;
              this.produtos_selecionados[j].usou_preco_atacado = this.produto_selecionado.usou_preco_atacado;
              this.produtos_selecionados[j].perc_desconto = this.produto_selecionado.perc_desconto;
              this.produtos_selecionados[j].valor_desconto = this.produto_selecionado.valor_desconto;
              this.produtos_selecionados[j].desconto_alterado = this.produto_selecionado.desconto_alterado;

              break;
            }
          }
        }
            
        await this.recalcularTotaisPedido(false);      
        await this.buscarFreteRota();
        await this.buscarFreteAdicionalPorAndar();
        await this.calcularTotaisFechamentoPedido();

        this.abrirModalAtualizarQuantidade = false;
        this.quantidade_produto_selecionado = '';
      },

      carregarDadosEndereco(endereco){
        this.endereco_cliente_selecionado = JSON.parse(JSON.stringify(endereco));
      },

      async adicionarEndereco(endereco){
        await this.carregarDadosEndereco(endereco);

        this.tipo_frete_andar = '';
        this.atualizarDefinicaoTipoEntregaEnderecoEntrega(false, true);
        this.$refs.frProdutosVenda.limparPesquisa(true);
        this.abrirModalSelecionarEnderecosCliente = false;
      },

      calcularTotaisFechamentoPedido: function(){
        let total_produto_ponta_estoque = 0;

        if (this.valor_dinheiro == ''){
          this.valor_dinheiro = 0;
        }
        
        if (this.valor_cartao_db == ''){
          this.valor_cartao_db = 0;
        }
        
        if (this.valor_cartao_cr == ''){
          this.valor_cartao_cr = 0;
        }
        
        if (this.valor_cheque_vista == ''){
          this.valor_cheque_vista = 0;
        }

        if (this.valor_cheque_prazo == ''){
          this.valor_cheque_prazo = 0;
        }

        if (this.valor_duplicata_boleta == ''){
          this.valor_duplicata_boleta = 0;
        }

        if (this.valor_acumulativo == ''){
          this.valor_acumulativo = 0;
        }

        if (this.valor_pix == ''){
          this.valor_pix = 0;
        }

        if (this.valor_credito == ''){
          this.valor_credito = 0;
        }

        if (isNaN(this.valor_desconto)){
          this.valor_desconto = 0;
        }
          
        this.total_liquido = 
          (
            Biblioteca.valor(this.valor_total_produtos) - 
            Biblioteca.valor(this.valor_desconto) - 
            Biblioteca.valor(this.valor_total_desconto_pis) -
            Biblioteca.valor(this.valor_total_desconto_cofins) +
            Biblioteca.valor(this.valor_total_ipi) + 
            Biblioteca.valor(this.valor_total_st) + 
            Biblioteca.valor(this.valor_total_fcp_st) + 
            Biblioteca.valor(this.valor_tac) + 
            Biblioteca.valor(this.total_despesas)
          ).toFixed(2);

        this.total_formas_pagamento = 
          Biblioteca.valor(this.valor_dinheiro) + 
          Biblioteca.valor(this.valor_cartao_db) + 
          Biblioteca.valor(this.valor_cartao_cr) + 
          Biblioteca.valor(this.valor_cheque_vista) +
          Biblioteca.valor(this.valor_cheque_prazo) +
          Biblioteca.valor(this.valor_duplicata_boleta) +
          Biblioteca.valor(this.valor_acumulativo) +
          Biblioteca.valor(this.valor_pix) +
          Biblioteca.valor(this.valor_credito);

        let total_preco_venda_oculto_sem_promocao = 0;
        let somente_produto_promocao = true; 
        this.permitido_aplicar_desconto = false;

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          
          if (this.produtos_selecionados[i].usou_promocao == 'N'){
            total_preco_venda_oculto_sem_promocao += this.produtos_selecionados[i].preco_venda_oculto * this.produtos_selecionados[i].quantidade;
            somente_produto_promocao = false;
          }
          
          if (this.produtos_selecionados[i].ponta_estoque)
            total_produto_ponta_estoque += this.produtos_selecionados[i].total_item
          }

        // Caso possua somente produtos em promoção selecionado não permitir aplicar desconto na tela de fechamento
        if (!somente_produto_promocao){
          this.permitido_aplicar_desconto = true;
        }
        
        this.calculando_desconto_percentual = false;
        this.total_preco_normal = this.valor_total_produtos - this.total_preco_promocao;
      },

      async confirmarBuscarEntregasAto(retorno){        
        this.recebimento_na_entrega = retorno.recebimento_na_entrega;
        this.tipo_contato_cliente = retorno.tipo_contato_cliente;
        this.definicoes_lotes = retorno.definicoes_lotes;

        this.usuario_redefiniu_lote = retorno.usuario_redefiniu_lote;

        if (this.tipo_entrega == 'ESA' && retorno.tipo_agendamento_entrega){
          this.tipo_agendamento_entrega = retorno.tipo_agendamento_entrega;     
          
          if (retorno.tipo_agendamento_entrega == 'P'){ 
            this.data_minima_entrega = retorno.data_minima_entrega;
          }
        }

        if (retorno.novo_tipo_entrega != '?' ){
          this.tipo_entrega = retorno.novo_tipo_entrega;
          this.atualizarDefinicaoTipoEntregaEnderecoEntrega(false, false);
        }

        if (retorno.data_entrega){
          this.data_entrega = retorno.data_entrega;
          this.hora_entrega = retorno.hora_entrega;
        }

        this.frete_rota = retorno.frete_rota ? retorno.frete_rota : {};
        this.frete_adicional_andar = retorno.frete_adicional_andar_escada;
        this.frete_tipos_veiculos = retorno.frete_tipos_veiculos ? retorno.frete_tipos_veiculos : [];

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          for (let j = 0; j < retorno.itens_entrega_ato.length; j++) {
            if (this.produtos_selecionados[i].produto_id == retorno.itens_entrega_ato[j].produto_id){
              
              this.produtos_selecionados[i].quantidade_agendar = retorno.itens_entrega_ato[j].qtd_agendar;
              this.produtos_selecionados[i].retirar_lojas_rede = retorno.itens_entrega_ato[j].retirar_lojas_rede;
              this.produtos_selecionados[i].empresa_retirar_lojas_rede_id = retorno.itens_entrega_ato[j].empresa_retirar_lojas_rede_id;
              this.produtos_selecionados[i].exigir_nfe_inves_cupom = retorno.itens_entrega_ato[j].exigir_nfe_inves_cupom;

              this.produtos_selecionados[i].tipo_selec_local_entrega_ato = retorno.itens_entrega_ato[j].tipo_selec_local_entrega_ato;
              this.produtos_selecionados[i].quantidade_entrega_ato_loj = retorno.itens_entrega_ato[j].tipo_selec_local_entrega_ato != 'N' ? retorno.itens_entrega_ato[j].qtd_entrega_ato : 0;
              this.produtos_selecionados[i].quantidade_entrega_ato_dep = retorno.itens_entrega_ato[j].qtd_entrega_ato_dep;
              this.produtos_selecionados[i].quantidade_entrega_ato_exp = retorno.itens_entrega_ato[j].qtd_entrega_ato_exp;
              
              this.produtos_selecionados[i].tipo_local_padrao_entrega_ato = retorno.itens_entrega_ato[j].tipo_local_padrao_entrega_ato;
              this.produtos_selecionados[i].qtd_sem_agendamento = retorno.itens_entrega_ato[j].qtd_sem_previsao;
              this.produtos_selecionados[i].previsao_entrega_sem_agen = retorno.itens_entrega_ato[j].data_previsao_entrega;

              this.produtos_selecionados[i].quantidade_entrega_ato = retorno.itens_entrega_ato[j].tipo_selec_local_entrega_ato == 'N' ? retorno.itens_entrega_ato[j].qtd_entrega_ato : retorno.itens_entrega_ato[j].qtd_entrega_ato + retorno.itens_entrega_ato[j].qtd_entrega_ato_dep + retorno.itens_entrega_ato[j].qtd_entrega_ato_exp;

              break;
            }
          }
        }

        await this.verificarPesoMaximoFrete(retorno.peso_total_entrega);

        let abortar = false;
        if (this.mensagem_validacao_peso_frete){
          await swal(this.mensagem_validacao_peso_frete, {
            buttons: {
              sim: "Sim",
              nao: "Não",
            },
          })
          .then((value) => {
            switch (value) {
              case "nao":
              abortar = true;
            }  
          });
        }

        if (abortar){
          return;
        }
        
        this.$refs.modal_ato.cancelarBuscarEntregasNoAto();

        await this.configurarFormasPagamentoFechamentoPedido();
        await this.calcularTotaisFechamentoPedido();
        await this.recalcularTotaisPedido(true);
        await this.calcularTotaisFechamentoPedido();
        
        this.abrirModalFecharPedido = true;
      },

      async fecharPedido(usuario_lib_credito_id){
        try {

          if (isNaN(this.total_liquido)){
            return
          }

          await this.calcularImpostosDescontoFechamentoPedido();

          if (!this.cliente_selecionado.cadastro_id){
            Biblioteca.exclamar('O cliente deve ser selecionado!');
            return;
          }

          if (!this.vendedor_selecionado.funcionario_id) {
            Biblioteca.exclamar('O vendedor deve ser selecionado!');
            return;
          }

          if (!this.condicao_pagamento_selecionada.condicao_id){
            Biblioteca.exclamar('A condição de pagamento deve ser selecionada!');
            return;
          }

          if (Biblioteca.valor(this.total_formas_pagamento) > Biblioteca.valor(this.total_liquido) && (!usuario_lib_credito_id)){
            await swal({
              title: "Atenção",
              text: "O total de pagamentos informado é superior ao total da operação. " +
              "Isto fará com que um crédito seja gerado para o cliente. Deseja continuar?",
              icon: "warning",
              buttons: {
                sim: "Sim",
                nao: "Não",
              },
            }).
            then((value) => {
              switch (value) {
                case "sim": this.$refs.certificar.abrir();
              }
            });

            return;
          } else {
            usuario_lib_credito_id = 0;
          }

          if (Biblioteca.valor(this.total_formas_pagamento) < Biblioteca.valor(this.total_liquido)){
            Biblioteca.exclamar(
              'O total das formas de pagamento deve ser igual ao total líquido! ' + 
              'Total liquido: ' + this.formatarValor(this.total_liquido) + ' total formas de pagamento: ' + this.formatarValor(this.total_formas_pagamento)
            );
            return;
          }

          var produtos_orcamento = [];

          for (let item of this.produtos_selecionados) {
            produtos_orcamento.push(
              {
                produto_id: item.produto_id,
                kit: item.kit,
                previsao_entrega_sem_agen: item.previsao_entrega_sem_agen,
                tipo_local_padrao_entrega_ato: item.tipo_local_padrao_entrega_ato,
                tipo_selec_local_entrega_ato: item.tipo_selec_local_entrega_ato,
				        retirar_lojas_rede: item.retirar_lojas_rede,
				        empresa_retirar_lojas_rede_id: item.empresa_retirar_lojas_rede_id,
                ponta_estoque: item.ponta_estoque,
                usou_preco_atacado: item.usou_preco_atacado,
                usou_promocao: item.usou_promocao,
                usou_promocao_especial: item.usou_promocao_especial,
                multiplo_venda: this.formatarValor(item.multiplo_venda, 3),
                valor_custo_extra_venda: this.formatarValor(item.valor_custo_extra_venda),
                indice_preco_clientes: this.formatarValor(item.indice_preco_clientes),
                indice_preco_ncm: this.formatarValor(item.indice_preco_ncm),
                peso: this.formatarValor(item.peso),
                preco_base_promocao: this.formatarValor(item.preco_base_promocao),
                quantidade: this.formatarValor(item.quantidade),
                preco_manual: this.formatarValor(item.preco_manual),
                preco_venda: this.formatarValor(item.preco),
                total_item: this.formatarValor(item.total_item),
                preco_venda_oculto: this.formatarValor(item.preco_venda_oculto),
                perc_desconto: this.formatarValor(item.perc_desconto),
                preco_base: this.formatarValor(item.preco_base), 
                valor_total_ipi: this.formatarValor(item.valor_total_ipi),
                valor_total_st: this.formatarValor(item.valor_total_st),
                valor_total_fcp_st: this.formatarValor(item.valor_total_fcp_st),
                perc_ipi: this.formatarValor(item.perc_ipi),
                quantidade_entrega_ato: this.formatarValor(item.quantidade_entrega_ato, 3),
                quantidade_entrega_ato_loj: this.formatarValor(item.quantidade_entrega_ato_loj, 3),
                quantidade_entrega_ato_dep: this.formatarValor(item.quantidade_entrega_ato_dep, 3),
                quantidade_entrega_ato_exp: this.formatarValor(item.quantidade_entrega_ato_exp, 3),
                quantidade_agendar: this.formatarValor(item.quantidade_agendar, 3),
		            qtd_sem_agendamento: this.formatarValor(item.qtd_sem_agendamento, 3),
                exigir_nfe_inves_cupom:item.exigir_nfe_inves_cupom,
                estoque_agendamento: item.estoque_agendamento
              }
            );
          }

          var produtos_lotes = [];
          for (let i = 0; i < this.definicoes_lotes.length; i++) {
            produtos_lotes[i] = Object.assign({}, this.definicoes_lotes[i]);
            produtos_lotes[i].quantidade_ent_ato = this.formatarValor(produtos_lotes[i].quantidade_ent_ato);          
            produtos_lotes[i].quantidade_agendar = this.formatarValor(produtos_lotes[i].quantidade_agendar);
          }

          this.processando = true;
          
          let hash_pedido_envio = await this.gerarHashPedidoEnvio();

          let parametros = {
            orcamento_id: this.orcamento_id,
            cliente_id: this.cliente_selecionado.cadastro_id,
            consumidor_final: this.dados_consumidor_final,
            condicao_pagamento_id: this.condicao_pagamento_selecionada.condicao_id,
            vendedor_id: this.vendedor_selecionado.funcionario_id,
            valor_desconto: this.formatarValor(this.valor_desconto),
            vlr_desconto_preco_manual: this.formatarValor(this.valorDescontoTotalF5),
            valor_total_st: this.formatarValor(this.valor_total_st),
            valor_total_fcp_st: this.formatarValor(this.valor_total_fcp_st),
            valor_total_ipi: this.formatarValor(this.valor_total_ipi),
            itens_orcamento: produtos_orcamento,
            valor_dinheiro: this.formatarValor(this.valor_dinheiro),
            valor_cartao_cr: this.formatarValor(this.valor_cartao_cr),
            valor_cartao_db: this.formatarValor(this.valor_cartao_db),
            valor_cheque_vista: this.formatarValor(this.valor_cheque_vista),
            valor_cheque_prazo: this.formatarValor(this.valor_cheque_prazo),
            valor_duplicata_boleta: this.formatarValor(this.valor_duplicata_boleta),
            valor_acumulativo: this.formatarValor(this.valor_acumulativo),
            valor_pix: this.formatarValor(this.valor_pix),
            valor_credito: this.formatarValor(this.valor_credito),
            valor_desconto_pis: this.formatarValor(this.valor_total_desconto_pis), 
            valor_desconto_cofins: this.formatarValor(this.valor_total_desconto_cofins),
            valor_produtos_com_desc_pis_cofins: this.formatarValor(this.valor_produtos_com_desc_pis_cofins),
            valor_total: this.formatarValor(this.valor_total_produtos),
            total_normal: this.formatarValor(this.total_preco_normal),
            peso_total: this.formatarValor(this.peso_total_produtos),
            definicoes_lotes: produtos_lotes,
            logradouro: this.endereco_cliente_selecionado.logradouro,
            complemento: this.endereco_cliente_selecionado.complemento, 
            bairro_id: this.endereco_cliente_selecionado.bairro_id,
            cep: this.endereco_cliente_selecionado.cep,
            ponto_referencia: this.endereco_cliente_selecionado.ponto_referencia,
            tipo_imovel: this.endereco_cliente_selecionado.tipo_imovel,
            tipo_acesso_imovel: this.endereco_cliente_selecionado.tipo_acesso_imovel,
            andar: this.endereco_cliente_selecionado.andar,
            inscricao_estadual: this.endereco_cliente_selecionado.inscricao_estadual,
            tipo_frete: this.tipo_frete,
            valor_frete: this.formatarValor(this.valor_frete),
            outras_despesas: this.formatarValor(this.outras_despesas),
            tipo_entrega: this.tipo_entrega,
            observacoes_endereco: this.observacoes_endereco,
            data_minima_entrega: this.data_minima_entrega,
            data_entrega: moment(this.data_entrega, 'YYYY/MM/DD').format('DD/MM/YYYY'),
            hora_entrega: this.hora_entrega,
            tipo_agendamento_entrega: this.tipo_agendamento_entrega,
            valor_frete_terceirizado: this.formatarValor(this.valorTotalFretesTerceirizados),
            tipos_veiculos: this.freteTiposVeiculosSelecionados,
            frete_adicional_andar: this.formatarValor(this.frete_adicional_andar),
            tipo_frete_andar: this.tipo_frete_andar,
            recebimento_na_entrega: this.recebimento_na_entrega,
            tipo_contato_cliente: this.tipo_contato_cliente,
            total_liquido: this.formatarValor(this.total_liquido),
            usuario_redefiniu_lote: this.usuario_redefiniu_lote,
            creditos_utilizados: this.creditos_utilizados,
            valor_credito_gerado: this.formatarValor(this.valor_dif_pagamento),
            total_formas_pagamento: this.formatarValor(this.totalFormasPagamento),
            usuario_lib_credito_id: usuario_lib_credito_id,
            hash_pedido_front: hash_pedido_envio
          };
          let retorno = await ROrcamentoFecharPedido.fecharPedido(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.processando = false;
          this.sucessoFecharPedido(retorno.dados);
        } catch (error) {
          this.verificarErro(error, 'fecharPedido'); 
        }
      },

      handleRef(proximoCampo) {
        if (proximoCampo == 'adicionar_produto') {
          if (this.ref_produto) {
            this.adicionando_produto_direto = true;
            this.$refs.frProdutosVenda.inserirDadoPorChave(Biblioteca.numeros(this.ref_produto), 0);
          }
        }
      },

      async sucessoFecharPedido(data){
        if (!data.status){
          return
        }

        let mensagem = "";

        if (data.msg){
          data.msg = data.msg.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
        }

        if ((data) && (data.informativos)){
          for (let i = 0; i < data.informativos.length; i++) {
            if (data.informativos[i].mensagem){
              data.informativos[i].mensagem.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
              await swal(data.informativos[i].mensagem);
            }
          }
        }

        if (data.status == 'Erro'){
          if (data.produtos_multiplos){
            for (let i = 0; i < data.produtos_multiplos.length; i++) {
              Biblioteca.exclamar('O produto ' + this.formatarValor(data.produtos_multiplos[i].produto_id, 0) + ' está com a quantidade informada que não corresponde ao múltiplo de venda do produto. Quantidade sugerida: ' + data.produtos_multiplos[i].quantidade_sugestao);
            }
          }
          else{
            if (data.retorno_str && data.retorno_str == 'MC'){
              Biblioteca.exclamar('O(s) produto(s) ' + data.msg +  ' está(ão) bloqueado(s) para venda ');
              return;
            }

            swal(data.msg);
          }

          return;
        } else {

          if (data.bloqueado == 'S'){
            mensagem = data.orcamento_id ? "Orçamento: " + data.orcamento_id : '';
    
            swal({
              title: data.pedido_fechado == 'S' ? "Pedido bloqueado!" : "Orçamento bloqueado!",
              text: mensagem,
              icon: "warning",
              button: {
                confirm: {
                  text: "OK",
                  value: true,
                  visible: true,
                  closeModal: true,
                },
              },
            })
            .then((value) => {
              this.abrirModalFecharPedido = false;
              this.recarregarComponente();
            });
          }
          else if (parseInt(data.orcamento_id) == 0){
            swal({
              title: "Orçamento gravado com sucesso.",
              icon: "success",
              button: {
                confirm: {
                  text: "OK",
                  value: true,
                  visible: true,
                  closeModal: true,
                },
              },
            })
            .then((value) => {
              this.abrirModalFecharPedido = false;
              this.recarregarComponente();
            });
          }
          else {            
            mensagem = "Orçamento: " + data.orcamento_id;
            if (data.recebido_automaticamente){
              mensagem += 
                String.fromCharCode(13) + String.fromCharCode(10) + 
                data.recebido_automaticamente.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
            }
            swal({
              title: data.pedido_fechado == 'S' ? "Pedido gravado com sucesso." : "Orçamento gravado com sucesso.",
              text: mensagem,
              icon: "success",
              button: {
                confirm: {
                  text: "OK",
                  value: true,
                  visible: true,
                  closeModal: true,
                },
              },
            })
            .then((value) => {
              this.abrirModalFecharPedido = false;
              this.recarregarComponente();
            });
          }

          this.indice_condicao_pagamento_selecionada = undefined;
        }      
      },

      temDecimais: function(valor){
        // Inline if. Se valor % 1 > 0 for verdadeiro, true, se não false.
        return (valor % 1 > 0 ? true : false);
      },

      getClasseLegendaProduto: function(estoque_ato, quantidade){
        let classe = '';

        if (Biblioteca.valor(estoque_ato) < parseFloat(quantidade)){
          classe += 'texto-vermelho';
        }

        return classe;
      },

      mostrarModalCodigoBarras(){
        if (!this.cliente_selecionado.cadastro_id){
          Biblioteca.exclamar('Para pesquisar o preço é necessário informar o cliente!');
          return;
        }
        
        if (!this.condicao_pagamento_selecionada.condicao_id){
          Biblioteca.exclamar('Para pesquisar o preço é necessário informar a condição de pagamento!');
          return;
        }

        this.abrirModalLeitorCodigoBarras = true;
      },

      async mostrarModalProdutos(){
        console.log("obj cliente");
        console.dir(this.cliente_selecionado);
        let chaveClienteId = this.$refs.frCliente.chave_cliente_pesquisa;
        console.log(this.cliente_selecionado.chave_cliente_pesquisa);



        if(chaveClienteId != ""){
          await this.adicionarCliente(this.cliente_selecionado,true);
          console.log("cliente adicionado: "+ this.cliente_selecionado.cadastro_id);
        }
        console.log("obj pagamento: ");
        console.dir(this.condicao_pagamento_selecionada);
        let valorCondicaoPagamento = this.$refs.frCondicaoPagamento.chave_pesquisa;
        console.log(this.condicao_pagamento_selecionada.condicao_id);

        if(valorCondicaoPagamento != "" && valorCondicaoPagamento){
          await this.$refs.frCondicaoPagamento.inserirDadoPorChave(valorCondicaoPagamento);
          console.log("pagamento adicionado: "+this.condicao_pagamento_selecionada.condicao_id);
        }

        this.adicionando_produto_direto = false;
        this.$refs.frProdutosVenda.mostrarModalProdutos(false);
      },

      async mostrarModalPesquisaOrcamentos(){
        await this.$refs.frPesquisaOrcamentos.abrirPesquisa(true);
      },

      async recalcularPrecosProdutos(tipo_negociacao_preco, retornar_json_completo, questionar_multiplo_aviso_venda, exibir_processando){
        let retornoReprocessamento = false;
          
        try {

          if 
            (
              (this.produtos_selecionados.length === 0) ||
              (!this.cliente_selecionado.cadastro_id) ||
              (!this.condicao_pagamento_selecionada.condicao_id)
            ) 
          {
            return retornoReprocessamento;
          }

          await this.armazenarLocalStorage('PRODUTOS', this.produtos_selecionados);
          await this.armazenarLocalStorage('VENDEDOR', this.vendedor_selecionado);
          await this.armazenarLocalStorage('LOTE', this.definicoes_lotes);
          await this.armazenarLocalStorage('CLIENTE', this.cliente_selecionado);
          await this.armazenarLocalStorage('CONDICAO', this.condicao_pagamento_selecionada);
          await this.armazenarLocalStorage('TIPO_FRETE', this.tipo_frete);
          await this.armazenarLocalStorage('TIPO_ENTREGA', this.tipo_entrega);
          await this.armazenarLocalStorage('VALOR_FRETE', this.valor_frete);
          await this.armazenarLocalStorage('FRETES_TIPOS_VEICULOS', this.frete_tipos_veiculos);
          await this.armazenarLocalStorage('OUTRAS_DESPESAS', this.outras_despesas);
          await this.armazenarLocalStorage('ENDERECO', this.endereco_cliente_selecionado);
          await this.armazenarLocalStorage('DATA_MINIMA_ENTREGA', this.data_minima_entrega);
          await this.armazenarLocalStorage('TIPO_AGENDAMENTO_ENTREGA', this.tipo_agendamento_entrega);
          await this.armazenarLocalStorage('PRODUTOS', this.produtos_selecionados);    

          if (!retornar_json_completo)
            retornar_json_completo = 'S';

          let produtos_recalculando = [];
          let alterou_quantidade = false;
          let produtos_selecionados_descricao = [];

          for (let i = 0; i < this.produtos_selecionados.length; i++){
            produtos_selecionados_descricao.push(
              {
                produto_id: this.produtos_selecionados[i].produto_id,
                nome: this.produtos_selecionados[i].nome,
                marca: this.produtos_selecionados[i].marca,
                codigo_original: this.produtos_selecionados[i].codigo_original,
                codigo_ncm: this.produtos_selecionados[i].codigo_ncm,
                codigo_barras: this.produtos_selecionados[i].codigo_barras,
                tipo_controle_estoque: this.produtos_selecionados[i].tipo_controle_estoque,
                indice_preco_clientes: this.produtos_selecionados[i].indice_preco_clientes,
                indice_preco_ncm: this.produtos_selecionados[i].indice_preco_ncm,
                controlar_numero_serie: this.produtos_selecionados[i].controlar_numero_serie,
                valor_custo_extra_venda: this.produtos_selecionados[i].valor_custo_extra_venda,
                desativar_produto_zerar_est: this.produtos_selecionados[i].desativar_produto_zerar_est,
                sujeito_a_comissao: this.produtos_selecionados[i].sujeito_a_comissao,
                pagar_comissao_profissional: this.produtos_selecionados[i].pagar_comissao_profissional,
                indice_grupo_indice_preco: this.produtos_selecionados[i].indice_grupo_indice_preco,
                tipo_selecao_automatica_lote: this.produtos_selecionados[i].tipo_selecao_automatica_lote,
                permite_venda_fracionada: this.produtos_selecionados[i].permite_venda_fracionada,
                permitir_vender_acumulativo: this.produtos_selecionados[i].permitir_vender_acumulativo,
                tinta_manipulada: this.produtos_selecionados[i].tinta_manipulada,
                tipo_entrega_permitida: this.produtos_selecionados[i].tipo_entrega_permitida,
                prazo_maximo_permitido_venda: this.produtos_selecionados[i].prazo_maximo_permitido_venda,
                unidade: this.produtos_selecionados[i].unidade,
                tipo_local_padrao_entrega_ato: this.produtos_selecionados[i].tipo_local_padrao_entrega_ato
              }
            )

            produtos_recalculando.push(            
              {
                P1: i,
                P2: this.formatarValor(this.produtos_selecionados[i].quantidade),
                P3: this.produtos_selecionados[i].usou_promocao,
                P4: this.formatarValor(this.produtos_selecionados[i].preco_base),
                P5: this.produtos_selecionados[i].produto_id,
                P6: this.formatarValor(this.produtos_selecionados[i].perc_desconto),
                P7: this.formatarValor(this.produtos_selecionados[i].preco),
                P8: this.formatarValor(this.produtos_selecionados[i].valor_desconto),
                P9: this.produtos_selecionados[i].ponta_estoque ? 'S' : 'N',
                P10: this.produtos_selecionados[i].usou_preco_atacado,
                P11: this.produtos_selecionados[i].retirar_lojas_rede,
                P12: this.produtos_selecionados[i].desconto_alterado ? 'S' : 'N',
                P13: this.produtos_selecionados[i].quantidade_agendar,
                P14: this.produtos_selecionados[i].usou_promocao_especial,
                P15: this.produtos_selecionados[i].qtd_sem_agendamento,
                P16: this.produtos_selecionados[i].quantidade_entrega_ato,
                P17: this.produtos_selecionados[i].quantidade_sem_previsao,
                P18: this.produtos_selecionados[i].tipo_selec_local_entrega_ato,
                P19: this.produtos_selecionados[i].previsao_entrega_sem_agen,
                P20: this.produtos_selecionados[i].quantidade_entrega_ato_loj,
                P21: this.produtos_selecionados[i].quantidade_entrega_ato_dep,
                P22: this.produtos_selecionados[i].quantidade_entrega_ato_exp,
                P23: this.produtos_selecionados[i].tipo_local_padrao_entrega_ato,
                P24: this.produtos_selecionados[i].usou_indice_grupo_indice_preco,
                P25: this.produtos_selecionados[i].empresa_retirar_lojas_rede_id,
                P26: this.produtos_selecionados[i].tipo_uso_preco_por_quantidade,
              }
            )
          }

          let parametros = {
            hash_pedido_front: this.hash_pedido,
            retornar_json_completo: retornar_json_completo,
            produtos_recalculando: produtos_recalculando,
            condicao_pagamento_id: this.condicao_pagamento_selecionada.condicao_id,
            cliente_id: this.cliente_selecionado.cadastro_id,
            bairro_id: this.endereco_cliente_selecionado.bairro_id,
            cep: this.endereco_cliente_selecionado.cep,
            tipo_imovel: this.endereco_cliente_selecionado.tipo_imovel,
            andar: this.endereco_cliente_selecionado.andar,
            inscricao_estadual: this.endereco_cliente_selecionado.inscricao_estadual,
            outras_despesas: this.outras_despesas,
            total_frete: this.valorTotalFretes,
            tipo_frete: this.tipo_frete,
            valor_frete: this.valor_frete,
            tipo_entrega: this.tipo_entrega,
            valor_desconto: (this.aplicarDescontoImpostos() == 'S' ? this.valor_desconto : 0),
            tipo_negociacao_preco: tipo_negociacao_preco ? tipo_negociacao_preco : 'NENHUM',
            aplicar_desc_pis_cofins: this.aplicarDescontoImpostos()
          }

          // Reprocessar os produtos somente se os parâmetros para reprocessar forem diferentes, 
          // pois se os parâmetros são iguais o resultado será o mesmo não havendo a necessidade de ocorrer o reprocessamento.
          if (JSON.stringify(parametros) == JSON.stringify(this.ultimos_parametros_reprocessar_produtos)){
            return true;
          }

          // Armazenando últimos dados reprocessados
          this.ultimos_parametros_reprocessar_produtos = JSON.parse(JSON.stringify(parametros));
          
          // Habilitando o aviso de reprocessamento
          this.reprocessando_prod = exibir_processando;

          let retorno = await ROrcamentoReprocessarProdutos.reprocessarProdutos(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          let produtos_reprocessados = retorno.dados.produtos;          
          this.produtos_selecionados = [];

          for (let i = 0; i < produtos_reprocessados.length; i++) {
            // Retornando detalhes do produto 
            for (let item of produtos_selecionados_descricao) {
              if (Biblioteca.valorInt(item.produto_id) == Biblioteca.valorInt(produtos_reprocessados[i].produto_id)){
                produtos_reprocessados[i].nome = item.nome;
                produtos_reprocessados[i].marca = item.marca;
                produtos_reprocessados[i].codigo_original = item.codigo_original;
                produtos_reprocessados[i].codigo_ncm = item.codigo_ncm;
                produtos_reprocessados[i].codigo_barras = item.codigo_barras;
                produtos_reprocessados[i].tipo_controle_estoque = item.tipo_controle_estoque;
                produtos_reprocessados[i].indice_preco_clientes = item.indice_preco_clientes;
                produtos_reprocessados[i].indice_preco_ncm = item.indice_preco_ncm;
                produtos_reprocessados[i].controlar_numero_serie = item.controlar_numero_serie;
                produtos_reprocessados[i].valor_custo_extra_venda = item.valor_custo_extra_venda;
                produtos_reprocessados[i].desativar_produto_zerar_est = item.desativar_produto_zerar_est;
                produtos_reprocessados[i].sujeito_a_comissao = item.sujeito_a_comissao;
                produtos_reprocessados[i].pagar_comissao_profissional = item.pagar_comissao_profissional;
                produtos_reprocessados[i].indice_grupo_indice_preco = item.indice_grupo_indice_preco;
                produtos_reprocessados[i].tipo_selecao_automatica_lote = item.tipo_selecao_automatica_lote;
                produtos_reprocessados[i].permite_venda_fracionada = item.permite_venda_fracionada;
                produtos_reprocessados[i].permitir_vender_acumulativo = item.permitir_vender_acumulativo;
                produtos_reprocessados[i].tinta_manipulada = item.tinta_manipulada;
                produtos_reprocessados[i].tipo_entrega_permitida = item.tipo_entrega_permitida;
                produtos_reprocessados[i].prazo_maximo_permitido_venda = item.prazo_maximo_permitido_venda;
                produtos_reprocessados[i].unidade = item.unidade;
                produtos_reprocessados[i].tipo_local_padrao_entrega_ato = item.tipo_local_padrao_entrega_ato;
              }
            } 

            //Passando as varíaveis para boolean
            produtos_reprocessados[i].ponta_estoque = (produtos_reprocessados[i].ponta_estoque == 'S');

            if (produtos_reprocessados[i].ponta_estoque){              
              produtos_reprocessados[i].preco = Biblioteca.valor(produtos_reprocessados[i].preco_ponta);
              produtos_reprocessados[i].preco_base = Biblioteca.valor(produtos_reprocessados[i].preco_base_ponta);
              produtos_reprocessados[i].estoque_ato = produtos_reprocessados[i].qtd_disponivel_ponta_estoque;
              produtos_reprocessados[i].estoque_agendamento = produtos_reprocessados[i].qtd_disp_ponta_estoque_rede;
            }else{              
              produtos_reprocessados[i].preco = Biblioteca.valor(produtos_reprocessados[i].preco);
              produtos_reprocessados[i].preco_base = Biblioteca.valor(produtos_reprocessados[i].preco_base);      
            }            

            produtos_reprocessados[i].adicionado = true;           
            produtos_reprocessados[i].produto_id = Biblioteca.valorInt(produtos_reprocessados[i].produto_id);
            produtos_reprocessados[i].preco_ponta = Biblioteca.valor(produtos_reprocessados[i].preco_ponta);
            produtos_reprocessados[i].preco_atacado_oculto = Biblioteca.valor(produtos_reprocessados[i].preco_atacado_oculto);
            produtos_reprocessados[i].preco_promocao = Biblioteca.valor(produtos_reprocessados[i].preco_promocao);
            produtos_reprocessados[i].preco_manual = 0; //Em outra função faz o cálculo utilizando o percentual de desconto.
            produtos_reprocessados[i].preco_venda_oculto = produtos_reprocessados[i].preco;
            produtos_reprocessados[i].total_item_temp = 0;
            produtos_reprocessados[i].preco_temp = produtos_reprocessados[i].preco;
            produtos_reprocessados[i].total_item = Biblioteca.valor(produtos_reprocessados[i].total_item);
            produtos_reprocessados[i].empresa_multiplo_venda = Biblioteca.valorInt(produtos_reprocessados[i].empresa_multiplo_venda);
            produtos_reprocessados[i].prazo_maximo_permitido_venda = Biblioteca.valorInt(produtos_reprocessados[i].prazo_maximo_permitido_venda);

            // Impostos
            produtos_reprocessados[i].valor_total_ipi = Biblioteca.valor(produtos_reprocessados[i].valor_ipi);
            produtos_reprocessados[i].valor_total_st = Biblioteca.valor(produtos_reprocessados[i].valor_st);
            produtos_reprocessados[i].valor_total_fcp_st = Biblioteca.valor(produtos_reprocessados[i].valor_fcp_st);
            produtos_reprocessados[i].preco_unitario_com_imposto = Biblioteca.valor(produtos_reprocessados[i].preco_unitario_com_imposto);
            // Total impostos
            produtos_reprocessados[i].valor_ipi = Biblioteca.valor(produtos_reprocessados[i].valor_ipi);
            produtos_reprocessados[i].valor_st = Biblioteca.valor(produtos_reprocessados[i].valor_st);
            produtos_reprocessados[i].valor_fcp_st = Biblioteca.valor(produtos_reprocessados[i].valor_fcp_st);

            produtos_reprocessados[i].preco_venda_sem_desconto = Biblioteca.valor(produtos_reprocessados[i].preco_venda_sem_desconto);
            produtos_reprocessados[i].quantidade = Biblioteca.valor(produtos_reprocessados[i].quantidade);
            produtos_reprocessados[i].quantidade_sugestao = Biblioteca.valor(produtos_reprocessados[i].quantidade_sugestao);
            produtos_reprocessados[i].multiplo_venda = Biblioteca.valor(produtos_reprocessados[i].multiplo_venda);
            produtos_reprocessados[i].multiplo_quantidade_sugestao = Biblioteca.valor(produtos_reprocessados[i].multiplo_quantidade_sugestao);
            produtos_reprocessados[i].valor_desconto = Biblioteca.valor(produtos_reprocessados[i].valor_desconto);
            produtos_reprocessados[i].perc_desconto = Biblioteca.valor(produtos_reprocessados[i].perc_desconto);
            produtos_reprocessados[i].valor_desconto_temp = produtos_reprocessados[i].valor_desconto;
            produtos_reprocessados[i].perc_desconto_temp = produtos_reprocessados[i].perc_desconto;
            produtos_reprocessados[i].tipo_uso_preco_por_quantidade = produtos_reprocessados[i].tipo_uso_preco_por_quantidade;            
            if (produtos_reprocessados[i].alterou_preco_por_qtd == 'S'){
              Biblioteca.exclamar(
                'O preço de venda do produto ' + Biblioteca.nPadrao(produtos_reprocessados[i].produto_id, 0) + ' - ' + produtos_reprocessados[i].nome + ' ' +
                'será alterado porque para a nova quantidade informada existe um preço de venda diferenciado do que já está informado.'
              );
            }

            //Validando o múltiplo de venda
            if (produtos_reprocessados[i].quantidade_sugestao > 0) {
              Biblioteca.exclamar(
                'A quantidade informada: ' + Biblioteca.nPadrao(produtos_reprocessados[i].quantidade_anterior, 3) + 
                ' do produto ' + Biblioteca.nPadrao(produtos_reprocessados[i].produto_id, 0) + " - " + produtos_reprocessados[i].nome + 
                ' - Empresa ' + Biblioteca.nPadrao(produtos_reprocessados[i].empresa_multiplo_venda, 0) + 
                ' não se adequa ao seu múltiplo de venda. (' + Biblioteca.nPadrao(produtos_reprocessados[i].multiplo_venda, 3) + ')' + 
                'A quantidade será trocada para a quantidade correta mais adequada. ' +
                'Sugestão: ' + Biblioteca.nPadrao(produtos_reprocessados[i].quantidade_sugestao, 3)
              );

              alterou_quantidade = true;
              produtos_reprocessados[i].quantidade = produtos_reprocessados[i].quantidade_sugestao;
            } 
            else if 
              (
                questionar_multiplo_aviso_venda &&
                !produtos_reprocessados[i].ponta_estoque &&
                produtos_reprocessados[i].multiplo_quantidade_sugestao && 
                (produtos_reprocessados[i].multiplo_quantidade_sugestao != produtos_reprocessados[i].quantidade) &&
                (Biblioteca.valorInt(this.produto_selecionado.produto_id) == Biblioteca.valorInt(produtos_reprocessados[i].produto_id))
              )
            {
              await swal(
                "A quantidade informada (" + Biblioteca.nPadrao(produtos_reprocessados[i].quantidade, 3) + ") do produto " + 
                Biblioteca.nPadrao(produtos_reprocessados[i].produto_id, 0)  + ' - ' + produtos_reprocessados[i].nome +
                " não se adequa ao múltiplo de aviso (" + Biblioteca.nPadrao(produtos_reprocessados[i].multiplo_venda_aviso_venda, 3) + ")" +
                " a quantidade sugestão é: " + Biblioteca.nPadrao(produtos_reprocessados[i].multiplo_quantidade_sugestao, 3) + "!" +
                " Deseja trocar para a quantidade de sugestão? ", {
                  buttons: {
                    sim: "Sim",
                    nao: "Não"                
                  },
                }
              ).then((value) => {
                switch (value) {
                  case "sim": 
                    alterou_quantidade = true;
                    produtos_reprocessados[i].quantidade = produtos_reprocessados[i].multiplo_quantidade_sugestao;

                    if (this.produto_selecionado.quantidade){
                      this.produto_selecionado.quantidade = produtos_reprocessados[i].quantidade;
                    }
                    
                    break;
                }
              })
            }

            this.produtos_selecionados.push(produtos_reprocessados[i]);
          }

          if (this.condicao_pagamento_selecionada.utilizar_tac_somente_simulacao == 'N'){
            this.valor_tac = Biblioteca.valor(retorno.dados.valor_tac);
          } else {
            this.valor_tac = 0;
          }

          this.valor_total_st_frete = Biblioteca.valor(retorno.dados.valor_st_frete);
          this.valor_total_desconto_pis = Biblioteca.valor(retorno.dados.valor_total_desconto_pis);
          this.valor_total_desconto_cofins = Biblioteca.valor(retorno.dados.valor_total_desconto_cofins);
          this.valor_produtos_com_desc_pis_cofins = Biblioteca.valor(retorno.dados.valor_produtos_com_desc_pis_cofins);

          await this.recalcularTotaisPedido(alterou_quantidade);  
          
          // Armazenando no local storage caso a requisição foi concluida com sucesso e não houve alteração de quantidade 
          // por causa de múltiplo de venda ou seja "Não vai ter mais nenhum novo reprocessamento".
          if (!alterou_quantidade) {
            await this.armazenarLocalStorage('VENDEDOR', this.vendedor_selecionado);
            await this.armazenarLocalStorage('LOTE', this.definicoes_lotes);
            await this.armazenarLocalStorage('CLIENTE', this.cliente_selecionado);
            await this.armazenarLocalStorage('CONDICAO', this.condicao_pagamento_selecionada);
            await this.armazenarLocalStorage('TIPO_FRETE', this.tipo_frete);
            await this.armazenarLocalStorage('TIPO_ENTREGA', this.tipo_entrega);
            await this.armazenarLocalStorage('VALOR_FRETE', this.valor_frete);
            await this.armazenarLocalStorage('FRETES_TIPOS_VEICULOS', this.frete_tipos_veiculos);
            await this.armazenarLocalStorage('OUTRAS_DESPESAS', this.outras_despesas);
            await this.armazenarLocalStorage('ENDERECO', this.endereco_cliente_selecionado);
            await this.armazenarLocalStorage('DATA_MINIMA_ENTREGA', this.data_minima_entrega);
            await this.armazenarLocalStorage('TIPO_AGENDAMENTO_ENTREGA', this.tipo_agendamento_entrega);
            await this.armazenarLocalStorage('PRODUTOS', this.produtos_selecionados);    
          }

          this.reprocessando_prod = false;

          // Retornando que deu certo o reprocessamento.
          retornoReprocessamento = true;
        } catch (error) {
          this.processando = false;
          this.reprocessando_prod = false;
          this.proc_carregando_orcamento = false;
          
          // Retornando que deu erro o reprocessamento.
          retornoReprocessamento = true;
          // Voltando as definições que estavam antes de processar.
          await this.recarregarDadosLocalStorage('VENDEDOR');
          await this.recarregarDadosLocalStorage('CLIENTE');
          await this.recarregarDadosLocalStorage('CONDICAO');
          await this.recarregarDadosLocalStorage('LOTE');
          await this.recarregarDadosLocalStorage('TIPO_FRETE');
          await this.recarregarDadosLocalStorage('TIPO_ENTREGA');
          await this.recarregarDadosLocalStorage('VALOR_FRETE');
          await this.recarregarDadosLocalStorage('FRETES_TIPOS_VEICULOS');
          await this.recarregarDadosLocalStorage('ENDERECO');
          await this.recarregarDadosLocalStorage('OUTRAS_DESPESAS');
          // 'PRODUTOS' Sempre por último pois recalcula o total do pedido de acordo com o valor dos itens.
          await this.recarregarDadosLocalStorage('PRODUTOS');

          // Desativando processando e exibindo a mensagem de erro tratada.
          this.verificarErro(error, 'recalcularPrecosProdutos'); 
        }

        return retornoReprocessamento;
      },

      async recalcularTotaisPedido(precisa_recalcular_produtos){
        let valor_total = 0;
        let valor_total_venda_oculto = 0;
        let peso_total = 0;
        this.valor_total_ipi = 0;
        this.valor_total_st = 0;
        this.valor_total_fcp_st = 0;

        this.total_despesas = 0;
        this.total_preco_promocao = 0;

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          if (this.produtos_selecionados[i].perc_desconto != 0){
            this.produtos_selecionados[i].preco_manual = (this.produtos_selecionados[i].preco_venda_sem_desconto - this.produtos_selecionados[i].valor_desconto);
            this.produtos_selecionados[i].preco = this.Arredondar(this.produtos_selecionados[i].preco_manual, 2);
          }
          else {
            this.produtos_selecionados[i].preco_manual = 0;
            
            if ((!this.carregando_pedido) && (this.produtos_selecionados[i].usou_promocao == 'S' || this.produtos_selecionados[i].usou_promocao_especial == 'S')) {
              this.produtos_selecionados[i].preco = this.produtos_selecionados[i].preco_promocao;   
            }
          }

          this.valor_total_ipi += this.produtos_selecionados[i].valor_total_ipi;
          this.valor_total_st += this.produtos_selecionados[i].valor_total_st;
          this.valor_total_fcp_st += this.produtos_selecionados[i].valor_total_fcp_st; 

          if (this.produtos_selecionados[i].usou_promocao == 'S' || this.produtos_selecionados[i].usou_promocao_especial == 'S'){
            valor_total_venda_oculto += this.produtos_selecionados[i].preco * Biblioteca.valor(this.produtos_selecionados[i].quantidade);
          } else{
            valor_total_venda_oculto += this.produtos_selecionados[i].preco_venda_oculto * Biblioteca.valor(this.produtos_selecionados[i].quantidade);
          }

          if (this.produtos_selecionados[i].usou_promocao == 'S' || this.produtos_selecionados[i].usou_promocao_especial == 'S' || this.produtos_selecionados[i].ponta_estoque){
            this.total_preco_promocao += this.produtos_selecionados[i].total_item;
          }

          valor_total += this.produtos_selecionados[i].total_item;
          peso_total += Biblioteca.valor(this.produtos_selecionados[i].peso) * Biblioteca.valor(this.produtos_selecionados[i].quantidade);
        }

        this.valor_total_st += this.valor_total_st_frete;
        
        if ((this.tipo_frete == 'V') || (this.tipo_frete == 'F')){
          this.total_despesas = Biblioteca.valor(this.valorTotalFretes + this.outras_despesas);
        }

        // Quando o tipo de frete é por % não se deve somar o valor da variável valor_frete pois já estará rateado por item.
        if (this.tipo_frete == 'C' || this.tipo_frete == 'S'){
          this.total_despesas = Biblioteca.valor(this.valorTotalFretesTerceirizados + this.outras_despesas);
        }

        this.valor_total_preco_venda_oculto = this.Arredondar(valor_total_venda_oculto, 2);
        this.valor_total_st = this.Arredondar(this.valor_total_st, 2);
        this.valor_total_produtos = valor_total.toFixed(2);
        this.peso_total_produtos = peso_total.toFixed(3);
        this.quantidade_produto_selecionado = '';  

        this.total_liquido = 
          (
            Biblioteca.valor(this.valor_total_produtos) - 
            Biblioteca.valor(this.valor_desconto) - 
            Biblioteca.valor(this.valor_total_desconto_pis) -
            Biblioteca.valor(this.valor_total_desconto_cofins) +
            Biblioteca.valor(this.valor_total_ipi) + 
            Biblioteca.valor(this.valor_total_st) + 
            Biblioteca.valor(this.valor_total_fcp_st) + 
            Biblioteca.valor(this.valor_tac) + 
            Biblioteca.valor(this.total_despesas)
          ).toFixed(2);

        if (precisa_recalcular_produtos){
          await this.recalcularPrecosProdutos('NENHUM', 'N', false, true);
        }
      },

      copiarPedido(){
        if (this.autorizado_copiar_pedidos_venda == 'N'){
          swal("Usuário não autorizado a copiar pedidos de venda!");
          return;
        }

        this.copiar_orcamento_id = Biblioteca.valorInt(this.copiar_orcamento_id);

        if (this.copiar_orcamento_id <= 0){
          Biblioteca.exclamar('Código inválido.');
          return;
        }

        let carregou_pedido = this.carregarOrcamentoEdicao(this.copiar_orcamento_id, 'S');

        if (carregou_pedido){
          this.abrirModalCopiarPedido = false;
        }
      },

      async calcularFrete(){
        if (this.tipo_frete == 'C'){
          let possui_desconto = false
    
          for (let i = 0; i < this.produtos_selecionados.length; i++) {
            if (Biblioteca.valor(this.produtos_selecionados[i].perc_desconto_temp) > 0){
              this.produtos_selecionados[i].perc_desconto_temp = 0
              this.produtos_selecionados[i].perc_desconto = 0
              this.produtos_selecionados[i].valor_desconto = 0
              this.produtos_selecionados[i].desconto_alterado = false            
              possui_desconto = true
            }
          }

          if (possui_desconto){
            this.calcularPreviaDescontoTodosProdutos();
            swal('Foram encontradas definições de desconto por item. E1 1stas definições serão perdidas com a seleção do tipo de frete "CIF%".');
          }
        }

        this.abrirModalFrete = false;
        // A função abaixo esta assincrona porque precisa aguardar o calculo para total com frete fique correto.
        await this.recalcularTotaisPedido(true);
      },

      limparDescontoPorItem: function(produto_index){
        this.produtos_selecionados[produto_index].perc_desconto_temp = 0;
        this.calcularPreviaDescontoTodosProdutos();
      },

      limparDescontoAlteracaoPreco: function(){
        this.produto_selecionado.perc_desconto_temp = 0;
        this.produto_selecionado.preco_temp = this.produto_selecionado.preco_venda_sem_desconto;
        this.produto_selecionado.preco_alterado = false;
      },

      calcularPreviaDescontoTodosProdutos: function(){
        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          if (this.produtos_selecionados[i].perc_desconto_temp == 0 || this.produtos_selecionados[i].perc_desconto_temp == ''){
            this.produtos_selecionados[i].preco_temp = this.produtos_selecionados[i].preco_venda_oculto;
            this.produtos_selecionados[i].total_item_temp = this.produtos_selecionados[i].preco_venda_oculto * this.produtos_selecionados[i].quantidade;
            this.produtos_selecionados[i].valor_desconto_temp = 0;
            this.produtos_selecionados[i].perc_desconto_temp = 0;
          }
          else {
            /*Arredondando para o padrão de 4 casas decimais*/
            this.produtos_selecionados[i].perc_desconto_temp = parseFloat(this.produtos_selecionados[i].perc_desconto_temp);            
            this.produtos_selecionados[i].perc_desconto_temp = this.Arredondar(this.produtos_selecionados[i].perc_desconto_temp, 4);
            
            
            /*Calculando o preço em função do desconto*/
            this.produtos_selecionados[i].preco_temp = this.Arredondar(
              (
                /* Preço do produto */
                this.produtos_selecionados[i].preco_venda_oculto *
                (1 - this.produtos_selecionados[i].perc_desconto_temp * 0.01)
              ),
              /* Casas decimais*/
              2
            );
            
            /*Recalculando o percentual de desconto em função do valor*/
            this.produtos_selecionados[i].perc_desconto_temp = parseFloat(
              100 *
              /* Preço do produto */
              (this.produtos_selecionados[i].preco_venda_oculto - this.produtos_selecionados[i].preco_temp) 
              /
              this.produtos_selecionados[i].preco_venda_oculto
            );

            this.produtos_selecionados[i].valor_desconto_temp = this.produtos_selecionados[i].preco_venda_oculto - this.produtos_selecionados[i].preco_temp;            
            this.produtos_selecionados[i].perc_desconto_temp = this.Arredondar(this.produtos_selecionados[i].perc_desconto_temp, 4);
            this.produtos_selecionados[i].total_item_temp = this.produtos_selecionados[i].preco_temp * this.produtos_selecionados[i].quantidade;

            this.calcularPreviaDescontoPrecoLiquido(i);
          }
        }
      },

      calcularPreviaDescontoProduto(produto_index){        
        if (this.produtos_selecionados[produto_index].perc_desconto_temp == 0){
          this.produtos_selecionados[produto_index].preco_temp = this.produtos_selecionados[produto_index].preco_venda_oculto;
          this.produtos_selecionados[produto_index].total_item_temp = this.produtos_selecionados[produto_index].preco_venda_oculto * this.produtos_selecionados[produto_index].quantidade;
          this.produtos_selecionados[produto_index].valor_desconto_temp = 0;
        }
        else {
          this.produtos_selecionados[produto_index].preco_temp = this.Arredondar(
            (
              /* Preço do produto */
              this.produtos_selecionados[produto_index].preco_venda_oculto *
              (1 - this.produtos_selecionados[produto_index].perc_desconto_temp * 0.01)
            ),
            /* Casas decimais*/
            2
          );

          this.produtos_selecionados[produto_index].valor_desconto_temp = this.produtos_selecionados[produto_index].preco_venda_oculto - this.produtos_selecionados[produto_index].preco_temp;            
          this.produtos_selecionados[produto_index].total_item_temp = this.produtos_selecionados[produto_index].preco_temp * this.produtos_selecionados[produto_index].quantidade;
        }
      },

      calcularPreviaDescontoPrecoLiquido(produto_index) {
        if (!this.produtos_selecionados[produto_index].preco_temp){
          return
	}

        this.produtos_selecionados[produto_index].perc_desconto_temp = (
          this.Arredondar(
            (100 *
              (this.produtos_selecionados[produto_index].preco_venda_oculto - this.produtos_selecionados[produto_index].preco_temp) 
              / this.produtos_selecionados[produto_index].preco_venda_oculto
            ),4
          )
        ) 
	
        this.produtos_selecionados[produto_index].total_item_temp = this.produtos_selecionados[produto_index].preco_temp * this.produtos_selecionados[produto_index].quantidade;
        this.produtos_selecionados[produto_index].valor_desconto_temp = this.produtos_selecionados[produto_index].preco_venda_oculto - this.produtos_selecionados[produto_index].preco_temp;
      },

      calcularPreviaDescontoProdutoSelecionado: function () {
        if (this.produto_selecionado.perc_desconto_temp == 0 || this.produto_selecionado.perc_desconto_temp == ''){
            this.produto_selecionado.preco_temp = this.produto_selecionado.preco_venda_oculto;
            this.produto_selecionado.total_item_temp = this.produto_selecionado.preco_venda_oculto * this.produto_selecionado.quantidade;
            this.produto_selecionado.valor_desconto_temp = 0;
            this.produto_selecionado.perc_desconto_temp = 0;
        }
        else {
          /*Calculando o preço em função do desconto*/
          this.produto_selecionado.preco_temp = this.Arredondar(
            (
              /* Preço do produto */
              this.produto_selecionado.preco_venda_oculto *
              (1 - this.produto_selecionado.perc_desconto_temp * 0.01)
            ),
            /* Casas decimais*/
            2
          );

          this.produto_selecionado.valor_desconto_temp = this.produto_selecionado.preco_venda_oculto - this.produto_selecionado.preco_temp;            
          this.produto_selecionado.total_item_temp = this.produto_selecionado.preco_temp * this.produto_selecionado.quantidade;
        }
      },

      calcularPreviaValorProdutoSelecionado: function () {      
        this.produto_selecionado.perc_desconto_temp = (
          this.Arredondar(
            (100 *
              (this.produto_selecionado.preco_venda_oculto - this.produto_selecionado.preco_temp) 
              / this.produto_selecionado.preco_venda_oculto
            ),4
          )
        ) 

        this.produto_selecionado.total_item_temp = this.produto_selecionado.preco_temp * this.produto_selecionado.quantidade;
        this.produto_selecionado.valor_desconto_temp = this.produto_selecionado.preco_venda_oculto - this.produto_selecionado.preco_temp;
      },

      async gravarDescontosProdutos(){
        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          if (parseFloat(this.produtos_selecionados[i].perc_desconto_temp) > Biblioteca.valor(this.desconto_autorizado_vendedor)){
            if (this.par_emp_gerar_bloq_desc_f5_acima_aut == 'S'){
              let abortar = false;

              await swal({
                title: "Atenção",
                text: "Desconto superior ao definido para o usuário(" + this.desconto_autorizado_vendedor + "%). " +
                "Caso continue, o pedido será bloqueado. Deseja continuar?",
                icon: "warning",
                buttons: {
                  sim: "Sim",
                  nao: "Não",
                },
              }).
              then((value) => {
                switch (value) {
                  case "nao": abortar = true;
                }
              });
              
              if (abortar){
                return;
              }

              break;
            } else {
               Biblioteca.exclamar(
                'Usuário não autorizado a dar este desconto! ' + 'Desconto aplicado: ' + this.formatarValor(this.produtos_selecionados[i].perc_desconto_temp, 4) + '%. ' +
                'Produto: ' + this.formatarValor(this.produtos_selecionados[i].produto_id, 0)
              );
              return;
            }
          }
        }

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          if (this.produtos_selecionados[i].perc_desconto_temp == 0 || this.produtos_selecionados[i].perc_desconto_temp == ''){
            this.produtos_selecionados[i].perc_desconto = 0;
            this.produtos_selecionados[i].valor_desconto = 0;
            this.produtos_selecionados[i].desconto_alterado = false;
          }
          else {
            this.produtos_selecionados[i].perc_desconto = this.produtos_selecionados[i].perc_desconto_temp;
            this.produtos_selecionados[i].valor_desconto = this.produtos_selecionados[i].valor_desconto_temp.toFixed(2);
            this.produtos_selecionados[i].desconto_alterado = true;
          }
        }

        await this.recalcularTotaisPedido(true);
        
        this.abrirModalDescontoProduto = false
        this.adicionando_produtos = false

        this.$nextTick(() => this.$refs.produto.focus());
      },

      async buscarMix(){
        try {

          if (!this.autorizado_visualizar_mix){
            swal('Usuário logado não autorizado a verificar mix de venda!');
            return;
          }

          if (!this.cliente_selecionado.cadastro_id){
            Biblioteca.exclamar('É necessário informar o cliente!');
            return;
          }

          if (!this.vendedor_selecionado.funcionario_id) {
            Biblioteca.exclamar('É necessário informar o vendedor!');
            return;
          }

          if (!this.condicao_pagamento_selecionada.condicao_id){
            Biblioteca.exclamar('É necessário informar a condição de pagamento!');
            return;
          }

          if (this.produtos_selecionados.length === 0){
            Biblioteca.exclamar('É necessário informar os produtos para verificar o mix!');
            return;
          }

          this.processando = true;
          var produtos_orcamento = [];

          for (let i = 0; i < this.produtos_selecionados.length; i++) {
            produtos_orcamento[i] = Object.assign({}, this.produtos_selecionados[i]);
          }

          for (let i = 0; i < produtos_orcamento.length; i++) {
            produtos_orcamento[i].preco_manual = this.formatarValor(produtos_orcamento[i].preco_manual, 2);
            produtos_orcamento[i].preco_venda = this.formatarValor(produtos_orcamento[i].preco);
            produtos_orcamento[i].quantidade = this.formatarValor(produtos_orcamento[i].quantidade);
            produtos_orcamento[i].peso = this.formatarValor(produtos_orcamento[i].peso);
            produtos_orcamento[i].total_item = this.formatarValor(produtos_orcamento[i].total_item, 2);
            produtos_orcamento[i].preco_venda_oculto = this.formatarValor(produtos_orcamento[i].preco_venda_oculto, 2);
            produtos_orcamento[i].perc_desconto = this.formatarValor(produtos_orcamento[i].perc_desconto, 2);
            produtos_orcamento[i].valor_total_ipi = this.formatarValor(produtos_orcamento[i].valor_total_ipi, 2);
            produtos_orcamento[i].valor_total_st = this.formatarValor(produtos_orcamento[i].valor_total_st, 2);
            produtos_orcamento[i].valor_total_fcp_st = this.formatarValor(produtos_orcamento[i].valor_total_fcp_st, 2);
            produtos_orcamento[i].preco_base = this.formatarValor(produtos_orcamento[i].preco_base);  
            produtos_orcamento[i].valor_desconto = this.formatarValor((Biblioteca.valor(produtos_orcamento[i].preco_venda_oculto) - produtos_orcamento[i].preco) * Biblioteca.valor(produtos_orcamento[i].quantidade)); 
          }

          if (!this.endereco_cliente_selecionado.logradouro){
            this.endereco_cliente_selecionado.logradouro = '';
          }

          if (!this.endereco_cliente_selecionado.complemento){
            this.endereco_cliente_selecionado.complemento = '';
          }

          if (!this.endereco_cliente_selecionado.bairro_id){
            this.endereco_cliente_selecionado.bairro_id = 0;
          }

          if (!this.endereco_cliente_selecionado.cep){
            this.endereco_cliente_selecionado.cep = '';
          }

          if (!this.endereco_cliente_selecionado.ponto_referencia){
            this.endereco_cliente_selecionado.ponto_referencia = '';
          }

          if (!this.endereco_cliente_selecionado.tipo_imovel){
            this.endereco_cliente_selecionado.tipo_imovel = 'NIN';
          }

          if (!this.endereco_cliente_selecionado.tipo_acesso_imovel){
            this.endereco_cliente_selecionado.tipo_acesso_imovel = 'N';
          }

          if (!this.endereco_cliente_selecionado.andar){
            this.endereco_cliente_selecionado.andar = 0;
          }

          if (!this.observacoes_endereco){
            this.observacoes_endereco = '';
          }

          let parametros = {
            cliente_id: this.cliente_selecionado.cadastro_id,
            condicao_pagamento_id: this.condicao_pagamento_selecionada.condicao_id,
            vendedor_id: this.vendedor_selecionado.funcionario_id,
            valor_desconto: this.formatarValor(this.valor_desconto),
            itens_orcamento: produtos_orcamento,
            valor_total: this.valor_total_produtos,
            peso_total: this.formatarValor(this.peso_total_produtos),
            tipo_frete: this.tipo_frete,
            valor_frete: this.valor_frete,
            tipo_entrega: this.tipo_entrega,
            bairro_id: this.endereco_cliente_selecionado.bairro_id,
            cep: this.endereco_cliente_selecionado.cep,
            tipo_imovel: this.endereco_cliente_selecionado.tipo_imovel,
            andar: this.endereco_cliente_selecionado.andar,
            outras_despesas: this.formatarValor(this.outras_despesas),
            peso_total_maximo: this.formatarValor(this.totalPesoMaximo),
            valor_frete_terceirizado: this.formatarValor(this.valorTotalFretesTerceirizados),
            valor_frete_adicional_andar: this.formatarValor(this.frete_adicional_andar),
            inscricao_estadual: this.endereco_cliente_selecionado.inscricao_estadual
          }

          let retorno = await ROrcamentoBuscarMixNovoOrcamento.buscarMixNovoOrcamento(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem)
          }

          this.mix = retorno.dados;
          this.mix.cor = this.mix.resultado_venda;
          this.mix.nome_cliente = this.cliente_selecionado.nome_fantasia;
          this.mix.nome_vendedor = this.vendedor_selecionado.nome;
          this.mix.nome_condicao = this.condicao_pagamento_selecionada.nome;

          for (let i = 0; i < this.mix.itens_mix.length; i++) {
            this.mix.itens_mix[i].cor = this.mix.itens_mix[i].situacao;

            if (!this.mix.itens_mix[i].custo_difal){
              this.mix.itens_mix[i].custo_difal = this.formatarValor(0, 2);
            }
            
            if (!this.mix.itens_mix[i].protege){
              this.mix.itens_mix[i].protege = this.formatarValor(0, 2);
            }

            if (!this.mix.itens_mix[i].estorno_protege){
              this.mix.itens_mix[i].estorno_protege = this.formatarValor(0, 2);
            }
          }

          this.processando = false;
          this.abrirModalMix = true;
        } catch (error) {
          this.verificarErro(error, 'buscarMix');    
        }
      },

      async definirLoteProdutoSelecionado(){
        try {
          this.divisoes_lotes_produto_selecionado = [];

          let parametros = {
            produto_id: this.produto_selecionado_editando.produto_id,
            tipo_selecao_automatica_lote: this.produto_selecionado_editando.tipo_selecao_automatica_lote,
            ponta_estoque: this.produto_selecionado_editando.ponta_estoque ? 'S': 'N',
            tipo_entrega: this.tipo_entrega,
            bairro_id: this.endereco_cliente_selecionado.bairro_id,
            empresa_retirar_lojas_rede_id: this.produto_selecionado_editando.empresa_retirar_lojas_rede_id,
          }

          let retorno = await REstoqueBuscarDivisaoEstoque.buscarDivisaoEstoque(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          for (let i = 0; i < retorno.dados.length; i++) {
            retorno.dados[i].quantidade_utilizar_ato = 0;
            retorno.dados[i].quantidade_agendar = 0;
            retorno.dados[i].definicao_automatica = false;
          }

          this.divisoes_lotes_produto_selecionado = retorno.dados.slice(0);
          this.abrirModalDefinirLoteProduto = true;
        } catch (error) {
          this.verificarErro(error, 'definirLoteProdutoSelecionado');
        }
      },

      async atualizarDefinicaoTipoEntregaEnderecoEntrega(definir_lote, buscar_frete){
        if (this.proc_carregando_orcamento){
          return;
        }

        this.configurarEdicaoTipoFreteAndar();

        if ((this.tipo_entrega == 'ESA' || this.tipo_entrega == 'ATO' || this.tipo_entrega == 'EPG') && (this.tiposAgendamentoArray.length > 1)){
          this.tipo_agendamento_entrega = 'R';
        }

        if (this.tipo_frete_andar == ''){
          this.tipo_frete_andar = this.endereco_cliente_selecionado.tipo_acesso_imovel == 'L' ? 'EL' : 'ES';
        }

        if (definir_lote){
          for (let j = 0; j < this.produtos_selecionados.length; j++) {
            if (this.tipo_entrega == 'ESA'){
              if (this.produtos_selecionados[j].tipo_controle_estoque == 'G' && this.definicoes_lotes.length > 0) {
                swal('Foram encontradas definições de lote para produtos como grade. Estas definições serão perdidas com a seleção do tipo de entrega "Sem agendamento".');
              }

              // Removendo as definições de lote atual
              let i = 0;
              while (true) {
                if (i >= this.definicoes_lotes.length) {
                  break;
                }

                if (this.definicoes_lotes[i].produto_id == this.produtos_selecionados[j].produto_id){
                  this.definicoes_lotes.splice(i, 1); // Removendo do array as definições do produto selecionado
                } else{
                  i++;
                }
              }
            }
          }  
        } 

        await this.buscarPercValorFretePadrao();
        await this.buscarFreteRota();

        if (buscar_frete){
          await this.buscarFreteAdicionalPorAndar();
          await this.buscarFreteTiposVeiculos();
          await this.recalcularTotaisPedido(true);
        }

        if (this.tipo_agendamento_entrega == 'R'){
          await this.buscarDataMinimaEntrega(); 
        }
      },

      async buscarDataMinimaEntrega(){
        
        try {
          let tipo_data_entrega = this.tipo_agendamento_entrega == 'P' ? 'calcular_data_entrega' : 'calcular_data_minima_entrega';
          let bairro_id = 0;
          
          if (this.endereco_cliente_selecionado.bairro_id){
            bairro_id = this.endereco_cliente_selecionado.bairro_id;
          }

          let parametros = {
            tipo_data_entrega: tipo_data_entrega,
            data_minima_entrega: this.data_minima_entrega,
            tipo_agendamento_entrega: this.tipo_agendamento_entrega,
            bairro_id: bairro_id
          }

          let retorno = await REntrega.buscarDataEntrega(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          if (this.tipo_agendamento_entrega == 'P'){
            this.data_entrega = retorno.dados.data_entrega;
          }
          
          if (this.tipo_agendamento_entrega == 'E'){

            this.data_minima_entrega = '';
            this.data_entrega = retorno.dados.data_entrega ?  retorno.dados.data_entrega : this.data_entrega;

            if(this.data_entrega == '1899-12-30'){
              this.data_entrega = '';
            }
            
          }

          if (this.tipo_agendamento_entrega == 'R'){
            this.data_minima_entrega = '';
            this.data_entrega = retorno.dados.data_entrega;
            this.hora_entrega = '';
          }
        } catch (error) {
          this.verificarErro(error, 'buscarDataMinimaEntrega'); 
        }
      },

      async buscarFreteRota(){
        try {
          this.frete_rota = {};

          if (this.tipo_entrega == 'ATO' || this.tipo_entrega == 'RLR'){
            return;
          }

          if (!this.endereco_cliente_selecionado.bairro_id){
            return;
          }

          if (this.par_emp_tipo_entregas_venda == 'ZON'){
            return;
          }

          if (this.par_emp_tipo_frete_manifesto != 'R'){
            return;
          }

          let parametros = {
            bairro_id: this.endereco_cliente_selecionado.bairro_id,
            total_produtos_entregar: this.formatarValor(this.valor_total_produtos),
            peso_produtos_entregar: this.formatarValor(this.peso_total_produtos),
            usuario_digitou_valor: false
          }

          let retorno = await ROrcamentoBuscarFretePorRota.buscarFretePorRota(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.frete_rota = Object.assign({}, retorno.dados);
          
          await this.recalcularTotaisPedido();
        } catch (error) {
          this.verificarErro(error, 'buscarFreteRota'); 
        }
      },

      async buscarFreteAdicionalPorAndar(){
        try {
          this.frete_adicional_andar = 0;
          
          if (this.tipo_entrega == 'ATO' || this.tipo_entrega == 'RLR'){
            return;
          }

          if (!this.endereco_cliente_selecionado.bairro_id){
            return;
          }

          let indice_tipo_frete_andar = this.tipo_frete_andar == 'EL' ? 0 : 1;
          let condicao_pagamento_id;
          
          if (this.carregando_pedido){ 
            condicao_pagamento_id = this.condicao_pagamento_id_frete_andar;
          }
          else {
            condicao_pagamento_id = this.condicao_pagamento_selecionada.condicao_id;
          }
          
          if (!condicao_pagamento_id){
            return;
          }

          let parametros = {
            peso_total: this.formatarValor(this.peso_total_produtos),
            tipo_entrega: this.tipo_entrega,
            tipo_imovel: this.tipo_imovel,
            indice_tipo_frete_andar: indice_tipo_frete_andar,
            andar_entrega: this.endereco_cliente_selecionado.andar,
            condicao_pagamento_id: condicao_pagamento_id
          }

          let retorno = await ROrcamentoBuscarFreteAdicionalPorAndar.buscarFreteAdicionalPorAndar(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.frete_adicional_andar = retorno.dados.frete_adicional_andar;
          this.frete_adicional_andar = Biblioteca.valor(this.frete_adicional_andar);
          this.valor_frete_andar_elevador_escada = retorno.dados.valor_frete_andar_elevador_escada;
          this.valor_frete_andar_elevador_escada = Biblioteca.valor(this.valor_frete_andar_elevador_escada);

          await this.recalcularTotaisPedido();
        } catch (error) {
          this.verificarErro(error, 'buscarFreteAdicionalPorAndar');   
        }
      },

      async buscarFreteTiposVeiculos(orcamento_id){
        try {
          if (this.carregando_localStorage){
            return;
          }

          this.frete_tipos_veiculos = [];

          if (this.tipo_entrega == 'ATO' || this.tipo_entrega == 'RLR'){
            return;
          }
          
          if (!this.endereco_cliente_selecionado.bairro_id){
            return;
          }
          
          if (this.par_emp_tipo_entregas_venda == 'ZON'){
            return;
          }

          if (this.par_emp_tipo_frete_manifesto == 'R'){
            return;
          }

          let parametros = {
            bairro_id: this.endereco_cliente_selecionado.bairro_id,
            total_produtos_entregar: this.formatarValor(this.valor_total_produtos),
            peso_produtos_entregar: this.formatarValor(this.peso_total_produtos),
            usuario_digitou_valor: false,
            orcamento_id: orcamento_id
          }

          let retorno = await ROrcamentoBuscarTiposVeiculosOrcamento.buscarTiposVeiculosOrcamento(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          retorno.dados.tipos_veiculos.forEach(tipo => {
            tipo.valor_frete = Biblioteca.valor(tipo.valor_frete);
            tipo.peso_maximo = Biblioteca.valor(tipo.peso_maximo);

            if (!tipo.viagens) {
              tipo.viagens = '';
              tipo.valor_total = 0;
            }
            else {
              tipo.viagens = Biblioteca.valor(tipo.viagens);
              tipo.valor_total = 0;
            }
          });

          this.frete_tipos_veiculos = retorno.dados.tipos_veiculos;
          await this.calcularFreteTiposVeiculos();
        } catch (error) {
          this.verificarErro(error, 'buscarFreteTiposVeiculos')   
        }
      },

      async buscarPercValorFretePadrao(){
        try {
          if (this.tipo_entrega == 'ATO' || this.tipo_entrega == 'RLR'){
            this.valor_frete = 0;
          }

          if (this.valor_frete > 0){
            return;
          }

          let retorno = await ROrcamentoBuscarValorFretePadrao.buscarValorFretePadrao(this.axios);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.tipo_frete = retorno.dados.tipo_frete_padrao_orcamento;
          
          if (this.tipo_entrega == 'ATO' || this.tipo_entrega == 'RLR'){
            this.valor_frete = 0;
          } else if (this.tipo_frete == 'C'){
            this.valor_frete = Biblioteca.valor(retorno.dados.perc_frete_cif_padrao); 
          } else  {
            this.valor_frete = Biblioteca.valor(retorno.dados.valor_frete_padrao_venda);
          }

          await this.recalcularTotaisPedido();
        } catch (error) {
          this.verificarErro(error, 'buscarPercValorFretePadrao');  
        }          
      },

      async calcularFreteTiposVeiculos(){
        for (let i = 0; i < this.frete_tipos_veiculos.length; i++) {
          this.frete_tipos_veiculos[i].valor_total = (this.frete_tipos_veiculos[i].viagens * this.frete_tipos_veiculos[i].valor_frete);
        }

        await this.recalcularTotaisPedido(true);
      },

      async verificarPesoMaximoFrete(peso_total){
        try {

          if (this.tipo_entrega != 'EPG' && this.tipo_entrega != 'ESA') {
            return;
          }

          if (this.par_emp_tipo_frete_manifesto != 'P'){
            return;
          }
          
          if (!this.endereco_cliente_selecionado.bairro_id){
            return;
          }

          let bairro_id = 0;
          this.mensagem_validacao_peso_frete = ''

          if (this.endereco_cliente_selecionado.bairro_id){
            bairro_id = this.endereco_cliente_selecionado.bairro_id;
          }

          let parametros = {
            bairro_id: bairro_id,
            peso_total: peso_total ? peso_total : this.formatarValor(this.peso_total_produtos),
            tipos_veiculos: this.freteTiposVeiculosSelecionados
          }

          let retorno = await ROrcamentoVerificarPesoMaximoFreteOrcamento.verificarPesoMaximoFreteOrcamento(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.mensagem_validacao_peso_frete = retorno.dados;
        } catch (error) {
          this.verificarErro(error, 'verificarPesoMaximoFrete');
        }
      },

      async configurarFormasPagamentoFechamentoPedido(){
        try {
          this.valor_dinheiro = 0;
          this.valor_cartao_cr = 0;
          this.valor_cartao_db = 0;
          this.valor_cheque_prazo = 0;
          this.valor_cheque_vista = 0;
          this.valor_duplicata_boleta = 0;
          this.valor_acumulativo = 0;
          this.valor_pix = 0;
          this.valor_credito = 0;

          let parametros = {
            condicao_id: this.condicao_pagamento_selecionada.condicao_id,
            cliente_id: this.cliente_selecionado.cadastro_id,
            recebimento_na_entrega: (this.recebimento_na_entrega ? 'S' : 'N')
          }

          let retorno = await ROrcamentoBuscarDadosIniciaisFechamentoPedido.buscarDadosIniciaisFechamentoPedido(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.habilitar_dinheiro = (retorno.dados.habilitar_dinheiro == 'S');
          this.habilitar_acumulativo = (retorno.dados.habilitar_acumulativo == 'S');
          this.habilitar_cartao_debito = (retorno.dados.habilitar_cartao_debito == 'S');
          this.habilitar_cartao_credito = (retorno.dados.habilitar_cartao_credito == 'S');
          this.habilitar_cheque_prazo = (retorno.dados.habilitar_cheque_prazo == 'S');
          this.habilitar_cheque_vista = (retorno.dados.habilitar_cheque_vista == 'S');
          this.habilitar_duplicata_boleto = (retorno.dados.habilitar_duplicata_boleto == 'S');
          this.habilitar_credito = (retorno.dados.habilitar_credito == 'S');
          this.habilitar_pix = (retorno.dados.habilitar_pix == 'S');
        } catch (error) {
          this.verificarErro(error, 'configurarFormasPagamentoFechamentoPedido');
        }
      },

      async buscarTipoPreco(){
        try {
          this.tipo_preco = null;

          if (!this.cliente_selecionado.cadastro_id || !this.condicao_pagamento_selecionada.condicao_id) {
            return; 
          }

          let parametros = {
            cadastro_id: this.cliente_selecionado.cadastro_id,
            condicao_id: this.condicao_pagamento_selecionada.condicao_id    
          }

          let retorno = await ROrcamentoBuscarTipoPrecoCliente.buscarTipoPrecoCliente(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.tipo_preco = retorno.dados.tipo_preco;
        } catch (error) {
          this.verificarErro(error, 'buscarTipoPreco');
        }
      },

      getCorMix: function(cor){
        return 'color: ' + cor;
      },

      getCorLucro: function (lucro){
        if (parseFloat(lucro) > 0)
          return "w3-text-green";
        else
          return "w3-text-theme";      
      },

      mostrarModalClienteConsumidorFinal: function () {
        this.pesquisando = false;
        this.processo_apos_coletar_consumidor_final = '';
        this.$refs.coletarDadosConsumidorFinal.abrir(this.dados_consumidor_final);
      },

      mostrarModalBairroConsumidorFinal: function () {
        this.pesquisando = false;
      },

      async mostrarModalFechamentoOrcamento(){
        if (this.produtos_selecionados.length == 0){
          Biblioteca.exclamar('É necessário informar os produtos para fechar o orçamento!');
          return;
        }

        if (this.validarDadosEndereco()){
          return;
        }

        if (await this.exigirPreenchimentoDadosConsumidorFinal('GRAVAR_ORCAMENTO')){
          return;
        }

        await this.calcularTotaisFechamentoPedido();
        await this.calcularDescontoCapaOrcamento('VALOR');
        
        this.abrirModalFechamentoOrcamento = true;
      },

      validarDadosEndereco: function(){
        let tipo_entrega = '';

        if (this.tipo_entrega == 'EPG'){
          tipo_entrega = 'Entregar';
        }else if (this.tipo_entrega == 'ESA'){
          tipo_entrega = 'Sem agendamento';
        }else{
          tipo_entrega = 'No ato';
        }

        if
          (
            (this.tipo_entrega == 'ESA' || this.tipo_entrega == 'EPG') &&
            (
              (!this.endereco_cliente_selecionado.logradouro) ||
              (!this.endereco_cliente_selecionado.complemento) ||
              (!this.endereco_cliente_selecionado.bairro_id) ||
              (!this.endereco_cliente_selecionado.cep)
            )
          )
        {
          Biblioteca.exclamar('Na gravação de pedido/orçamento do tipo ' + tipo_entrega + ' é necessário carregar o endereço!');
          return true;
        }

        if ((this.tipo_entrega == 'ESA' || this.tipo_entrega == 'EPG') && ((!this.observacoes_endereco) || (this.observacoes_endereco.length === 0))){
          Biblioteca.exclamar('Nas vendas do tipo ' + tipo_entrega + ' a observação de endereço é obrigatória!');
          return true;
        }

        if
          (
            (this.par_emp_tipo_obrig_endereco_entrega == 'T') &&
            (
              (!this.endereco_cliente_selecionado.logradouro) ||
              (!this.endereco_cliente_selecionado.complemento) ||
              (!this.endereco_cliente_selecionado.bairro_id) ||
              (!this.endereco_cliente_selecionado.cep)
            )
          )
        {
          Biblioteca.exclamar('Na gravação do pedido/orçamento é necessário carregar o endereço, quando o parâmetro de empresa "Tipo de obrigatoriedade do endereço de entrega" estiver selecionado "Todos os casos de venda"!');
          return true;
        }

        if
          (
            (this.par_emp_tipo_obrig_endereco_entrega == 'A') &&
            (this.condicao_pagamento_selecionada.acumulativo_forma_pagamento == 'S') &&
            (
              (!this.endereco_cliente_selecionado.logradouro) ||
              (!this.endereco_cliente_selecionado.complemento) ||
              (!this.endereco_cliente_selecionado.bairro_id) ||
              (!this.endereco_cliente_selecionado.cep)
            )
          )
        {
          Biblioteca.exclamar('Na gravação do pedido/orçamento é necessário carregar o endereço, quando for venda no acumulativo e o parâmetro de empresa "Tipo de obrigatoriedade do endereço de entrega" estiver selecionado "Regra normal, porém sempre exigir se a venda for acumulativa"!');
          return true;
        }

        if
          (
            ((this.cliente_selecionado.tipo_cliente == 'U') || (this.cliente_selecionado.tipo_cliente == 'O')) &&
            ((this.condicao_pagamento_selecionada.acumulativo_forma_pagamento == 'S') || (this.enderecos_cliente.length > 1)) &&
            (
              (!this.endereco_cliente_selecionado.logradouro) ||
              (!this.endereco_cliente_selecionado.complemento) ||
              (!this.endereco_cliente_selecionado.bairro_id) ||
              (!this.endereco_cliente_selecionado.cep)
            )
          )
        {
          Biblioteca.exclamar('Na gravação do pedido/orçamento é necessário carregar o endereço, quando o cliente e produtor rural ou construtora e esta comprando no acumulativo!');
          return true;
        }

        if (!this.endereco_cliente_selecionado.inscricao_estadual){
          this.endereco_cliente_selecionado.inscricao_estadual = '';
        }

        if (!this.endereco_cliente_selecionado.logradouro){
          this.endereco_cliente_selecionado.logradouro = '';
        }

        if (!this.endereco_cliente_selecionado.complemento){
          this.endereco_cliente_selecionado.complemento = '';
        }

        if (!this.endereco_cliente_selecionado.bairro_id){
          this.endereco_cliente_selecionado.bairro_id = 0;
        }

        if (!this.endereco_cliente_selecionado.cep){
          this.endereco_cliente_selecionado.cep = '';
        }

        if (!this.endereco_cliente_selecionado.ponto_referencia){
          this.endereco_cliente_selecionado.ponto_referencia = '';
        }

        if (!this.endereco_cliente_selecionado.tipo_imovel){
          this.endereco_cliente_selecionado.tipo_imovel = 'NIN';
        }

        if (!this.endereco_cliente_selecionado.tipo_acesso_imovel){
          this.endereco_cliente_selecionado.tipo_acesso_imovel = 'N';
        }

        if (!this.endereco_cliente_selecionado.andar){
          this.endereco_cliente_selecionado.andar = 0;
        }

        if (!this.observacoes_endereco){
          this.observacoes_endereco = '';
        }
      },

      exigirPreenchimentoDadosConsumidorFinal(tipo_processo){
        
        if(this.cliente_consumidor_final){

          console.log(this.dados_consumidor_final);

          if(Biblioteca.stringVazia(this.dados_consumidor_final.consumidor_final_nome)){
            swal('O nome do cliente tem que ser informado quando é consumidor final!');
            this.processo_apos_coletar_consumidor_final = tipo_processo;
            this.$refs.coletarDadosConsumidorFinal.abrir(this.dados_consumidor_final);
            return true; 
          }

          if(Biblioteca.stringVazia(this.dados_consumidor_final.consumidor_final_telefone) && this.tipo_entrega == 'RLR'){
            swal('É necessário informar um telefone válido para consumidor final com o tipo de entrega "Retirar lojas rede!');
            this.processo_apos_coletar_consumidor_final = tipo_processo;
            this.$refs.coletarDadosConsumidorFinal.abrir(this.dados_consumidor_final);
            return true; 
          }

        }
        
        return false;
      },

      async mostrarModalFecharPedido(){
 
        
        const valorInput = this.$refs.frVendedor.chave_pesquisa;

        if (valorInput != "") {
          await this.$refs.frVendedor.inserirDadoPorChave(valorInput);
        }

        if (!this.vendedor_selecionado.funcionario_id) {
          Biblioteca.exclamar('O vendedor deve ser selecionado!');
          return;
        }

        
        if (this.produtos_selecionados.length == 0){
          Biblioteca.exclamar('É necessário informar os produtos para fechar o pedido!');
          return;
        }


        if ((this.tipo_entrega == 'ATO' || this.tipo_entrega == 'RLR') && (this.valor_frete > 0 || this.valor_total_st_frete > 0)){
          Biblioteca.exclamar('Pedidos com entregas do tipo "' + (this.tipo_entrega == 'ATO' ? 'No ato' : 'Retirar lojas rede') + '" não pode ser cobrado frete!');
          return;
        }
        
        if (await this.validarDadosEndereco()){
          return;
        }

        await this.calcularTotaisFechamentoPedido();

        if (await this.exigirPreenchimentoDadosConsumidorFinal('FECHAR_PEDIDO')){
          return;
        }

        if (this.tipo_entrega != 'ATO') {
          this.$refs.modal_ato.abrir();
          return;
        } else {
          let existe_produto_controla_lote = false; 
          
          for (let i = 0; i < this.produtos_selecionados.length; i++) {
            if (!existe_produto_controla_lote){
              if (this.produtos_selecionados[i].tipo_controle_estoque == 'L' || this.produtos_selecionados[i].tipo_controle_estoque == 'P'){
                existe_produto_controla_lote = true;
                break;
              }
            }
          }
          
          // this.tipo_selec_local_entrega_ato != 'N' ||
          if (this.vendedor_selecionado.tipo_local_padrao_entrega_ato != 'N' || existe_produto_controla_lote) {
            this.$refs.modal_ato.abrir();
            return;
          }
        }

        await this.configurarFormasPagamentoFechamentoPedido();
        await this.verificarPesoMaximoFrete();        

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          this.produtos_selecionados[i].quantidade_entrega_ato = this.formatarValor(this.produtos_selecionados[i].quantidade);
        }
        
        this.abrirModalFecharPedido = true;
      },

      aplicarDescontoImpostos(){
        let retorno = 'N';

        if (this.abrirModalFecharPedido || this.abrirModalFechamentoOrcamento || this.abrirModalOpcoesBloqueioProposta){
          retorno = 'S';
        }

        return retorno;
      },

      async calcularImpostosDescontoFechamentoPedido(){
        if (Biblioteca.valor(this.perc_desconto_venda) == 0){        
          this.valor_desconto =  0;
          this.perc_desconto_venda =  0;        
        }

        var produtos_orcamento = [];

        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          produtos_orcamento[i] = Object.assign({}, this.produtos_selecionados[i]);
        }

        for (let i = 0; i < produtos_orcamento.length; i++) {
          produtos_orcamento[i].produto_id = Biblioteca.valorInt(produtos_orcamento[i].produto_id);
          produtos_orcamento[i].preco_venda = Biblioteca.valor(produtos_orcamento[i].preco);
          produtos_orcamento[i].quantidade = Biblioteca.valor(produtos_orcamento[i].quantidade);
          produtos_orcamento[i].usou_promocao = produtos_orcamento[i].usou_promocao == 'S' || produtos_orcamento[i].usou_promocao_especial == 'S' ? 'S' : 'N';
          produtos_orcamento[i].kit = produtos_orcamento[i].kit;
          produtos_orcamento[i].valor_total = produtos_orcamento[i].total_item;
        }

        await this.recalcularPrecosProdutos('NENHUM', 'N', false, true);
        await this.calcularDescontoCapaOrcamento('VALOR');
        await this.calcularTotaisFechamentoPedido();
        await this.recalcularTotaisPedido(true);
      },

      mostrarModalOpcoesProduto(produto_selecionado){
        this.definirProdutoSelecionado(produto_selecionado);
        this.abrirModalOpcoesProduto = true;
      },

      definirProdutoSelecionado(produto_selecionado){
        this.produto_selecionado_editando = Object.assign({}, produto_selecionado);
        this.produto_selecionado = Object.assign({}, produto_selecionado);
      },

      produtoAceitaDesconto(produto){
        return ((produto.usou_promocao == 'N') && (!produto.ponta_estoque) && (produto.usou_promocao_especial == 'N'));
      },

      mostrarModalCopiarPedido(){
        this.abrirModalCopiarPedido = true;
        this.$nextTick(() => this.$refs.codigo_copiar_pedido.focus());
      },

      mostrarModalDescontoPorProduto(){
        if (this.produtos_selecionados.length == 0){
          Biblioteca.exclamar("É necessário informar os itens para definição de desconto por item!");
          return;
        }

        let existe_prod_per_desc = false;
        for (let i = 0; i < this.produtos_selecionados.length; i++) {
          if (this.produtoAceitaDesconto(this.produtos_selecionados[i])){
            existe_prod_per_desc = true;  
          }

          this.produtos_selecionados[i].perc_desconto_temp = this.produtos_selecionados[i].perc_desconto;
        }

        if (!existe_prod_per_desc){
          swal('Nenhum dos produtos do pedido permite utilizar desconto/acréscimo. Pois todos os produtos estão utilizando promoção ou ponta estoque.');
          return;
        }

        this.calcularPreviaDescontoTodosProdutos();
        this.abrirModalDescontoProduto = true;
      },

      mostrarModalFrete: function(){
        if (this.produtos_selecionados.length == 0){
          Biblioteca.exclamar("É necessário informar os itens para definição de frete!");
          return;
        }
        
        this.abrirModalFrete = true;
      },

      async buscarAvisosRestricoesCliente(campo, informativo, carregando_orcamento, fechando_pedido){
        if (Biblioteca.valor(this.cliente_selecionado.cadastro_id) <= 0){
          return;
        }

        await this.$refs.mostrarAvisosNaVenda.buscarAvisosRestricoesCliente(
          this.condicao_pagamento_selecionada.condicao_id, 
          this.cliente_selecionado.cadastro_id, 
          this.vendedor_selecionado.funcionario_id, 
          this.total_liquido, 
          fechando_pedido ? 'S':'N',
          carregando_orcamento ? 'S':'N',
          informativo ? 'S':'N', 
          this.tipo_entrega,
          campo
        );
      },

      async retornoAvisosNaVenda(retorno){
        if (retorno.dados.houve_bloqueio === 'S') {
          if (retorno.dados.campo === 'tpCampoCliente'){
            swal(retorno.dados.mensagem);
            await this.$refs.frCliente.limparDados();
            return;
          }
          else if (retorno.dados.campo === 'tpCampoCondicaoPagamento'){
            swal(retorno.dados.mensagem);
            await this.$refs.frCondicaoPagamento.limparDados();
            this.processando_restricoes = true;
            
            if (Biblioteca.valor(retorno.dados.condicao_padrao_id) > 0){
              await this.$refs.frCondicaoPagamento.inserirDadoPorChave(retorno.dados.condicao_padrao_id);
            }

            this.processando_restricoes = false;
            return;
          }
        }

        if (Biblioteca.valor(retorno.dados.condicao_padrao_id) > 0){
          await this.$refs.frCondicaoPagamento.inserirDadoPorChave(retorno.dados.condicao_padrao_id);
          return;
        }
      
        if (retorno.dados.msg_quest_cli_vin_out_ven){
          await swal(
            retorno.dados.msg_quest_cli_vin_out_ven, 
            {
              buttons: {
                sim: "Sim",
                nao: "Não"                
              },
            }
          ).then(async (value) => {
            switch (value) {
              case "sim": await this.$refs.frVendedor.inserirDadoPorChave(retorno.dados.vendedor_vinc_cli);
            }
          });
        }
        
        await this.$refs.mostrarAvisosNaVenda.exibirAvisosNaVenda(retorno.dados.avisos);
      },

      exibirCaracteristicasProduto(produto){
        this.$refs.mdCaracteristicasProduto.exibirModal(produto);
      },

      exibirEstoqueRedeProduto(produto){
        this.$refs.mdEstoqueRedeProduto.exibirModal(produto);
      },

      exibirAssistenciasTecnicas(produto){
        this.$refs.mdAssistenciaTecnica.exibirModal(produto);
      },

      mostrarModalSelecionarEnderecosCliente: function(){
        if (!this.cliente_selecionado.cadastro_id){
          Biblioteca.exclamar("É necessário informar o cliente para definição de endereço de entrega!");
          return;
        }

        this.buscarEnderecosEntrega();
        this.abrirModalSelecionarEnderecosCliente = true;
      },

      exibirDadosProdutosVendidos(produto){
        this.$refs.dadosProdutosVendidos.exibirModal(produto.produto_id, this.cliente_selecionado.cadastro_id);
      },

      getCorGrupoPromocao(produto) {
        if((produto.usou_promocao == 'N') && (produto.usou_promocao_especial == 'N'))
          return;

        if (produto.cor_promocao_tela_vendas === '#008000') // verde
          return 'background-color: #d5f5e4'
        else if (produto.cor_promocao_tela_vendas === '#800080') // roxo
          return 'background-color: #efccff';
      },

      configurarCarregandoPedido(){
        this.carregando_pedido = 
          (
            this.proc_carregando_orcamento && 
            (
              (!this.condicao_pagamento_selecionada.condicao_id) || 
              (!this.vendedor_selecionado.funcionario_id) || 
              (!this.cliente_selecionado.cadastro_id)
            )
          ); 
        
        if (this.proc_carregando_orcamento){
          this.proc_carregando_orcamento = 
            (!this.condicao_pagamento_selecionada.condicao_id) || 
            (!this.vendedor_selecionado.funcionario_id) || 
            (!this.cliente_selecionado.cadastro_id);
        }
      },

      configurarEdicaoTipoFreteAndar: function(){
        this.permitir_edicao_tipo_frete_andar = this.endereco_cliente_selecionado.tipo_acesso_imovel == 'L';
      },

      frontEndDateFormat(date) {
        if (!date){
          return "";
        }

        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },

      mostrarValoresOrcamento: function () {
        this.mostrarValoresTotais = !this.mostrarValoresTotais
        let div_valores = document.getElementById("valores_orcamento");
        let label_valores = Array.from(div_valores.getElementsByTagName('label'));
        
        if (this.transicao_valores_pedido) {
          div_valores.classList.replace("fadeIn", "hidden");
        } else {
          div_valores.classList.replace("hidden", "fadeIn");       
          if (parseInt(window.screen.availWidth) <= 425) {
            label_valores.forEach(elemento => {elemento.classList.replace("w3-left", "w3-center")});
          } else {
            label_valores.forEach(elemento => {elemento.classList.replace("w3-center", "w3-left")});
          }
        }
        this.transicao_valores_pedido = !this.transicao_valores_pedido;
      },

      mostrarOcularFiltros: function(){
        this.mostrar_filtros = !this.mostrar_filtros
      },

      preecherCampoFechamentoPedido: function(event, tipo, nome_campo){
        this.contador_click++;

        if(this.contador_click === 1) {
          this.timer = setTimeout(function() {
            this.contador_click = 0
          }, this.delay);
        } else{
            clearTimeout(this.timer);  

            if (this.total_formas_pagamento >= this.total_liquido){
              this.contador_click = 0; 
              return;
            }
            let valor_restante = this.total_liquido - this.total_formas_pagamento
            let campo = document.getElementById(nome_campo)            
            if (campo.disabled){
              this.contador_click = 0;
              return;
            }
            
            switch (tipo) {
              case 'VVD':
                this.valor_dinheiro = valor_restante;
                break
              case 'VCV':
                this.valor_cheque_vista = valor_restante;
                break
              case 'VCD':
                this.valor_cartao_db = valor_restante;
                break
              case  'VCP':          
                this.valor_cheque_prazo = valor_restante;
                break
              case 'VCC':
                this.valor_cartao_cr = valor_restante;
                break
              case 'VDB':          
                this.valor_duplicata_boleta = valor_restante;
                break
              case 'VVA'  :
                this.valor_acumulativo = valor_restante;
                break
              case 'PIX'  :
                this.valor_pix = valor_restante;
                break
              case 'VCR':
                this.valor_credito = valor_restante; 
                break
              default:
                return;
            }

            this.contador_click = 0;
        }  
      },

      async limparVendedor(){
        this.vendedor_selecionado = {};
        await this.armazenarLocalStorage('VENDEDOR', this.vendedor_selecionado);
      },

      async limparCliente(){
        this.cliente_selecionado = {};
        await this.armazenarLocalStorage('CLIENTE', this.cliente_selecionado);
      },

      async limparCondicaoPagamento(){
        this.condicao_pagamento_selecionada = {}; 
        await this.armazenarLocalStorage('CONDICAO', this.condicao_pagamento_selecionada);
      },

      verificarTipoEntrega: function(tipo_entrega){
        this.classe_botao_tipo_entrega_ent = 'botao-tipo-entrega'
        this.classe_botao_tipo_entrega_sem = 'botao-tipo-entrega'
        this.classe_botao_tipo_entrega_ato = 'botao-tipo-entrega'
        this.classe_botao_tipo_entrega_rlr = 'botao-tipo-entrega'

        if (tipo_entrega == 'ATO'){
          this.classe_botao_tipo_entrega_ato = 'botao-tipo-entrega-selecionado'
        } else if (tipo_entrega == 'EPG'){
          this.classe_botao_tipo_entrega_ent = 'botao-tipo-entrega-selecionado'
        } else if (tipo_entrega == 'ESA'){
          this.classe_botao_tipo_entrega_sem = 'botao-tipo-entrega-selecionado'
        } else if (tipo_entrega == 'RLR'){
          this.classe_botao_tipo_entrega_rlr = 'botao-tipo-entrega-selecionado'
        }

        this.atualizarDefinicaoTipoEntregaEnderecoEntrega(true, true);
        this.recalcularTotaisPedido(true);
      },

      alterarQuantidadeProduto(produto){
        this.produto_selecionado = produto;
        this.quantidade_produto_selecionado = this.produto_selecionado.quantidade;
        this.abrirModalAtualizarQuantidade = true;
        this.$nextTick(() => this.$refs.quantidade_produto.focus());
      },

      calcularDescontoCapaOrcamento(campo) {    
        if (campo == 'PERC') {          
          this.valor_desconto = this.Arredondar(Biblioteca.valor(this.perc_desconto_venda) * Biblioteca.valor(this.total_preco_normal) / 100, 2);          
        } 
        else {  
          this.perc_desconto_venda = this.Arredondar((100 * Biblioteca.valor(this.valor_desconto) / Biblioteca.valor(this.total_preco_normal)), 4);          
        }        
      },

      trocarAba(botao, novaAba){
        let tablinks = document.getElementsByClassName("tablink");
        for (let i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        this.abaSelecionada = novaAba
        document.getElementById(botao).className += " active";        

        this.abaSelecionada = novaAba;
      },

      totalizarDivisoesProdutoSelecionado: function(){
        let valor_total = 0;

        for (let i = 0; i < this.divisoes_lotes_produto_selecionado.length; i++) {
          valor_total += this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato + this.divisoes_lotes_produto_selecionado[i].quantidade_agendar;
        }

        this.totalizador_divisoes_produto_selecionado = valor_total;
      },

      async definirLotesProdutoSelecionado(){
        if (this.formatarValor(this.totalizador_divisoes_produto_selecionado) != this.formatarValor(this.produto_selecionado_editando.quantidade)){
          swal({
            title: "Definições de lotes do produto",
            text: 'A quantidade selecionada para os lotes do produto é diferente da quantidade selecionada para o produto!',
            icon: "error",
            button: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                closeModal: true,
              },
            },
          });

          return;
        }

        let empresa = undefined;
        let multiplo_venda = undefined;
        let contem_multiplo_errado = false;
        let quantidade_utilizada = undefined;
        for (let i = 0; i < this.divisoes_lotes_produto_selecionado.length; i++) {
          if (((this.tipo_entrega == 'ATO') && (this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato > Biblioteca.valor(this.produto_selecionado_editando.estoque_ato))) ||
            ((this.tipo_entrega == 'EPG') && (this.divisoes_lotes_produto_selecionado[i].quantidade_agendar > this.produto_selecionado_editando.estoque_agendamento))
          ){
            swal({
              title: "Definições de lotes do produto",
              text: 'Estoque insuficiente para a divisão selecionada! Lote ' + this.divisoes_lotes_produto_selecionado[i].local_id + ' - ' + this.divisoes_lotes_produto_selecionado[i].nome_local,
              icon: "error",
              button: {
                confirm: {
                  text: "OK",
                  value: true,
                  visible: true,
                  closeModal: true,
                },
              },
            });

            return;
          }

          if (Math.round(this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato % Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].multiplo_venda) * 100) / 100 != 0){
            quantidade_utilizada = this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato;
            multiplo_venda = this.divisoes_lotes_produto_selecionado[i].multiplo_venda; 
            empresa = this.divisoes_lotes_produto_selecionado[i].nome_empresa;
            contem_multiplo_errado = true;
            break;
          }

          if (Math.round(this.divisoes_lotes_produto_selecionado[i].quantidade_agendar % Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].multiplo_venda) * 100) / 100 != 0){
            quantidade_utilizada = this.divisoes_lotes_produto_selecionado[i].quantidade_agendar;
            multiplo_venda = this.divisoes_lotes_produto_selecionado[i].multiplo_venda;
            empresa = this.divisoes_lotes_produto_selecionado[i].nome_empresa;
            contem_multiplo_errado = true;
            break;
          }
        }

        if (contem_multiplo_errado){
          swal({
            title: "Definições de lotes do produto",
            text: 'A quantidade informada (' + this.formatarValor(quantidade_utilizada, 3) + ') do produto ' + this.formatarValor(this.produto_selecionado_editando.produto_id, 0) + ' - ' + this.produto_selecionado_editando.nome + ' ' +
            'não se adequa ao seu múltiplo de venda (' + multiplo_venda + ') - ' + empresa + '!',
            icon: "error",
            button: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                closeModal: true,
              },
            },
          });

          return;
        }

        try {
          let definicoes = Object.assign([], this.divisoes_lotes_produto_selecionado);

          for (let i = 0; i < this.divisoes_lotes_produto_selecionado.length; i++) {
            definicoes[i].quantidade_ent_ato = this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato;
          }

          let parametros = {
            definicoes_lotes: definicoes
          }

          let retorno = await ROrcamentoBuscarEntregasNoAto.buscarEntregasNoAtoVerificarDadosLotes(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          let i = 0;
          while (true) {
            if (i >= this.definicoes_lotes.length)
              break;

            if (Biblioteca.valorInt(this.definicoes_lotes[i].produto_id) == Biblioteca.valorInt(this.produto_selecionado_editando.produto_id))
              this.definicoes_lotes.splice(i, 1); // Removendo do array as definições do produto selecionado
            else
              i++;
          }

          for (let i = 0; i < this.divisoes_lotes_produto_selecionado.length; i++) {
            if ((Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato) > 0) || (Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].quantidade_agendar) > 0))
              this.definicoes_lotes.push(Object.assign({}, this.divisoes_lotes_produto_selecionado[i]));
          }

          this.abrirModalDefinirLoteProduto = false;
        } catch (e) {
          swal({
            title: "Definições de lotes do produto",
            text: e.message,
            icon: "error",
            button: {
              confirm: {
              text: "OK",
              value: true,
              visible: true,
              closeModal: true,
              },
            },
          });
        }
      },

      lotesDefinidosProduto: function(produto_id) {
        let lotes = [];

        for (let i = 0; i < this.definicoes_lotes.length; i++) {
          if (this.definicoes_lotes[i].produto_id == produto_id) {
            lotes.push(this.definicoes_lotes[i].lote);
          }
        }

        return lotes;
      },

      limparConsumidorFinal(){    
        this.dados_consumidor_final = {};
      },

      async carregarDadosClienteExistente(cliente_id){
        await this.limparConsumidorFinal();
        await this.$refs.frCliente.inserirDadoPorChave(cliente_id);
      },

      async carregarDadosConsumidorFinal(retorno_consumidor_final){
        this.dados_consumidor_final = {};
        if (retorno_consumidor_final && Object.keys(retorno_consumidor_final).length > 0){
          this.dados_consumidor_final = await JSON.parse(JSON.stringify(retorno_consumidor_final));

          if (this.processo_apos_coletar_consumidor_final == 'GRAVAR_ORCAMENTO'){
            this.mostrarModalFechamentoOrcamento(); 
          } else if (this.processo_apos_coletar_consumidor_final == 'FECHAR_PEDIDO'){
            this.mostrarModalFecharPedido();
          }
        }
      },

      getClassDiferencaPagamento(){
        let retorno = "w3-input w3-border ";

        if (this.valor_dif_pagamento < 0){
          retorno += "texto-vermelho";
        } else{
          retorno += "w3-text-indigo";
        }

        return retorno;
      },

      valor(numero){
        return Biblioteca.valor(numero);
      },

      async gerarNovoHashPedido(){
        this.hash_pedido = '';
        try {
          this.hash_pedido = (Math.floor(Math.random() * 1000) + moment(new Date(), 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') + '').replace(/\s/g, '').replace(/[^0-9]/g, '');
        } catch (e) {
          this.hash_pedido = Math.floor(Math.random() * 1000);
        }

        await this.armazenarLocalStorage('HASH_PEDIDO', this.hash_pedido);
      },

      async gerarHashPedidoEnvio(){
        let retorno = '';

        try {
          retorno = await ( 
            (
              this.hash_pedido + 
              this.cliente_selecionado.cadastro_id + 
              this.vendedor_selecionado.funcionario_id +
              this.condicao_pagamento_selecionada.condicao_id + 
              this.total_liquido
            ).
            replace(/\s/g, '').
            replace(/[^0-9]/g, '').
            substring(0, 39)
          );
        } catch (e) {
          retorno = '';
        }

        return retorno;
      },

      verificarErro(erro, nome_funcao){
        this.processando = false;
        this.recarregar_tela = '';
        this.reprocessando_prod = false;
        this.proc_carregando_orcamento = false;
        this.carregando_dados_iniciais = false;
        Biblioteca.gerarLogNomeFuncao('Orcamentos.vue -> ' + nome_funcao);
        let mensagem = Biblioteca.tratamentoMensagem(erro);
        Biblioteca.exclamar(mensagem);
      },

      async redefinirDadosIniciaisOrcamentos(){
        await this.armazenarLocalStorage('REDEFINIR');
        await this.limparConsumidorFinal();        
        await this.carregarDadosIniciaisTelaVendas();
        await this.gerarNovoHashPedido();
      }
    },

    async mounted() {
      let query = this.$route.query;
      
      // Parâmetro executado pela carteira de clientes.
      if (Biblioteca.valorInt(query.cadastro_id) > 0) {
        await this.carregarDadosIniciaisTelaVendas();
        await this.$refs.frCliente.inserirDadoPorChave(query.cadastro_id);

        // Limpando o "cadastro_id" do router query
        this.$router.replace({query: {cadastro_id: undefined}});
      } else if (
        (query.orcamento) &&
        (Biblioteca.valorInt(query.orcamento.orcamento_id) > 0) && 
        (Biblioteca.em(query.orcamento.copiando_pedido, ['S', 'N']))
      ) {
        await this.redefinirDadosIniciaisOrcamentos();
        await this.carregarOrcamentoEdicao(query.orcamento.orcamento_id, query.orcamento.copiando_pedido);

        this.$router.replace({query: {orcamento: undefined}});
      } else {
        // Limpando os dados do local storage caso o usuário logado seja diferente do armazenado.
        await this.verificarUsuarioLogadoLocalStorage();

        // Buscando os dados do local storage.
        let local = await JSON.parse(localStorage.getItem('localStorage'));

        if 
          ( 
            (local) &&
            (local.orcamentos_pedido_offline) && 
            (!local.orcamentos_pedido_offline.orcamento_id) &&
            (local.orcamentos_pedido_offline.produtos_selecionados) && 
            (local.orcamentos_pedido_offline.data_ultima_atualizacao == this.frontEndDateFormat(new Date()))
          ) 
        {
          await swal("Deseja retornar com o antigo orçamento?", {
            buttons: {            
              sim: "Sim",
              nao: "Não"
            },
            showLoaderOnConfirm: true
          })
          .then(async (value) => {
            switch (value) {
              case "nao":
                await this.redefinirDadosIniciaisOrcamentos();
                break;
              case "sim":
                this.recuperarDados = true;
                await this.carregarDadosIniciaisTelaVendas();
                
                // Atualizando parâmetros localstorage
                let local_parametros_atualizados = await JSON.parse(localStorage.getItem('localStorage'));
                local.orcamentos_parametros_offline = await JSON.parse(JSON.stringify(local_parametros_atualizados.orcamentos_parametros_offline));
                
                // Preenchendo com os dados dos parâmetros atualizados.
                await this.preencherOrcamentoLocalStorage(local);
                Biblioteca.informar("Orçamento carregado com sucesso.");

                break;
            }
          });
          return;
        } else {
          await this.redefinirDadosIniciaisOrcamentos();
        }
      } 
    },

    async created(){
      window.addEventListener('beforeunload', function(evt) {
        // Esta mensagem não é a que será exibida. O browser apenas valida se este evento está declarado e ele mesmo define o que será exibido.
        var message = 'Deseja realmente sair da página?';
        if (typeof evt == 'undefined') {
          evt = window.event;
        }
        if (evt) {
          evt.returnValue = message;
        }
        
        return message;
      });

      await store.commit('SET_MODULO_SISTEMA_ID', 1);
    }    
  }

</script>

<style scoped>
  .card-mensagem:hover { background-color: #fff !important }
  .card-mensagem:hover label{ color: #9c1d1c !important; }
  .card-mensagem:hover p,
  .card-mensagem:hover span{color: #636363 !important}

  h2{
    border-bottom: 1px solid #9c1d1c;
  }

  @media screen and (max-width: 490px){
    #tabPrincipais div span:first-of-type{
      margin-bottom: 0px !important;
    }
  }

  @media screen and (min-width: 1200px){
    .bloco-consumidor-final button{
      margin-left: 10px !important;
      height: 90%;
    }

    .bloco-consumidor-final div{
      width: calc(100% - 8.33333% - 10px);
    }

    .card-produto button:hover{
      background-color: #9c1d1c !important;
      color: #fff !important;
      box-shadow: 0px 2px 32px #00000090;
    }
  }
  
  @media screen and (max-width: 767px){
    .margin-0-mobile{
      margin-top: 0px !important;
    }
    .card-produto{
      margin:10px 0 !important;
    }
    h2{
      font-size: 24px;
      margin-bottom:15px;
    }
    h5 {
      margin-left: 0 !important;
    }
    #principal > .w3-container{
      padding:0 !important;
    }

    .fechar-pedido{
      width: calc(100% - 32px);
      margin: 0 16px;
    }

    .div-btn-filtro {
      margin-top: 0 !important;
      margin-bottom: 16px;
    }

    .padding-info {
      padding: 0;
    }

    .recebimento-mobile {
      margin-top: 16px !important;
      text-align: center;
    }

    .table-entrega-ato .max-width .check-no-ato {
      width: 18px !important;
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
  }

  .w3-modal {
    padding-top: 60px !important;
    padding-bottom: 10px;
  }

  .disable {
    opacity: 0.5
  }

  .enable {
    opacity: 1
  }

  .switch-input {
    display: none;
  }

  .max-width {
    height: 42px
  }

  .input-entra-ato {
    color: rgb(55, 128, 55);
    text-align: center;
    cursor: pointer;
    
    border-bottom: none;
    border-color: transparent;
    background-color: rgba(144, 238, 144, 0.21);

    width: 100% !important;
    height: 100% !important;
  }

  .input-entra-ato:focus {
    border-color: rgb(50, 156, 50);
    outline: none;
    border-bottom: 2px solid;
    -webkit-appearance: none;
  }

  .sem-agendamento {
    background-color: #ff000021; 
    color: red;     
  }

  .check-no-ato {
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .hide-data-previsao {
    display: none;
  }

  .drop-down-ato {
    padding: 5px;
    cursor: default !important;     
    margin-bottom: 5px  ;  
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;     
    width: 315px !important;
  }

  .dropdown-esquerda{
    right:0 !important;
  }

  .tr-items:hover {
	  background: #9c1d1cb8;
    color:#fff;
    cursor: pointer;
  }
  .tr-items-ativo:hover {
    background: #9c1d1c;
    color: white;
  }
  .tr-items-ativo {
    background: #9c1d1c;
    color: white;
  } 

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar:horizontal {
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd; 
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }

  .card-produto{
    background-color: #ebebeb;
    border: 2px solid #ebebeb;
    padding: 10px;
    border-radius: 20px;
  }

  .card-produto.active{
    background: #ebebeb;
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%
  }

  .card-item {
    margin-top: 0 !important
  }

  .legenda-redonda {    
    padding: 5px;
    border-radius: 15px;  
  }

  .botoes-cinza {
    border: 1px solid red;
  }

  .botao-tipo-entrega {
    padding: 5px 0 5px 0; 
    width: 98%;
    border-radius: 20px;
    outline: 0;
    background-image: linear-gradient(to right, #dddddd, #cccccc);
    color: #000000;
    border: 1px solid #aaaaaa;
    cursor: pointer;
  }

  .cor-fonte-car-itens {
    color: #1a1a1a;
  }

  .botao-tipo-entrega-selecionado {
    background-image: linear-gradient(to right, #9c1d1c, #691212);
    color: #ffffff;
    border: 1px solid #cccccc;
  }

  .botao-consumidor-final {
    margin-top: 24px;
  }

  #quantidade_pesquisa, .btn-qtd{
    height: 30px !important;
    padding: 0 10px !important;
    font-size: 14px;
  }

  .link{
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;  
  }

  .card-endereco {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    cursor: pointer;
  }

  .card-tipo-veiculo{
    background-color: #dedcdc;
    border: 2px solid #dedcdc;
    padding: 10px;
    border-radius: 20px;
    box-shadow: #c9c9c9 1px 1px 1px 1px;
  }

  @keyframes fa-blink {
    0% {opacity: 1;}
    100% {opacity: 0;}
  }

  .fa-blink {
    -webkit-animation: fa-blink .850s linear infinite;
    -moz-animation: fa-blink .850s linear infinite;
    -ms-animation: fa-blink .850s linear infinite;
    -o-animation: fa-blink .850s linear infinite;
    animation: fa-blink .850s linear infinite;
  }

</style>


// WEBPACK FOOTER //
// src/components/Orcamentos/Orcamentos.vue